export default {
    websiteTitle: "Charging operation service platform",
    operatorId: "Operator code",
    oprName: "Name of operator",
    tips: "Tips",
    isUpdate: "Are You Sure You Want to Update",
    isDelete: "Are You Sure You Want to Delete",
    isOffline: "Are you sure you want to force offline?",
    deleteSuccess: "Successfully Deleted",
    updateSuccess: "Successfully Update",
    addSuccess: "Add Successfully",
    all: "All",
    operation: "Operation",
    dl: "quantity of electricity",
    eleFee: "Electricity",
    serverFee: "Service",
    delayFee: "Delay",
    totalAmount: "Total amount",
    yuan: "yuan",
    kWh: "kWh",
    unitOrder: "single",
    ac: "AC",
    dc: "DC",
    confirm: "confirm",
    noData: "No data",
    allCity: "All cities",
    chargingStation: "Charging station",
    merchant: "Merchant",
    operator: "Operator",
    chargingPile: "Charging pile",
    year: "Year",
    month: "Month",
    day: "Day",
    yesterday: "yesterday",
    today: "today",
    thisMonth: "This month",
    thisYear: "This year",
    allday: "all",
    timeType: "Time type",
    regularText: "Regular",
    irregular: "Irregular",
    agree: "Agree",
    refuse: "Refuse",
    operationSucess: "Operation successful",
    saveSucess: "Successfully Save",
    exportSuccess: "Import succeeded",
    isNullTime: "Time is not null",
    isStartAndEnd: "StartTime > EndTime",
    allSelect: "All Select",
    FormValidationError: "form validation error",
    multipleChoice: "Header Settings",
    exportEdit: "export edit",
    edit: "edit",
    loading: "loading...",
    browse: "browse",
    //单位
    unitText: {
        pen: "pen",
        yuan: "yuan",
        hours: "hours",
        people: "people",
        seat: "seat",
        wan: "w",
        Wyuan: "w yuan",
        WkWh: "w kWh",
        WkW: "w kW",
        year: "year",
        month: "month",
        day: "day",
        ton: "ton",
        second: "second",
        full: "full",
        reduce: "reduce",
        give: "give",
        zhang: "",
        individual: "indivual",
        xHours: "hours",
        minute: "minute",
        seconds: "second",
        noDiscount: "No discount",
        hold: "hold",
        set: "set",
        total: "total",
        days: "day",
    },
    formText: {
        startTime: "startTime",
        endTime: "endTime",
        startEndTime: "Time",
        export: "export",
        exportLoading: "loading...",
        exportNumber: "Number of exports",
        exportPl: "The number of exports cannot be less than or equal to 0",
        exportError: "Export error or timeout",
        allCity: "all city",
        selectGun: "Charging gun",
        selectMch: "Merchant",
        selectSite: "Charging station",
        selectPile: "Charging pile",
        selectTime: "Choose the time",
        selectTimePl: "Please select the time",
        selectOper: "Operators",
        downloadForm: "Download form",
        intTips: "number",
        beginTimeTips: "Please select start time",
        endTimeTips: "Please select end time",
        import: "Import",
        selectProvince: "Please select Province",
        selectCity: "Please select a city",
        selectArea: "Please select area",
        subSuccess: "Operation successful",
        goBack: "Go back",
        fileError: "Please upload the following file formats:",
        tipsMaxTime: "Start time cannot be greater than end time, please select again",
        fileSizeMax: "File size cannot be larger than ",
        imgUpload: "upload picture",
        numberError: "Please enter the correct quantity",
        exportOrderErrorMax: "Please select a span of one year to export orders",
        select: "select",
        upload: "Upload files",
        showAll: "Show All",
        showSelect: "Show Selected",
    },
    directCurrent: "DC",
    alternatingCurrent: "AC",
    onLine: "on line",
    offLine: "off line",
    gunStatus: "gun status",
    free: "free",
    connected: "connected",
    charging: "charging",
    full: "full",
    trouble: "trouble",
    disabled: "disabled",
    booked: "booked",
    //===========================按钮===========================
    query: "query",
    search: "search",
    update: "update",
    add: "add",
    delete: "delete",
    balanceReminder: "balanceReminder",
    siteOpen: "siteOpen",
    details: "details",
    recharge: "recharge",
    refund: "refund",
    rapitalRecords: "rapitalRecords",
    accountStatement: "accountStatement",
    pullSite: "pullSite",
    apply: "apply",
    cancellation: "cancellation",
    supplement: "supplement",
    batchDelete: "Batch Delete",
    cancel: "cancel",
    toExamine: "To examine",
    preservation: "Preservation",
    submit: "Submit",
    adopt: "Adopt",
    determine: "Determine",
    noAdopt: "No adopt",
    enable: "Enable",
    stop: "Stop",
    grant: "grant",
    export: "export",
    import: "import",
    relevance: "relevance",
    cancelRelevance: "cancel relevance",
    adjustIntegral: "adjust integral",
    levelIntegral: "level integral",
    member: "member",
    userGroup: "user group",
    operatingRecord: "operating record",
    activate: "activate",
    pass: "pass",
    notPass: "not pass",
    supplementOrder: "Supplement Order",
    invalid: "Invalid",
    withdrawalOfReview: "Withdrawal of review",
    regenerate: "Regenerate",
    preview: "Preview",
    readyToPay: "Ready to pay",
    reject: "Reject",
    paymentCompleted: "Payment completed",
    annex: "Annex",
    check: "check",
    uploadCertificate: "Upload certificate",
    close: "Close",
    save: "Save",
    invoicing: "Invoicing",
    outText: "Login expired, please login again",
    //===========================按钮===========================
    //短信服务
    msgServer: {
        startTime: "Start time",
        endTime: "End time",
        phone: "Phone",
        search: "Search",
        msgRecharge: "SMS number recharge",
        msgBuy: "SMS purchase",
        send: "Number of sent",
        msgSurplus: "Number of SMS remaining",
        msgStatus: "State",
        msgSendTime: "Sending time",
        msgMsgType: "SMS type",
        msgSendContent: "Send content",
        recharge: "SMS recharge",
    },
    //短信购买记录
    msgBuyRecord: {
        orderNumber: "Order Number",
        auditStatus: "Audit Status",
        startTime: "Start Time",
        endTime: "End Time",
        search: "Search",
        purchaseQuantity: "Purchase Quantity",
        paymentAmount: "Payment Amount",
        orderStatus: "Order Status",
        payTime: "Pay Time",
        enclosure: "Enclosure",
        delete: "Delete",
        totalNum: "Total purchase quantity",
        remainNum: "Remaining quantity",
        invoiceStatus: "Invoicing status",
        btnUploadContract: "Upload Contract",
        btnPay: "To pay",
        btnApplyInvoice: "Apply for invoice",
        smsRechargeTitle: "SMS recharge",
        smsRechargeBtnUpload: "Download contract template",
        smsRechargeBtnYes: "Existing contract",
        smsRechargeTips: 'SMS recharge requires uploading the purchase contract. Please download the contract template first, improve the contract information, and then proceed with the SMS recharge operation; If the purchase contract has been completed, please click on "I have a contract" to continue purchasing.',
        paymentWay: "Payment method",
        paymentWay2: "WeChat payment",
        paymentWay3: "Corporate transfer",
        paymentWayTips: "Note: Selecting WeChat payment submission cannot be changed after the payment order is generated!",
        payWx: "Use WeChat QR code scanning for payment",
        payWxTips: "After payment, please close it yourself. If the SMS has not been received,",
        payWxTips2: "Please contact the administrator",
        payWxMoney: "Payment amount:",
        payWxOrder: "Order generated",
        orderNo: "orderNo",
        payWxCopy: "copy",
        payWxMoneyInfo: "Offline remittance information",
        payMoney: "amount ",
        bankAccountName: "Bank account name",
        bankDeposit: "BANK",
        bankAccountNo: "Bank account",
        remark: "remark",
        payWxOrderTips: "This item is required. Click to copy the order number above",
        success: "Waiting for processing, completing the order",
        successTips: "After the remittance, please upload the transfer voucher in a timely manner, and we will handle it for you in a timely manner. If you have any questions, please contact the administrator",
        paymentNetFileUrl: "Payment voucher",
        paymentNetFileUrlPl: "Please upload payment voucher",
        paymentWayPl: "Please select payment method",
        upload: "Upload",
        auditNo: "Audit failed due to:",
        uploadSuccess: "Upload successful",
        uploadContract: "Upload Contract",
        contractNetFileUrl: "PURCHASE CONTRACT",
        contractNetFileUrlPl: "Please upload the purchase contract",
        comboPkId: "Purchase quantity",
        residue: "Remaining quantity",
        packageAmount: "Package amount",
        totalPay: "Total payable",
        submitOrder: "submit order",
        unit: "piece",
        purchasedWay: "purchase method",
        contractStatus: "contract status",
        paymentStatus: "payment status",
        paymentVoucherStatus: "Payment review status",
    },
    // 短信发票
    msgApplyInvoice: {
        hasDefault: "default",
        setHasDefault: "set as default",
        ent: "Enterprise unit",
        entNo: "Individual/Non Corporate",
        info: "Receiving information",
        sendEmail: "E-mail",
        phoneNo: "phone",
        addressee: "recipient",
        mailingAddress: "Shipping address",
        sublimt: "Submit application",
        addresseePl: "Please enter the recipient",
        mailingAddressPl: "Please enter the shipping address",
        invoiceTitleInfo: "Invoice header information",
        invoiceTitleType: "Invoice Type",
        invoiceTitle: "Title Name",
        taxId: "duty paragraph",
        registerTelephone: "Registration Phone",
        registerAddress: "Company Registered Address",
        hasDefaultSelect: "Default or not",
        invoiceAccount: "Invoicing amount",
        applyStatus: "Invoicing status",
    },
    //短信购买记录详情
    msgBuyRecordDetails: {
        pkid: "Order number",
        purchasedCount: "Purchase quantity",
        paymentAmount: "Payment amount",
        createTime: "Buying time",
        payTime: "time of payment",
        orderStatus: "Status",
        needContract: "Do you need a contract",
        contractNetFileUrl: "PURCHASE CONTRACT",
        paymentNetFileUrl: "Payment voucher",
        rechargeTime: "Recharge time",
        beforeSmsCount: "SMS before recharge",
        afterSmsCount: "SMS after recharge",
        yes: "yes",
        no: "no",
        cardRder: "Ordering Information",
        cardInvoice: "Invoice Information",
        cardAudit: "Audit records",
    },
    //互联互通
    interflowList: {
        systemnName: "Systemn Name",
        internetDirection: "Internet Direction",
        internetStatus: "Internet Status",
        internetStartTime: "Internet Start Time",
        internetEndTime: "Internet End Time",
        internetType: "Interconnection type",
        accountBalance: "Account Balance",
        status: "Status",
        open: "Enabled",
        close: "disabled",
        pullSuccess: "Pull successful",
        netPublic: "Interconnection and public type",
        hasOpen: "On state",
        oprSum: "Operator has been activated",
        netSystemSum: "Interconnection and interworking",
        netSystemSum2: "Interworking direction",
        netSystemSum3: "Interworking Public type",
        netSystemSum4: "On state",
        netForwardSum: "Forward direction",
        netReverseSum: "Opposite direction",
        netBidirectionalSum: "Two-way",
        netInsideSum: "Interior",
        netExternalSum: "Outside",
        netNoSum: "Open",
        netOffSum: "Close",
        netEndSum: "Ending Count",
    },
    //接口用户
    interfaceMember: {
        totalinterfaceMember: "Total Interface Member",
        totalsiteOpen: "Total Site Open",
        totalRechargeAmount: "Total Recharge Amount",
        totalChargeAmount: "Total Charge Amount",
        contacts: "Contacts",
        contactNumber: "Contact Number",
        interfaceName: "Interface Name",
        siteNumber: "Site Number",
        accountNumber: "Account Number",
        accountType: "Account Type",
        status: "Status",
        accountBalance: "Account Balance",
        unBind: "Please unbind the site first",
        delConfirm: "Are you sure you want to cancel",
        delSuccess: "Logout succeeded",
        globalSearch: "Contact person / contact information",
        netStatus3: "Logged off",
        netStatus2: "normal",
    },
    //结算订单补推
    orderSupplement: {
        government: "Government",
        personal: "Personal",
        externalOrderNumber: "External Order Number",
        internetOperators: "Internet Operators",
        chargingStation: "Charging Station",
        supplementaryResults: "Supplementary Results",
        supplementaryTimePeriod: "Supplementary Time Period",
        internalOrderNumber: "Internal Order Number",
        chargingStationName: "Charging Statio nName",
        startTime: "Start Time",
        endTime: "End Time",
        chargingTime: "Charging Time",
        chargeAmount: "Charge Amount",
        supplementaryTime: "Supplementary Time",
        updateTime: "Update Time",
        startSupplementaryResults: "Start Supplementary Results",
        endSupplementaryResults: "End Supplementary Results",
        settlementSupplementaryResults: "Settlement Supplementary Results",
        chargeTime: "Please select charging time",
        noOper: "No Internet operator",
        timeMaxError: "The selected time cannot exceed three months, please re select",
        noTableSelect: "Please select the data to be pushed",
        TableNoTypeSelect: "Please select the data supplement of the same operator",
        pullSuccess: "Push successful order",
        pullFail: "Push failed order",
        pullNo: "Undelivered order",
        pleasePull: "Please tick the type of supplementary push",
    },
    //第三方服务
    thirdPartyServices: {
        nameOfThirdPartyService: "Name Of Third Party Service",
        nameOfServiceProvider: "Name Of Service Provider",
        serviceProviderContent: "Service Provider Content",
        contacts: "Contacts",
        contactNumber: "Contact Number",
        startTime: "Start Time",
        endTime: "End Time",
        globalSearch: "Service Name/Service Provider Name",
    },
    //第三方服务订单
    thirdPlatformPushOrder: {
        orderNumber: "Order Number",
        nameOfThirdPartyService: "Name Of ThirdParty Service",
        chargingStation: "Charging Station",
        pushResults: "Push Results",
        supplementaryTimePeriod: "Supplementary Time Period",
        chargingStationName: "Charging Station Name",
        pushResultsDes: "Push Results Des",
        pushTime: "Push Time",
        selectData: "Please select the data you want to push",
        loading: "Please wait...",
        success: "Submitted successfully, waiting for the system to push",
        results: "Complementary results",
        failReason: "failure reason",
    },
    //===========================运营商===========================
    //运营商
    operInfo: {
        operatorInformation: "operatorInformation",
        basicInformation: "basicInformation",
        operator: "operator",
        operatorAbbreviation: "operatorAbbreviation",
        address: "address",
        companyDescription: "companyDescription",
        contact: "contact",
        mobile: "mobile",
        email: "email",
        registrationDate: "registrationDate",
        expirationDate: "expirationDate",
        mobileCustomization: "mobileCustomization",
        mobileCustomizationInfo: "set up customized messages on the Personal Mobile Device",
        systemMessage: "systemMessage",
        systemMessageInfo: "used for the configuration of cloud platform logo, platform name, webpage record display and other information",
        settlementConfiguration: "Invoice Settings",
        chargeServiceInfo: "Options for configuring user charging services, such as app activation and configuration",
        settlementConfigurationInfo: "used for carrier information management during settlement between carriers and merchants, such as payment company, settlement invoice settlement instructions, etc.",
        lastUpdateDate: "lastUpdateDate",
        passwordSetup: "passwordSetup",
        passwordSetupInfo: "used for the operation authority password of critical information of the system, such as entering the site online, offline, rate change, etc.The default is the 6 digits after the mobile phone is bound",
        chargingServiceconFiguration: "chargingServiceconFiguration",
        chargingServiceconFigurationInfo: "used for the configuration of user charging services, such as WeChat official account, opening and configuration of applets, and opening and configuration of Alipay applets, etc.",
        balanceReminder: "balanceReminder",
        balanceReminderInfo: "used for the configuration of the balance reminder function of an individual member account",
        city: "Please select a city",
        serviceTel: "Service Tel",
        verificationCode: "Verification Code",
        updateMobileSoc: "Modify mobile terminal customization",
        socStop: "SOC constant stop charging",
        socRadio: "If the setting is off, the mobile terminal will hide the SOC setting function, and the SOC function will be restored after it is turned on.",
        socDefault: "SOC default",
        socMinValue: "SOC lower limit:",
        socDefaultInfo: "Configure the default setting value of SOC of mobile terminal. Users can use this setting value to charge without setting SOC value. The default setting value is 98%. To prevent accidental overcharge, set the default value carefully.",
        scoTop: "The default value has reached 100%. When the actual charge exceeds 98%, only 5 minutes can be charged. Please set it carefully",
        socFooler: "The lower limit value set by SOC at mobile terminal is between 10% and 80% by default",
        exceptionType: "Exception handling type",
        exceptionPile: "Pile Report",
        exceptionPlatForm: "Platform report",
        delayRadio: "Delay fee",
        socTopDefalut: "Please enter the default value",
        socMax: "The default value cannot be more than 100",
        socIsnull: "The default value must be an integer greater than 0",
        socMin: "Please enter the lower limit value",
        socIsMax: "The lower limit cannot be more than 100",
        socIsNumber: "The lower bound value must be an integer greater than 0",
        limitStartAmount: "Minimum start up amount",
        frozenStartAmount: "Start charging frozen amount",
        isRefund: "Open refund",
        isRefundPl: "Please select whether to enable refund",
        prechargeRetired: "Charge and return immediately",
        isPrechargeRetired: "Please select whether to charge and return immediately",
        prechargeRetiredTips: "Use the recharged amount to charge. After charging, deduct the charge fee. The remaining amount will be returned to the customer's WeChat/Alipay or bank card.",
        refundText: "Refund instructions",
        refundTextPl: "Please enter a refund description",
        chargingMethod: "Charging method",
        chargingMethodPl: "Please select the charging method",
        hasOpenBalanceConsumption: "Balance charging",
        hasOpenBalanceConsumptionTips: "Use the customer's charging account balance for charging, deduct the charging fee after charging, and the remaining amount will be returned to the customer's charging account balance.",
        hasOpenCredit: "Charge first, pay later",
        hasOpenCreditTips: "To enable charge before pay, you need to configure the payment points of WeChat official account and WeChat applet respectively. After the configuration is completed, charge before pay will take effect. Otherwise, users will not be able to use this function on the corresponding platform.",
        hasOpenCreditGo: "Deconfigure",
        openText: "open",
        //系统设置
        weChatLogo: "WeChat official account logo",
        weChatMiniLogo: "Wechat applet logo",
        platFormLogo: "Platform logo",
        platFormName: "Platform name",
        logoPropaganda: "Landing page slogan",
        webFilingInfo: "Web filing information",
        //结算配置信息
        invoiceInfo: "Billing information",
        invoiceType: "Invoice type",
        electronicInvoice: "Electronic invoice",
        paperInvoice: "Paper invoice",
        enterpriseName: "corporate name",
        dutyParagraph: "duty paragraph",
        tariffRate: "Tariff rate",
        serviceRate: "Service charge tax rate",
        bankOfDeposit: "Bank of deposit",
        accountNumber: "account number",
        invoiceUnit: "Invoice unit",
        contacts: "contacts",
        contactNumber: "contact number",
        payee: "payee",
        drawer: "Drawer",
        reviewer: "Reviewer",
        receivingAddress: "Receiving address",
        otherInfo: "Other information",
        remark: "remarks",
        withdrawalInstructions: "Withdrawal description",
        mattersNeedingAttention: "matters needing attention",
        explainOne: "1. Different invoice types will affect the tax rate of opposite Invoicing, so the invoice type should be selected carefully.",
        explainTwo: "2. The company name will affect the payer of the withdrawal document and the company header of the invoice. Please modify it carefully.",
        explainThree: "3. Other information such as tax number, deposit bank and account number are required for invoicing.",
        explainForm: "4. Contact person, contact phone number and receiving address are optional. The default is the contact information when the operator is created",
        explainFive: "5. You can fill in the notes and withdrawal instructions according to the actual payment request. After modification, the corresponding information in the withdrawal form will be updated",
        invoiceStatus: "Invoice activation status",
        invoiceAudit: "Manual audit status",
        invoiceTypeName1: "Electronic invoice",
        invoiceTypeName2: "Paper invoice",
        openInvoiceYes: "Enabled",
        openInvoiceNo: "Not enabled",
        set: "set up",
        //密码修改
        newpassword: "New password",
        repeatpassword: "Repeat new password",
        //充电服务配置
        //微信公众号
        basicConfiguration: "Basic configuration",
        serviceEnable: "Service enable",
        wechatQrcode: "Official account two-dimensional code",
        wechatName: "Name of official account",
        originalId: "Original ID",
        appId: "appId",
        secret: "secret",
        weChatTemplate: "Notification template",
        chargingStartNotification: "Charging start notification",
        chargingEndNotification: "Charge end notification",
        chargingSettlementNotification: "Charging settlement notice",
        chargingFaultNotification: "Fault notification",
        amountNotification: "Insufficient balance reminder",
        wechatPayInfo: "Wechat payment information",
        merchantName: "Merchant name",
        merchantId: "Merchant ID",
        merchantKey: "Merchant key",
        merchantCert: "Apply for a refund certificate",
        //支付宝小程序
        miniProgramLogo: "Applet logo",
        miniProgramQrcode: "Applet QR code",
        miniProgramName: "Applet name",
        privateKey: "Apply private key",
        publicKey: "Alipay public key",
        //余额提醒
        individualMember: "individual member",
        electricCard: "Non real name electric card member",
        notes: "Note: after opening this function, the member will notify the other party by sending SMS or official account when the balance is lower than the specified amount. In order to prevent frequent notification from affecting the user, it is recommended to remind the amount to be set carefully.",
        openFunction: "Function opening",
        open: "open",
        close: "close",
        amountMin: "User charging, balance less than",
        amountInfo: "After yuan, send a notice.",
        notificationMethod: "Notification method",
        weChatNotification: "Official account notification",
        smsNotification: "SMS notification",
        weChatTemplateDetection: "Official account template detection",
        isTemplate: "Configured",
        notTemplate: "not configured",
        smstemplateDetecion: "SMS template detection",
        maxRiskAmountPerOrder: "Maximum risk deposit",
        maxRiskAmountPerOrderTips: "Reminder: The risk deposit is the maximum payment limit for a single user/single day/single order. It is recommended to set an amount of 200 yuan. If there are large service vehicles charging at the site, it is recommended to adjust the amount to 300-500 yuan.",
        blacklistUserTelphone: "Blacklist Contact Number",
        blacklistUserNotifyText: "Blacklist reminder text",
        blacklistUserNotifyTextPl: "Please enter blacklist reminder text",
        oprSystemName: "Operator System Name",
        oprSystemLogoFilePath: "System logo",
        addressPl: "Please enter the address",
        addressPlCity: "Please select a city",
        rolePkIdPl: "Please select a role",
        oprSystemLogoFilePathPl: "Please upload the operator system logo",
        hasOpenAutoRefund: "Refund automatic review",
        hasOpenAutoRefundPl: "Please select whether to automatically review refunds",
        contactServiceProvider: "Contact service provider",
        contactServiceProviderPl: "Used to view the contact information of service providers or provide feedback on issues to service providers",
        problemFeedback: "Problem feedback",
        problemType: "Problem type",
        operHasRead: "Has the service provider read it",
        operHasReply: "Does the service provider respond",
        addFeedback: "Add feedback",
        feedbackTime: "Feedback time",
        feedbackPerson: "Feedback person",
        problemContent: "Problem content",
        replyTime: "Reply time",
        addProblem: "New questions added",
        checkReply: "View replies",
        operReply: "Service Provider Response",
        replyContent: "Reply content",
        deleteFeedback: "Do you want to delete the feedback issue?",
        configInfo: "configuration information",
        chargingErrorRemind: "Abnormal charging reminder",
        chargingErrorRemindPl: "SMS reminder when the long-term charging amount of a single order is 0kWh",
        singleOrderChargeTime: "Continuous charging duration for a single order",
        singleOrderChargeTimePl: "Please enter the continuous charging duration for a single order",
        changeProblem: "Modify the issue",
        chooseProblemTypePl: "Please select the type of question",
        problemContentPl: "Please enter the question content",
        addFeedbackSuccess: "Successfully added feedback",
        inputEnterTip: "The set charging time must be an integer",
        inputEnterTip2: "The set charging time must be a positive number",
        inputEnterTip3: "The maximum charging time set is three digits",
    },
    //商户管理
    merchantManagement: {
        merchantId: "merchantId",
        merchantName: "merchantName",
        merchantIdOrName: "merchantId Or Name",
        merchantAbbreviation: "merchantAbbreviation",
        chargingStationNum: "chargingStationNum",
        contacts: "contacts",
        email: "email",
        contactNumber: "contactNumber",
        creationTime: "creationTime",
        mchStatus: "Merchant status",
        cooperationTime: "Cooperation deadline",
        closeMerchant: "Close",
        totalQuantity: "Total number of merchants",
        enableQuantity: "Merchant enabled",
        disableQuantity: "Merchant closed",
        days30Left: "Due 30 days",
        days60Left: "Due 60 days",
        days90Left: "Due 90 days",
        closeError: "Please turn off the charging station and go offline",
        invoiceStaCount: "Number of invoicing stations",
        log: "Operation Log",
    },
    // 商户日志
    mchLog: {
        globalSearch: "keywords",
        sharingRules: "Sharing rules",
        withdrawalRules: "Withdrawal rules",
        objectType: "OPERATE ON",
        operationContent: "Operation content",
        operationType: "Operation type",
        operationUserName: "operator",
        operationIp: "Operator IP",
    },
    //设备厂商信息
    producer: {
        manufacturerName: "Trade Names",
        BusinessLicenseNo: "Business license number",
        brandName: "brand name",
        equipmentManufacturer: "equipment manufacturer",
        equipmentManufacturerType: "Equipment manufacturer type",
        equipmentManufacturerLicenseNo: "Organization Code",
        contacts: "contacts",
        contactNumber: "phone",
        corporationLegalPerson: "Corporate",
        corporateIdentityCard: "Legal person ID",
        equipmentForm: "system",
        equipmentForm2: "This operator",
    },
    //设备型号
    equipmentModel: {
        equipmentType: "equipmentType",
        equipmentmodelManufacturerName: "equipmentmodel/ManufacturerName",
        equipmentModel: "equipmentModel",
        standardInformation: "standardInformation",
        matchingInformation: "matchingInformation",
        manufacturer: "manufacturer",
        updateTime: "updateTime",
        system: "system",
    },
    //===========================主页===========================
    home: {
        assetTitle: "Asset information",
        staCount: "Charging Stations Statistics (pc)",
        pileCount: "Charging Pile Statistics (pc)",
        gunCount: "Charging Gun Statistics (pc)",
        mapStaStutas: "Site status",
        mapAc: "AC",
        mapDc: "DC",
        map: "map",
        mapQuery: "Query",
        mapStaTel: "Site phone",
        gunStatus: "Charging gun status",
        assets: "Assets",
        mchStatistics: "Merchant statistics",
        staStatistics: "Site statistics",
        pileStatistics: "Pile statistics",
        gunStatistics: "Gun statistics",
        powerStatistics: "Total power statistics",
        rankingTitle: "Site",
        rankingTitle2: "ranking",
        rankingTitleDl: "Quantity of electricity",
        rankingTitleMoney: "Amount",
        cardTitleMoney: "Site Amount Ranking",
        cardTitleDl: "Ranking of Charging Capacity",
        rankingNo: "No ranking",
        total: "total",
        totalPower: "Total power",
        dl: "Electricity (kWh)",
        trans: "Paid-in (yuan)",
        charge: "Charging times (times)",
        useRate: "Utilization rate(％)",
        totalUser: "Cumulative users",
        avgChargeTimes: "Average number of charges",
        monthAvgUseRate: "Site usage rate this month",
        totalRegister: "New registration",
        totalCancellation: "log off",
        all: "all",
        today: "today",
        yesterday: "yesterday",
        chargeEcharTitle: "Charging and income",
        chargeEcharTypeDay: "(Nearly 30 days, excluding today)",
        chargeEcharTypeMonth: "(Last December)",
        chargeEcharTypeYear: "(Last 10 years)",
        gunTotal: "Total number of guns",
        dataStatistics: "Charging data statistics",
        dcPile: "DC",
        dcSplit: "Split DC",
        acPile: "Split AC",
        totalTitle: "Overview",
        detailsTitle: "Details",
    },
    // 主页地图
    homeMap: {
        search: "Search",
        reset: "Reset",
        area: "Area",
        power: "Power",
        quantity: "Quantity",
        tower: "Tower",
        merchant: "Merchant",
        deviceType: "Device Type",
        staSize: "Charging station scale",
        netDirection: "Interconnection",
        staStatus: "Operational status",
        staActivity: "Site Activity",
        normalSearch: "Normal Search",
        advancedSearch: "Advanced Search",
        ac: "AC pile",
        dc: "DC pile",
        smallSize: "small-scale",
        mediumSize: "Medium scale",
        largeSize: "large-scale",
        yes: "Yes",
        no: "No",
        site: "Site",
        pile: "Pile",
        screenPl: "Please enter the charging station and operator",
        screenResult: "Find relevant results for you about",
        moreSelect: "choice",
        more: "more",
    },
    //===========================主页 - 站下桩列表 ===========================
    homePile: {
        pileNumber: "Pile number",
        pileName: "Pile mane",
        power: "power(kW)",
        loading: "loading...",
        pileNo: "No pile",
    },
    //===========================主页 - 站下桩列表 - 详情 ===========================
    homePileDetails: {
        number: "Number",
        gun: "Gun",
        totalDl: "Cumulative charge(kWh)",
        totalCharge: "Cumulative charging times(second)",
        totalChargeTime: "The cumulative charging time is about",
        startTime: "StartTime",
        entTime: "EndTime",
        details: "Details",
        endOrder: "Close order",
        tableFullName: "Member name",
        tablePhoneNo: "Phone",
        tableOrderStatusDesc: "Order status",
        tableChargeBeginTime: "Start charging time",
        tableChargeEndTime: "End charging time",
        tableChargeElect: "Quantity of electricity",
        tableChargeMinutes: "Charging time",
        tableTotalAmount: "Total cost",
        timeMaxMin: "The start time cannot exceed the end time",
        timeNull: "Update time cannot be empty!",
        endOrderConfirm: "Are you sure you want to close the order?",
        endOrderSuccess: "Order closed successfully",
    },
    //===========================主页 - 大屏 ===========================
    homeData: {
        goSys: "Enter the system",
        operData: "Charging operation and maintenance platform",
        pageTitle: "Operational data",
        mapTypeSite: "Site map",
        mapTypeHeat: "Heat map",
        mapTypeDl: "Electricity and heat map",
        mapTypeMoney: "Revenue heat map",
        mapEnergy: "Energy accounting",
        coal: "coal",
        oil: "oil",
        co2: "co2",
        so2: "SO2",
        no2: "NOx",
        revenueRanking: "Revenue ranking",
        orderRanking: "Charging order ranking",
        dlRanking: "Charging power ranking",
        timeRanking: "Charging utility ratio ranking",
        effectiveTimeRanking: "Charging usage ratio ranking",
        userRanking: "Ranking of charging users",
        dataRanking: "Site ranking",
        totalOrder: "Charging order",
        totalMoney: "Charging revenue",
        totalDlMoney: "Electricity revenue",
        totalServerMoney: "Service fee revenue",
        totalChargingTime: "Charging time",
        totalDl: "Charging capacity",
        totalPower: "Total rated power",
        totalUser: "Total user",
        selectAll: "all",
        selectToday: "today",
        yesterday: "yesterday",
        selectMonth: "month",
        revenueLineTitle: "Charging revenue trend chart",
        revenuePieTitle: "Proportion of charging revenue",
        revenueTotalTitle: "Total cost",
        revenueUnit: "yuan",
        dlLineTitle: "Charging power trend",
        dlPieTitle: "Proportion of charging power",
        dlTotalTitle: "Total power",
        dlUnit: "kWh",
        orderLineTitle: "Charging order trend chart",
        orderPieTitle: "Proportion of Charging Orders",
        orderTotalTitle: "Total orders",
        orderUnit: "",
        gunStatusTitle: "Real time status of charging gun",
        userLineTitle: "Trend chart of charging users",
        useLineTitle: "Utilization and utilization trend chart",
        siteRanking: "Construction information",
        totalSiteNum: "Charging station",
        totalGunNum: "Charging gun",
        totalPowerNum: "Charging power",
        pileCount: "Charging pile",
        dcNum: "DC",
        dcGunNum: "DC gun",
        dcPower: "DC power",
        acNum: "AC",
        acGunNum: "AC gun",
        acPower: "AC power",
        bottomSite: "Charging stations",
        bottomGun: "Charging guns",
        bottomTotalPower: "Total rated power of charging pile",
        bottomDcPile: "DC piles",
        bottomDcGun: "DC gun",
        bottomDcPower: "DC total rated power",
        bottomAcPile: "AC piles",
        bottomAcGun: "AC gun",
        bottomAcPower: "AC total rated power",
        mapSelectText2: "Charging time",
        mapSelectText3: "Charging users",
        mapSelectText4: "Charging power",
        mapSelectText5: "Charging order",
        mapSelectText6: "Charging revenue",
        mapSelectText7: "Charging usage",
        mapSelectText8: "Charge utilization",
        echartRevenueDf: "electricity bill",
        echartRevenueServer: "service charge",
        echartRevenueDelayAmount: "Delay fee",
        echartDlSharp: "Sharp",
        echartDlPeak: "Peak",
        echartDlFlat: "Flat",
        echartDlValley: "Valley",
        echartUserOrder: "Ordinary user",
        echartUserOrderEnt: "Enterprise user",
        echartUserOrderNet: "Channel User",
        echartUseRatio: "Utilization rate(%)",
        echartUsageRate: "Usage rate(%)",
        chargeUser: "Number of charging users",
        activeUserNum: "Active times",
        dcPlotGun: "Split DC Gun",
        dcPlotPower: "Split DC Total Power",
        bottomPower: "Total construction power",
    },
    // 资金数据
    fullData: {
        allYear: "All years",
        yearTips: "*Clear the year condition to summarize all year data",
        month: "Month",
        day: "Day",
        statDate: "Statistics date",
        slefOrderCount: "Charging order quantity",
        slefChargeElect: "Charging capacity(kW)",
        slefChargeAmount: "Electricity charges receivable(yuan)",
        slefServiceAmount: "Service charge receivable(yuan)",
        slefDelayAmount: "Delay fee receivable(yuan)",
        slefTotalAmount: "Total amount receivable(yuan)",
        slefDiscountAmount: "Preferential amount(yuan)",
        slefTransactionAmount: "Total amount received(yuan)",
        agentAmount: "Amount of share income(yuan)",
        totalAmount: "Total revenue(yuan)",
        totalMoney: "Total revenue",
        moneyUnit: "income",
    },
    //运营数据
    operationData: {
        receivableAmount: "Amount receivable(yuan)",
        discountAmount: "Preferential amount(yuan)",
        totalMoney: "Amount actually received(yuan)",
        serverFee: "Service charge(yuan)",
        charge: "Charging times(second)",
        people: "Active population(people)",
        chargeTime: "Charging time",
        chargeDl: "Charging capacity(kWh)",
        data: "Data statistics",
        dlRanking: "Power ranking",
        noRanking: "No ranking",
        moneyRanking: "Amount ranking",
        tipsSite: "Please select charging station",
        tipsTime: "Please select the time",
        tipsMaxTime: "The start time cannot be greater than the end time, please select again",
        echart: "Chart",
        table: "Table",
        chargeTimes: "Charge times",
        balanceAmount: "Account Balance",
    },
    // 共用名称（订单列表也在里面）
    commonTableName: {
        insideOrderNo: "Internal order ",
        externalOrderNo: "External order",
        orderStatus: "Order status",
        orderType: "Order type",
        no: "no",
        yes: "yes",
        details: "details",
        endOrder: "Close order",
        error: "exception handling",
        orderNo: "order number",
        merchantName: "Merchant name",
        netSystemName: "Internet operators",
        staName: "Charging station",
        pileName: "Pile name",
        gunName: "Gun name",
        serialNumber: "Serial number",
        memberName: "Member name",
        phoneNo: "phone",
        carNo: "license plate",
        chargeBeginTime: "Start charging time",
        chargeEndTime: "End charging time",
        payTime: "Payment time",
        chargeDuration: "Charging time",
        delayDuration: "Time of pile occupation",
        chargeElect: "Quantity of electricity(kWh)",
        chargeAmount: "electricity fees(yuan)",
        serviceAmount: "Service fees",
        delayAmount: "Delay fee",
        totalAmount: "Total amount(yuan)",
        discountAmount: "Total discount amount",
        transactionAmount: "transaction Amount",
        startSoc: "start soc",
        endSoc: "end soc",
        stopReason: "stop reasonDesc",
        orderSource: "Order source",
        abnormalType: "abnormal type",
        elecPrice: "Electricity rete(yuan/kWh)",
        servicePrice: "Servic rate(yuan/kWh)",
        slotFlag: "Electricity fee type",
        slotElecPrice: "Electricity price(yuan)",
        time: "Time",
        delayMins: "Time(minute)",
        delayFreeMins: "Free time(minute)",
        delayFree: "Free time",
        sex: "Sex",
        vipLevel: "Member level",
        vipType: "Member type",
        vin: "VIN",
        cardType: "Car model",
        staType: "Site type",
        staStatus: "Site status",
        staAddr: "Site address",
        gunPkId: "gun id",
        manufacturer: "Belong to manufacturer",
        deviceType: "Pile type",
        devicemodel: "Equipment model",
        ratedPower: "Rated power",
        ratedCurrent: "Rated current",
        ratedVoltage: "Rated voltage",
        timeInterval: "time interval",
        chargeDiscount: "Electricity discount",
        serviceDiscount: "Dervice discount",
        delayDiscount: "Delay discount",
        totalDiscount: "Total discount amount",
        chargeTransAmount: "Paid in tariff",
        serviceTransAmount: "Paid in service fee",
        jian: "sharp",
        feng: "peak",
        ping: "flat",
        gu: "valley",
        beforeBalance: "Amount before(yuan)",
        afterBalance: "Amount after(yuan)",
        reteInfo: "Rate information",
        charge: "Charging times(second)",
        startTime: "Start time",
        endTime: "End time",
        modifyTime: "Modify time",
        staPkId: "Site number",
        entUserName: "Member companies",
        chargingCard: "User card number",
        consumptionPattern: "Charging mode",
        chargingMode: "charging mode",
        userType: "user type",
        startMode: "start mode",
        manufactureDate: "date of manufacture",
    },
    commonDetails: {
        delayMins: "Time",
        delayFreeMins: "Free time",
        delayAmount: "Delay fee",
        lastBillingNode: "Last billing node",
        charge: "Electricity level(kW·h)",
        serviceFee: "Service fee (yuan)",
        totalAmount: "Total consumption amount (yuan)",
    },
    // 订单列表页面
    orderList: {
        end: "Charge is over",
        endConfirm: "Are you sure you want to close the order?",
        endLoadingTips: "Issue stop charging command",
        endLoadingTips2: 'The system will issue the stop charge command to the charging pile. If the order status cannot be changed to "charging completed" within 15s, the second step operation will continue',
        endLoadingTips3: "Generate platform Charging Report",
        endLoadingTips4: 'The system will push the platform charging report to the charging pile. If the order status cannot be changed to "charging completed" within 15s, the third step will continue',
        endLoadingTips5: "Modify order status to abnormal order",
        endLoadingTips6: "The system will modify this order as an abnormal order, and the user can normally perform the next charging operation",
        endLoading: "In process..",
        endCharge: "End charging",
        loadingSuccess: "The stop command is issued successfully",
        success: "Platform report generated successfully",
        orderError: "Order status changed to exception",
        endSuccess: "End success",
        pageTitle: "Charging order",
        exportType: "default",
        exportType2: "details",
        totalChargeElect: "Total charge(kWh)",
        totalTransactionAmount: "Total Actual Revenue",
        totalServiceAmount: "Service charge",
        totalChargeAmount: "Electricity fees",
        totalDelayAmount: "Delay fee",
        totalDiscount: "Total amount discount",
        totalServiceDiscount: "Service fee discount",
        totalChargeDiscount: "Electricity discount",
        formType1: "General search",
        formType2: "Precise search",
        balanceRecharge: "Balance charge",
        prechargeRetired: "Pre charge",
        postPaidcharge: "Charge first, pay later",
    },
    // 订单异常结算页面
    abnormalOrder: {
        pileCharging: "Total billing amount for piles",
        chargeTime: "Charging period",
        stopReason: "Stop reason",
        pileChargeAmount: "Total charge charge (yuan)",
        sysCharging: "Total platform billing amount",
        sysChargeAmount: "Total platform charging fee (yuan)",
        pileErrorValue: "Error between pile and pile:",
        normalErrorValue: "Normal error: the difference is less than 0.5 yuan or the difference proportion is less than 20%",
        usePileCharging: "Charge by using pile",
        useSysCharging: "Charging by using platform",
        countType: "Calculation formula: total pile charging fee / total platform charging fee + total delay fee",
        payAmount: "Total payment",
    },
    //订单详情
    orderDetails: {
        aorderDetailsTitle: "Charging order details",
        userSiteTabTitle: "User and site information",
        chargeType: "Charging type",
        chargeStatus: "Charging state",
        chargingModel: "Charging strategy",
        chargeElect: "Charging capacity",
        chargeDuration: "Charging time",
        orderCheckDetails: "Order verification details",
        chargeDataEchart: "Charging data",
        chargeMoneyEchart: "Charging charge data curve",
        batteryEchart: "Battery information curve",
        pileSignal: "Pile signal",
        faultCode: "Exception code",
        faultName: "Exception name",
        faultDesc: "Exception description",
        userInfo: "User info",
        siteInfo: "Site information",
        siteId: "Site id",
        pileInfo: "Pile information",
        rateInfo: "Fee information",
        errorHandle: "exception handling",
        billingMethod: "Billing method",
        operationTime: "Operation time",
        operationoOject: "Operation object",
        pileCreationTime: "Equipment commissioning time",
        chargeFeeYLeftName: "Cost (yuan)",
        chargeFeeYRightName: "Electricity(kW/h)",
        chargeTemperatureYLeftName: "temperature",
        chargeTemperatureYRightName: "voltage",
        insertGun: "Insert a gun",
        startCharging: "Start charging",
        endCharging: "End charging",
        draw: "Draw",
        outputVoltage: "output voltage",
        chargingPower: "charging power",
        outputCurrent: "output current",
        demandVoltage: "demand voltage",
        demandCurrent: "demand current",
        cpVoltage: "CP voltage",
        chargerTemperature: "charger temperature",
        gunTemperature: "gun temperature",
        brmProtocol: "BRM protocol version",
        brmBatteryType: "BRM battery type",
        brmBatteryCapacity: "BRM battery rated capacity",
        brmRatedVoltage: "BRM rated total voltage",
        BCPMaxVoltage: "Maximum voltage of BCP unit",
        BCPMaxCurrent: "BCP maximum current",
        BCPBatteryEnergy: "Total energy of BCP battery",
        BCPMacVoltage: "BCP maximum charging voltage",
        BCPMaxTemperature: "BCP maximum temperature",
        BCPStartSOC: "BCP starts SOC",
        BSMMaxTemperature: "BSM maximum power battery temperature",
        BCSMaxBatteryVoltage: "BCS maximum cell voltage",
        // 结算信息
        settlementTableName: "project",
        settlementTablePayableAmount: "Payable (yuan)",
        settlementTableDiscountAmount: "Discount (yuan)",
        settlementTabletransAmount: "Actual payment (yuan)",
        settlementTabletransDl: "electric charge",
        settlementTabletransServer: "service charge",
        settlementTabletransDelay: "delay charge",
        retaInfoTab1: "Settlement information",
        retaInfoTab2: "Charging charge information",
        retaInfoTab3: "Delay fee information",
        retaInfoTab4: "VIP/coupon information",
        total: "total",
        vipDiscount: "VIP discount",
        couponDiscount: "Coupon discount",
        serviceAmount: "Service fee payable",
        serviceDiscount: "Preferential service fee",
        vipDiscountAmount: "VIP discount",
        couponDiscountAmount: "coupon",
        serviceTransAmount: "Paid service fee",
        chargeAmount: "Electricity charges payable",
        chargeDiscount: "Preferential electricity charge",
        chargeTransAmount: "Paid electricity charge",
        delayAmount: "Delay fee payable",
        delayDiscount: "Discount for delay fee",
        delayTransAmount: "Paid delay fee",
        totalAmount: "Total",
        totalDiscount: "Total amount discount",
        transactionAmount: "Total paid",
        discountTotal: "Total discount",
        discountName1: "Event",
        discountName2: "Enterprise preference",
        discountName3: "Interface user preference",
        discountName4: "Interconnection",
        discountName5: "Non real name card",
        typeName1: "Activity",
        typeName2: "enterprise",
        typeName3: "interconnection",
        typeName4: "interface user cost",
        typeName5: "Non real name card",
        //费率表格
        dlInfo: "Electricity information",
        slotFlagDesc: "Type of electricity",
        time: "Power use period",
        electricity: "Electricity（kWh）",
        standardExpenses: "Standard expenses",
        slotServicePrice: "Service rate(yuan/kWh)",
        slotElecPrice: "Electricity rate(yuan/kWh)",
        discountServiceAmount: "Service fee discount(yuan)",
        discountElectAmount: "Electricity discount(yuan)",
        cost: "Activity/enterprise/interconnection/interface user cost",
        delayCost: "enterprise/interconnection/interface user cost",
        delayInfo: "Delay information",
        minutesOhter: "Delay duration (min)",
        slotDelayPrice: "Rate (yuan/minute)",
        delayFee: "Delay fee payable(yuan/minute)",
        // slotDelayPriceOhter: "Delay fee rate（yuan/minute）",
        // totalAmountOhter: "Delay fee payable(yuan)",
        discountAmountOhter: "Discount for delay fee(yuan)",
        discountType: "Discount type",
        vipTotalDiscount: "Total discount",
        discount: "discount",
    },
    errorOrder: {
        abnormal: "Exception Name",
        faultDesc: "Exception description",
        stopReason: "Reason for stopping",
        totalAbnormalChargeOrder: "Abnormal orders",
        processedQuantity: "Processed",
        unProcessedQuantity: "Untreated",
        orderType: "Order type",
        handleFlag: "Billing method",
        pileBilling: "Pile billing",
        platformFlag: "Platform billing",
        errorDetails: "Exception details",
    },
    // 离线卡订单
    offCardOrder: {
        cardPhysicalSn: "Serial number",
        cardSn: "Physical card number",
        chargeMode: "Charging mode",
        dealType: "Order status",
        exportName: "Offline card order",
        dl: "Charging capacity(kWh)",
        amount: "Income amount(yuan)",
        service: "Service charge(yuan)",
        chargingTime: "Charging time",
        orderNumber: "Order quantity(pen)",
        offCardNum: "Number of offline cards",
        chargingType: "Charging mode",
        chargingEndTime: "Charging end time",
    },
    // 离线卡详情
    offCardOrderDetails: {
        pageTitle: "Charging order details",
    },
    //用户分析
    userAnalysis: {
        tab1: "User growth",
        tab2: "user attribute",
        tab3: "User ranking",
        tab4: "User behavior",
        userStatus: "User status",
        targetDate: "Target date",
        comparisonDate: "Comparison date",
        addUser: "New users",
        activeUser: "Active users",
        cumulativeUser: "Cumulative users",
        selectTimeTips: "The time span cannot exceed two months",
        target: "Target",
        comparison: "Comparison",
        analyzeTrends: "Analyze trends",
        timeComparison: "Time comparison",
        time: "Time",
        addUserRetention: "Retention rate of new users",
        activeUserRetention: "Active user retention rate",
        cumulativeUserRetention: "Cumulative user month on month",
        analysisIndex: "Analysis index",
        dataTime: "Data time",
        firstOrderRate: "First order rate",
        addProportion: "Month on month growth",
        cumulative: "Cumulative",
        firstUserRatio: "First user ratio",
        ratioOfRetainedUsers: "Ratio of retained users",
        yesterday: "Yesterday",
        lastDays7: "Last 7 days",
        lastDays15: "Last 15 days",
        lastDays30: "Last 30 days",
        provinceAscription: "Provincial ownership",
        loading: "Loading",
        province: "Province",
        people: "People",
        proportion: "Proportion",
        strategyAnalysis: "Charging strategy analysis",
        startAnalysis: "Analysis of startup mode",
        timeAnalysis: "Single charge duration distribution",
        firstOrderUser: "First order user",
        top100: "Top100",
        top200: "Top200",
        custom: "Custom",
        accountType: "Account type",
        userRanking: "User ranking",
        ranking: "Ranking",
        avgTransactionAmount: "Average order amount(yuan)",
        cycleActivityRate: "Cycle activity rate",
        inputTips: "Please enter the correct value",
        mapNoData: "No map information for this area",
    },
    // 优惠券
    coupon: {
        addCoupon: "Add coupons",
        couponNamePl: "Coupon name",
        discountType: "Discount type",
        couponType: "Coupon type",
        couponTitle: "Coupon name",
        relevancingAmount: "Associating activities",
        usingCouponAmount: "Generated quantity",
        sendCouponAmount: "Issued quantity",
        createUserName: "Founder",
        createTime: "Creation time",
        applyStatus: "Audit status",
        grant: "Grant",
        pushConfiguration: "Push configuration",
        pushStatus: "Push status",
        updateSuccess: "Update successful",
        tamplateDetection: "Template detection",
        hasAllocation: "Configured",
        notAllocation: "not configured",
        pushConfigTip: "Unable to enable coupon push function without configuring template",
    },
    // 新增优惠券
    addCoupn: {
        couponCategory1: "Event coupon",
        couponCategory2: "Free coupon",
        couponTypeTips: "Note: The activity coupon needs to be associated with the preferential activity, while the complimentary coupon does not need to be associated with the preferential activity, and it will be directly distributed to the designated user account after creation.",
        costType: "Applicable charges",
        useCondition: "Conditions of use",
        orderUse: "A single order can be used",
        addRow: "Add a line",
        termOfValidity: "Term of validity",
        fixedTime: "Fixed time",
        afterCollection: "After collection",
        dayEffective: "valid within days",
        thirdServices: "Related third party services",
        issuedQuantity: "Issued quantity",
        instructionsTitle: "Instructions",
        instructionsTips: "The instructions will be displayed on the coupon. Please pay attention to the wording",
        applyStatus: "Audit status",
        auditorName: "Reviewer",
        auditTime: "Audit time",
        reasons: "Remarks",
        inputDayTips: "Please enter the number of days",
        inputDayMax: "Quantity cannot be more than 1000, please re-enter",
        inputDayError: "Please enter the correct number of days, no decimal",
        inputTimeNo: "Please select a fixed time",
        inputTimeNo2: "The start time cannot be the same as the end time",
        inputReasons: "Please enter the reason for not passing",
        selectCoupn: "Please select coupon type",
        dayNumber: "Days",
        number: "quantity",
        selectCostTypeTips: "Please select the applicable charge",
        inputInstructionsNoTips: "Please enter the instruction",
        selectTermOfValidity: "Please select validity period",
        selectThirdServices: "Please select associated third party service",
        subSuccess: "Operation successful",
        auditSuccess: "Audit successful",
        addCoupn: "New coupons",
        updataCoupn: "Modify coupons",
        detailsCoupn: "Coupon details",
        auditCoupn: "Coupon audit",
        discount: "Discount ratio",
        remarks: "remarks",
        couponInfo: "Coupon Information",
        discountName: "discount",
        auditTitle: "Review comments",
        remarksTips: "Reason description, passed as non mandatory",
        grantTitle: "Distribution settings",
        auditInfoTitle: "Audit Information",
    },
    // 优惠活动
    memberCoupon: {
        addActivity: "Add activity",
        namePl: "Fuzzy retrieval of activity name",
        status: "Active state",
        campaignType: "Activity type",
        applyStatus: "Audit status",
        usageStatus: "Usage status",
        waitAudit: "To be reviewed",
        passed: "Passed",
        rejected: "Rejected",
        title: "Activity title",
        userCouponAmount: "Quantity used",
        sendCouponAmount: "Issued quantity",
        marginAmount: "Allowance / total quantity",
        createUserName: "Founder",
        createTime: "Creation time",
        confrimStart: "Are you sure you want to enable it",
        confrimStop: "Are you sure you want to disable",
        startSuccess: "Enabled successfully",
        stopSuccess: "Disabled successfully",
        auditUserName: "Auditor",
        titleActivity: "Activities",
        titleAudit: "Audit Information",
    },
    // 新增优惠活动
    addMemberCoupon: {
        couponAmounts: "Coupon template",
        chargeMoney: "Single recharge amount ≥",
        charge: "Single charging degree ≥",
        selectTmp: "Select template",
        noCoupon: "No coupons available",
        sending: "Sending",
        addCondition: "Add condition",
        noGrantMore: "Non superimposed distribution",
        noGrantMoreTips: "No superimposed distribution: the system only issues the most qualified coupon template",
        crantMore: "Superimposed distribution",
        crantMoreTips: "Superimposed distribution: the system will superimpose all qualified coupon templates and distribute them all.",
        userMaxSecond: "Collection times of single user",
        infinite: "Infinite times",
        limited: "Finite times",
        thirdCouponAmounts: "Third party coupon template",
        addTmp: "Select template",
        elePriceMethod: "Preferential way of electricity price",
        dcElePrice: "DC pile price",
        acElePrice: "AC pile price",
        serverPriceMethod: "Service fee discount",
        dcServerFee: "DC pile service fee",
        acServerFee: "Service charge of AC pile",
        ruleSet: "Rule setting",
        EveryInvitation: "Number of people invited",
        everyInvitation: "Every invitation",
        cumulativeInvitation: "Cumulative invitation",
        addInviteesCondition: "Add number of invitees condition",
        giftOptions: "Gift options",
        addUserRegister: "New user registered successfully",
        addUserRegisterTips: "New users charge up to x degrees within X days after registration",
        givePeople: "Present invitees",
        newUserAfter: "After new user registration",
        dayCharge: "Charge up to",
        channel: "Applicable channel",
        partakeSite: "Participating in price adjustment site",
        couponRange: "Scope of use of coupons",
        unlimited: "unlimited",
        designatedCity: "Designated city",
        designatedSite: "Designated site",
        autarky: "Autarky",
        noAutarky: "No Autarky",
        totalCoupons: "Total coupons",
        useCollectTimesStatusTips: "Please select the number of times to collect for a single user",
        useCollectTimesStatusTips2: "Please enter the number of times",
        useCollectTimesStatusTips3: "The number of times cannot be greater than 1000",
        useCollectTimesStatusTips4: "Please enter the correct number of times",
        scopeTypeTips: "Please select the coupon scope",
        scopeTypeTips2: "Please select a city",
        scopeTypeTips3: "Please select a site",
        totalNumberTips: "Sending times",
        moneyTips: "numerical value",
        campaignTypeTips: "Please select activity type",
        campaignClientTips: "Please select the appropriate channel",
        elecFeeTypeTips: "Please choose the preferential way of electricity charge",
        serviceFeeTypeTips: "Please choose the service fee discount method",
        couponAmountsTips: "Please select a coupon template",
        beginTimeTips: "Please select start time",
        endTimeTips: "Please select the end time",
        remarkTips: "Please enter the instruction",
        tipsMaxTime: "The start time cannot be greater than the end time, please select again",
        subSuccess: "Operation successful",
        auditSuccess: "Audit successful",
        titleAdd: "Add marketing campaign",
        titleUpdata: "Modify marketing campaign",
        titleDetails: "Marketing campaign details",
        titleAudit: "Marketing activity audit",
        overlayDiscount: "Overlay discount",
        overlayDiscountTips: "Stacked discounts refer to multiple discounts that can be stacked and calculated.",
        overlayDiscountTips2: "The event price adjustment discount can be combined with one or both of the VIP member discounts and coupon discounts. If not selected, the discount will only execute the event price adjustment and will not be combined with the discount.",
        registrationTips: "The number of free gifts represents the total number of free gifts in this template. For example, if you enter 10, the first 10 newly registered users will get this coupon, and those registered later will not be distributed.",
    },
    // 发放优惠券
    memberCouponGrant: {
        couponEnd: "run out",
        allowance: "allowance",
        surplus: "Remaining sending times",
        surplusTips: "Each designated user is recorded as a number of times of distribution",
        targetUsers: "Receiving target user",
        targetUsersTips1: "Input the user's mobile phone number manually",
        targetUsersTips2: "Batch import of mobile phone numbers",
        targetUsersTips3: "nothing",
        targetUsersTips4: "Multiple inputs need to be separated by ','. Manual input can support up to 1000 numbers. It is recommended to submit large quantities of numbers in the form of file import",
        uploadFile: "Select file",
        uploadFileType: "Please upload XLS, xlsx format, number file",
        uploadFileExamples: "Sample view",
        uploadFileTips: 'Excel cell format must use "normal" format, the file size can not exceed 3M, it is recommended to import a single time',
        targetUsersNull: "Please select the receiving target user",
        phoneNull: "Please enter the user's mobile phone number",
        exportPhoneNull: "Please import user mobile number",
        No: "No",
        NoTips: "The number of users specified in the coupon template has exceeded the remaining times of issuing, please delete the specified user",
        minTmpTips: "Please issue at least one coupon template",
        grantTitle: "Coupon issuance",
        grant: "grant",
        perPerson: "per,Person",
        total: "zhange，total",
        totalGrant: "Total coupons issued",
        grantSuccess: "Successful distribution",
        issuingType: "Issuing time",
        targetUsers1: "All users",
        targetUsers2: "Specify User",
        issuingType1: "Immediate release",
        issuingType2: "Issued at specified time",
    },
    // 用户优惠券
    userCoupon: {
        hasUsed: "Coupon usage status",
        notUsed: "Not used",
        used: "Used",
        campaignTitle: "Activity name",
        staName: "Using the charging station",
        pileName: "Using charging point",
        orderNo: "Use order",
        releaseTime: "Collection time",
        endTime: "Expiration time",
        useTime: "Usage time",
        state: "state",
        platformId: "Platform ID",
        platformName: "Platform name",
        couponPkId: "Coupon number",
        userName: "User nickname",
        couponType: "Coupon type",
        couponTitle: "Coupon title",
        tab1: "User coupons",
        tab2: "Third party coupons",
    },
    //系统公告
    systemNotice: {
        addNotice: "Add announcement",
        noticeState: "Announcement status",
        noticeType: "Message type",
        title: "title",
        content: "content",
        picturesParam: "pictures",
        validTime: "entry-into-force time",
    },
    //新增系统公告
    addSystemNotice: {
        pageTitle: "Add system announcement",
        expireTime: "Failure time",
        noticeType1: "Select system style",
        noticeType2: "Custom picture",
        staPkId: "Sending site",
        viewShow: "Style Preview",
        upload: "Upload pictures",
        activity: "Related activities",
        contentTips: "Please input the content",
        validTimeTips: "Please select effective time",
        expireTimeTips: "Please select the expiration time",
        noticeTypeTips: "Please select message type",
        staPkIdTips: "Please select the sending site",
        picturesParamTips: "Please upload the picture",
        maxTime: "The expiration time cannot be greater than the effective time",
        subSuccess: "Submitted successfully",
        imgTips: "Image size is: 750*150",
    },
    // 会员消息
    customerService: {
        key: "nickname/phone",
        createUserName: "Member nickname",
        processed: "Replied",
        unprocessed: "Unanswered",
        reply: "Reply",
        sources: "Sources",
        weChat: "WeChat",
        applets: "Applets",
        contactPhone: "Phone",
        sourceType: "Message type",
        content: "Content",
        picturesParam: "Pictures",
        createTime: "Time of issue",
        processingStatus: "Processing status",
        processingResult: "Processing content",
        modifyTime: "Processing time",
        replyMsg: "Reply to message",
        contentPl: "Please enter a reply",
        feedBackType: "Feedback type",
        user: "User",
        system: "Platform",
        time: "Time",
        account: "operating account",
        role: "Role",
    },
    // 用户指南
    userGuide: {
        addArticle: "Add article",
        catalogue: "Catalogue manage",
        addCatalogue: "Add catalogue",
        menuTitle: "catalogue",
        title: "title",
        requestUrl: "Link address",
        confirmDel: "Are you sure you want to delete",
        delSuccess: "Successfully deleted",
    },
    // 新增文章
    addArticle: {
        titleTips: "Please enter the title",
        requestUrlTips: "Please enter the link address",
        subSuccess: "Operation successful",
    },
    // 会员等级管理
    memberGrade: {
        switch: "Enable Status",
        tab1: "Level management",
        tab2: "Level Purchase History",
        discountType: "Discount type",
        discountRatio: "Discount ratio",
        saleStatus: "Sale status",
        endPurchase: "Termination of purchase",
        allowPurchase: "Allow purchase",
        enablea: "Enable",
        disable: "Disable",
        confirmEnablea: "Are you sure you want to enable it?",
        confirmDisable: "Are you sure you want to disable?",
        confirmDel: "Are you sure you want to delete?",
        delSuccess: "Successfully deleted",
        successTips: "Change succeeded",
        salesRevenue: "Income from selling members (yuan)",
        purchaseRatio: "Grade purchase ratio",
        purchaseTimeRatio: "Purchase duration ratio",
        purchaseMethod: "Purchase method",
        gradeType: "Grade type",
        vipDaysDesc: "Length of purchase",
        purchaseType: "Purchase type",
        purchaseTime: "Purchase time",
        gradePurchaseRecord: "Grade purchase record",
        transactionPoints: "Pay points",
        transactionTime: "Consumption points",
        vipEndTime: "Due date",
        transactionAmount: "Payment amount (yuan)",
    },
    // 会员等级管理添加
    addMemberGrade: {
        vipLevel: "Grade name",
        vipLevelPl: "Please select a level",
        vipLevelRule: "Please select membership level",
        priceTitle: "Member price",
        pricePl: "Numbers 1-10",
        points: "Points",
        discountAmountTypeRule: "Please select discount type",
        maxNumber: "Membership",
        statusRule: "Please select selling status",
        daysDesc: "Purchase days",
        price: "Price (yuan)",
        firstDiscountRatio: "First purchase discount",
        pointsPrice: "Points exchange price",
        dayPrice: "day price",
        dayPointsPrice: "day points exchange price",
        firstDiscountRatioTips: "The first purchase discount should be 1",
        please: "Please input",
        maxNum: "No more than 99999",
        subSuccess: "Submitted successfully",
        noLimit: "No upper limit",
        discount: "Discount",
        customDays: "custom",
    },
    // 积分活动
    integralActivity: {
        tabTitle1: "Charging points activity",
        tabTitle2: "Point sign in activity",
        tabTitle3: "Points exchange record",
        tabTitle4: "Points growth record",
        activityName: "Activity name",
        allType: "All mode",
        payTime: "Payment time",
        integralActivity: "Integral activity",
        integralSet: "Integral setting",
        mei: "",
        consume: "consume",
        kwhExchange: "kilowatt hour for",
        points: "points",
        pay: "Pay",
        yuanExchange: "yuan for",
        cmpnName: "Name of integral activity",
        chargePointWayDesc: "Acquisition method",
        chargePointRuleDesc: "Access method content",
        campaignState: "Activity Status",
        searchPl: "Order number/member name/mobile number/points activity",
        integralAddRecord: "Points growth record",
        transactionPoints: "Integral value",
        totalPoints: "Summary of generated points",
        pointsTop5: "Top 5 points activities",
        userPointAlarmDays: "Valid period of points",
        updataTime: "Point update time",
        updataTimeTips: "Reminder of validity of points",
        countDown: "Count down",
        updataTimePl: "Please select the point update time",
        userPointAlarmDaysPl: "Please select the valid period of points",
        subSuccess: "Operation successful",
        totalPointsRedeemed: "Total points redeemed",
        residualTotalIntegral: "Residual total integral",
        exchangeTop5: "Top 5 exchange volume",
        orderNo: "Exchange order",
        vipName: "Exchange items",
        exchangePoints: "Exchange points",
        afterPoints: "Residual integral",
        transactionMethodDesc: "Mode of change",
        createTime: "Exchange time",
        integralSwitch: "Integral function switch",
        campaignTotalPoints: "Generate integral",
        integralActivityInfo: "Points activity information",
        configInfo: "configuration information",
    },
    // 新增积分活动
    addIntegralActivity: {
        // checkInPlan: "Check in plan",
        // firstCheck: "First sign in rule",
        // firstCheckGet: "First sign in",
        // noIntegral: "No integral",
        // continuityCheckRule: "Continuous check in rule",
        // continuityCheckRuleTips:
        //   "After the user gets the continuous sign in reward, the continuous sign in days will be recalculated, and the user will get the continuous sign in reward again when the next continuous sign in days are met",
        // continuityCheckFul: "Continuous attendance",
        // continuityCheckFul2: "day, get it",
        // continuityCheckRuleTips2:
        //   "The score value obtained from the continuous check-in days is in a ladder shape. After the user obtains the first level reward, the check-in days will be included in the second level until the continuous check-in days of the next level are met",
        // add: "Add ladder",
        checkRule: "Check in rules",
        activityRules: "Activity rules",
        activityRulesPl: "Please describe the rules of this integral activity",
        chargePointWayRule: "Please choose the integral method",
        payTimeRule: "Please choose the payment method",
        firstCheckIntegral: "First sign in bonus points",
        checkRulePl: "Please select the check-in rule",
        continuityCheckDay: "Continuous check in days",
        remarksRule: "Please enter the activity description",
        integralRule: "Sign in rules for points",
        integralRule1: "1. 1 point for the first day of continuous check-in, 2 points for the second day, and so on, 7 points for the seventh day.",
        integralRule2: "2. Sign in for more than 7 consecutive days, and the score is consistent with that of the seventh day",
        integralRule3: "3. If the sign in is interrupted midway, it will be calculated from the first day.",
        add: "Add check-in activity",
        updata: "Modify check-in activity",
    },
    // 积分增长记录详情
    integralAddRecordDetails: {
        type: "type",
        time: "time",
        createTime: "Check in time",
    },
    //站点信息
    pileInfo: {
        addSite: "Add site",
        operationType: "Operation type",
        staStatus: "Operation status",
        applyStatus: "Audit status",
        updataSite: "Edit site",
        subAudit: "Submit for approval",
        eleList: "Electricity price list",
        pileList: "Pile list",
        closeSite: "Close site",
        audit: "Approval",
        chargeStrategy: "Charging strategy",
        siteDebug: "debugging",
        underRepair: "Under repair",
        normalUse: "Normal use",
        outSite: "Move out site",
        exportTips: "The number of exports cannot be less than or equal to 0",
        closeSiteSuccess: "Closing the site successfully!",
        closeSiteConfirm: "Are you sure to close the offline site?",
        siteExportTmp: "Charging station import template",
        subAuditConfirm: "Are you sure you want to submit for review?",
        subSuccess: "Submitted successfully",
        staPkId: "Site number",
        staAddress: "Address Details",
        movingMch: "Moving merchants",
        movingMchPl: "Please select a merchant",
        operSet: "Operation settings",
        phoneShow: "Value added services",
        show: "show",
        hide: "close",
        electricFeeTplName: "Charging rate",
        appointFeeTplName: "Rate to be effective",
        feeEffectiveTime: "Appointment time",
        delayFeeTplName: "Delay rate",
        chargingStrategy: "strategy",
        operationMode: "Business mode",
        invoicingParty: "Invoicing party",
        invoicingPartyPl: "Please select the invoicing party",
        province: "province",
        city: "city",
        district: "district",
        unbindTip: "Please try again later",
    },
    // 站点电价列表
    pileInfoEle: {
        rate: "Charging rate",
        appointmentRate: "Pending Effective Rate",
        feeName: "Template Name",
        ac: "Ac pile",
        dc: "Dc pile",
        executeTime: "Effective time",
        chargeRateName: "Electricity/Service Rate (yuan/kWh)",
        delayFreeMinutes: "Free duration",
        delayFreeMinutesMax: "Upper limit of pile fees",
        delayRateName: "Stake fee (yuan/minute)",
        reservationRateName: "Reservation occupancy fee (yuan/minute)",
        reservationRateMax: "Upper limit of reservation fee",
        minute: "minute",
        rateChangeBnt: "Rate Replacement Details",
        delayRate: "Delay rate",
    },
    // 费率应用明细
    feeDetails: {
        feeName: "Charging rate",
        replaceFeeName: "Rate to be effective",
        executeTime: "Appointment effective time",
        delayFeeTplName: "Pile rate",
        tab1: "Charge rate",
        tab2: "Delay rate",
        tab3: "Reservation charging rate",
        rateDetails: "Rate details",
        open: "open",
        close: "close",
        noSta: "No data",
        replaceFee: "Current reservation charging rate",
        acReplaceFee: "AC pile rate",
        dcReplaceFee: "DC pile rate",
    },
    // 站点详情
    pileInfoDetail: {
        city: "City",
        staAddress: "Address",
        position: "Construction site",
        staLat: "Latitude and longitude",
        staTypeName: "Site type",
        fullName: "Associated merchants",
        tagInfoVos: "Site Tags",
        commissioningDate: "Operation time",
        businessBeginHours: "Opening Hours",
        parkNum: "Number of parking spaces",
        serviceTel: "Service telephone",
        phoneNo: "Site phone",
        hasFreePark: "Free parking fee or not",
        yes: "Yes",
        no: "No",
        remarks: "Reminder",
        feeName: "Site rate",
        DC: "DC pile",
        AC: "AC pile",
        oprDelayFeeInfos: "Delay fee",
        delayFreeMinutes: "Free duration",
        staPics: "Site image",
        staInfo: "Charging point information",
        totalDev: "Total equipment",
        dcGunCount: "Direct current muzzle",
        acGunCount: "Exchange muzzle",
        tab1: "Site details",
        tab2: "Maintenance records",
        tab3: "Rate change record",
        price: "Total price(yuan/kWh)",
        manufacturerName: "Equipment manufacturer",
        ratedPower: "Rated power(kW)",
        delayUnit: "yuan/minute",
        reason: "reason",
        debuggingPeople: "Debugging personnel",
        debuggingContent: "Debugging content",
        oldFeeName: "Old rate",
        newFeeName: "New rate",
        replaceTime: "Replacement date",
        feeType: "Rate type",
    },
    // 充电桩信息
    pileList: {
        allUpdata: "Bulk editing",
        batchStaBtn: "Batch Association / unbinding",
        batchLineBtn: "Batch go online / go offline",
        batchSendBtn: "Batch release QR code",
        addBtn: "Add pile information",
        deviceStatus: "Charging point status",
        showQcode: "QR code",
        editGun: "Editing gun",
        showUnlock: "Unlocking",
        offLine: "off-line",
        showFee: "Issue electricity price",
        outPile: "Move out of charging pile",
        unbind: "Unbundling",
        downQCode: "Issue",
        staName: "Site",
        internalNumber: "Station number",
        chargeGunInfoVoList: "Model of electric gun",
        parkNo: "Parking number",
        gunStatus: "Electric gun status",
        editPile: "Edit pile",
        issueConfirm: "Are you sure you want to send a QR code?",
        issueSuccess: "Issue QR code successfully",
        showFeeConfirm: "Is the electricity price determined?",
        showFeeSuccess: "Success of power generation price",
        showUnlockConfirm: "Are you sure to unlock?",
        showUnlockSuccess: "Unlocking succeeded",
        unbindSuccess: "Unbind site successfully!",
        moveInSta: "Charging station moved in",
        moveInStaPl: "Please select charging station",
        remarks: "Remarks",
        checkReminder: "Check reminder",
        checkReminderTips: "The QR code platform is inconsistent with the charging gun, please go to the QR code details page to check and check, if they are inconsistent, you need to re-issue the QR code",
        checkReminderTips2: "The QR code has not been verified, please check the QR code details page after verification",
        gun: "gun",
        offTips: "The charging station is configured with an orderly charging grouping strategy, and the grouping needs to be reconfigured after online and offline operations",
        unbindTips: "The charging station is configured with an orderly charging grouping strategy, and the grouping needs to be reconfigured after the unbinding operation",
        groupName: "Ordered charging grouping",
        confirmOff: "Confirm to operate the device - ",
        saveQrcode: "Save QR code",
        saveQrcodeImg: "Save Picture",
        exportQrcode: "Export QR code",
        gunOperation: "Gun operation",
    },
    // 批量修改桩
    pileAllUpdata: {
        dwonloadBtn: "Download",
        importBtn: "import",
        remove: "remove",
        confirmSave: "confirm save",
        step1: "first step",
        stepText1: "Filter conditions, select the specified charging station",
        step2: "second step",
        stepText2: "Download the device table, if it has been downloaded in advance, please ignore this step",
        step3: "third step",
        stepText3: "Fill in the corresponding information according to the equipment number in the form",
        step4: "the fourth step",
        stepText4: "Click: Import file",
        step5: "the fifth step",
        stepText5: "Check the imported data, confirm that it is correct and click Save",
    },
    modalShowMap: {
        showMap: "Open map",
        addrPl: "Please enter the address",
        noData: "no data",
    },
    // 修改充电站
    pileInfoEdit: {
        site: "Charging station",
        regionId: "Province City District",
        businessBeginHours: "Opening hours",
        businessEndHours: "Closing hours",
        allDay: "all day",
        position: "Site location",
        map: "Map",
        showMap: "Open map",
        staLng: "longitude",
        staLat: "latitude",
        largeParkNum: "Bus number",
        consNo: "Registration number",
        hasSupportReseration: "Is reservation supported",
        parkingFee: "Parking notes",
        picturesParamList: "picture",
        picturesParamQuery: "view picture",
        imgSize: "The recommended image size is:",
        addrPl: "Please enter the address",
        selectTag: "Select label",
        addTag: "Add label",
        tagName: "Label name",
        required: "Required",
        nameMax: "Site name length cannot exceed 50",
        regionIdPl: "Province city district all required",
        merchantPkIdPl: "Please select an associated merchant",
        constructionPl: "Please choose the construction site",
        positionPl: "Please select site location",
        commissioningDatePl: "Please select the operation time",
        hasWeChat: "WeChat official account display",
        hasWeMini: "Wechat applet display",
        hasZfbLife: "Alipay life code display",
        hasZfbMini: "Alipay applet display",
        hasApp: "App display",
    },
    // 批量更换费率
    allUpdataRate: {
        allUpdataRateBtn: "Batch replacement rate",
        allUpdataRateDelayBtn: "Batch replacement delay rate",
        allUpdataRateReservationBtn: "Reservation rate for batch replacement",
        allUpdataChargingStrategy: "Batch Modify Ordered Charging Strategy",
        addUpdataRateBtn: "add replacement rate",
        changeRateBtn: "Replace immediately",
        feeName: "New rate template",
        executeTime: "Replacement date",
        executeStatus: "Replacement status",
        operatorName: "Operation account",
        targetSta: "Site",
        executeMode: "Replacement type",
        feeNamePl: "Please select a rate",
        executeTimePl: "Please select a time",
        executeModePl: "Please select the replacement type",
        targetStaPl: "Please select a site",
        executeMode1: "Effective immediately",
        executeMode2: "Reservation takes effect",
        tips: "Reminder: Immediately effective charging rate does not affect the existing reservation effective rate, the reservation effective will update the current charging rate that has been effective reservation, and does not affect the current charging rate in use. The effective time is 00:00:00 of the set date",
        subTips: "Reminder: Immediately effective charging rate does not affect the existing reservation effective rate, the reservation effective will update the current charging rate that has been effective reservation, and does not affect the current charging rate in use.",
        aduitNow: "Immediately issue",
        aduitThen: "Appointment issuance",
    },
    // 批量关联站点
    allBindPile: {
        sta: "Associate device to",
        staPl: "Please select your site",
        subBtn: "Immediate Association",
        subUnBtn: "Untie immediately",
        unFormSta: "Site filtering",
        tab1: "binding",
        tab2: "Unbound",
    },
    // 批量上线/下线
    allLineOffPile: {
        lineOffBtn: "Offline now",
        lineBtn: "Go online now",
    },
    //  编辑枪
    editGun: {
        manufacturerName: "Equipment manufacturer",
        gunName: "Muzzle name",
        gunNamePl: "Please enter the muzzle name",
        parkNo: "Parking number",
        description: "Muzzle description",
        descriptionPl: "Please enter the muzzle description",
    },
    // 新增桩
    addPile: {
        deviceType: "Equipment type",
        deviceModelPkId: "Equipment model",
        protocolPkId: "Agreement",
        remark: "Remark",
        gunInfo: "Muzzle information",
        info: "Information",
        addName: "Add charging pile",
        staNamePl: "Site must be selected",
        deviceTypePl: "Device type must be selected",
        deviceModelPkIdPl: "Equipment model must be selected",
        sn: "Pile number",
        snPl: "The pile number cannot be empty",
        snPl2: "Pile number must be a number",
        snPl3: "Pile number must be numbers or letters",
        pileNamePl: "Pile name cannot be empty",
        deviceStatusPl: "Operation status cannot be empty",
        protocolPkIdPl: "Please select agreement primary key",
        qrcode: "QR code",
        detailsName: "Charging point details",
        updataName: "Modify charging point",
        charging: "Charging",
        inserted: "Gun inserted",
        fault: "Fault",
        disable: "Disable",
        offLine: "off-line",
        free: "Free",
        full: "Full",
        subscribe: "make an appointment",
        offline: "Offline",
        online: "Online",
        importTpl: "Template Download",
        tab1: "Add piles",
        tab2: "Batch import of piles",
        total: "Total this time",
        dev: "device",
        dc: "Dc",
        ac: "Ac",
        power: "Power",
        pileCommissioningDate: "Operation time",
        pileCommissioningDatePl: "Please select the commissioning time",
        pileProductionDate: "Please select the production date",
        splitPile: {
            deviceModelPkId: "Host Model",
            sn: "Host Number",
            pileName: "Host Name",
            title: "Add Terminal",
            addRow: "Add Terminal",
            addRowPl: "Please add a new terminal",
            deviceModel: "Terminal Model",
            deviceModelName: "Terminal Name",
            deviceModelSn: "Terminal Number",
            ratedPower: "Rated power",
            deviceModelPl: "Please select the terminal model",
            deviceModelNamePl: "Please enter the terminal name",
            numberPl: "Please enter a numerical number",
            remove: "Remove",
            internalNumber: "Station ID",
            pileProductionDate: "Production Date",
        },
    },
    // 费率管理
    feeManage: {
        tabStaRate: "Site Rate",
        tabEntRate: "Enterprise rate",
        tabInterflowRate: "Interconnection rate",
        useRate: "In use rate",
        notUseRate: "Unused rate",
        rateDetails: "Rate details",
        bindSite: "Associated Sites",
        waitTakeEffect: "Waiting for use",
        takeEffect: "Used",
        effectiveStatus: "on-state",
        effectiveTime: "Usage time",
        addTpl: "Add rate",
        allChangeRate: "Batch replacement rate",
        key: "Rate name",
        sys: "System",
        feeName: "Template name",
        feeNamePl: "Please enter a template name",
        acRate: "Charging rate of AC pile (electricity / service charge)",
        dcRate: "Charging rate of DC pile (electricity charge / service charge)",
        delayRate: "Delay rate",
        bindStaNum: "Quantity used",
        applyStatus: "Audit status",
        timePl: "Update time cannot be empty",
        upPl: "Please do not delete or modify the rate in use!",
        delConfirm: "Are you sure to delete the current rate",
        rateAudit: "Rate audit",
        adopt: "Approved",
        refuse: "Refuse",
        reason: "Reasons",
        rateAuditPl: "Please select approval status",
        reasonPl: "Please enter the reason description",
        replaceTime: "Apply time",
        requestTime: "Operation time",
        operatorName: "Operator",
        recordChargeRate: "Charging rate",
        recordDealyRate: "Delay rate",
        acAppointment: "AC pile reservation rate",
        acRateTimingType: "Charging type of AC pile",
        dcAppointment: "DC pile reservation rate",
        dcRateTimingType: "Charging type of DC pile",
        appointmentRate: "Appointment charging rate",
        hasReplaceFee: "Is the rate to be effective yet",
        createUserName: "Modified By",
        createTime: "Modification time",
        feeRecord: "Rate Record",
        feeStatus: "current state",
        clearConfirm: "Are you sure you want to cancel the rate change?",
        issue: "Issue",
        toBeIssued: "Quantity to be issued",
        updateTip: "The current rate needs to be distributed to the site. If you need to modify the rate, please cancel the distribution first",
        aduitTip: "The current rate is pending effective rate. If you need to issue it, please take the pending effective rate first",
        aduitCancleTip: "Are you sure to cancel the distribution?",
        cancleSuccess: "Cancel successful",
        sureCancleTip: "Are you sure to cancel the appointment?",
    },
    //新增、修改费率
    addFeeManage: {
        copyRate: "Copy rate",
        copyTips: "Tip: You can quickly copy rates and time periods",
        copyPl: "Please select the rate to copy",
        subAudit: "Submit for review",
        addRate: "Add rate",
        delayFreeMinutes: "Free time",
        copy: "Copy",
        rate: "Rate",
        acRate: "AC pile rate",
        dcRate: "DC pile rate",
        delayRate: "Delay fee rate",
        priceMax: "Current price exceeds",
        priceNumber: "Price, please enter the number",
        timePl: "Please select the time to add",
        time24All: "All 24 hours have been selected and cannot be added",
        timeOverlap: "Time periods overlap, please check",
        time24AllNo: "Please select the full 24 hours",
        please: "Please input",
        serviceRate: "Service rate",
        slotElec: "Electricity price",
        slotDelayPrice: "Rate (yuan / min)",
        rateDetails: "Rate details",
        acRateDetails: "AC pile charging rate details",
        dcRateDetails: "DC pile charging rate details",
        replaceMethod: "Effective Configuration",
        replaceTime: "Apply time",
        replaceMethodPl: "Please select an effective configuration",
        replaceTimePl: "Please select the apply time",
        retaOld: "Original rate",
        retaNew: "New rate",
        copyDc: "Copy DC rate",
        copyAc: "Copy AC rate",
        reteSet: "Rate Setting",
        freePeriod1: "Free time slot one",
        freePeriod2: "Free time slot two",
        freePeriod3: "Free time slot three",
        selectTimeTip: "Please select a time period",
        freeTips: "During the above period, the pile occupation fee is waived for pile occupation",
        selectTimeRepeatTip: "Free time slots cannot be repeated",
        chargeFee: "AC charging rate",
        delayFee: "DC pile occupancy rate",
        delayFeeDetail: "Pile cost (yuan/minute)",
        freePeriod: "Free duration (minutes)",
        delayFeeMax: "Upper limit of pile cost (yuan)",
    },
    //费率管理--企业
    entFeeManage: {
        boundStaCount: "Associated Sites",
        electricStrategy: "Electricity pricing strategy",
        serviceStrategy: "Service fee strategy",
        delayStrategy: "Delay fee strategy",
        original: "Original price or not",
        priceUpdata: "Price modify",
        bindSta: "bind Sites",
        entName: "Enterprise Name",
        systemName: "System name",
    },
    delayFeeManage: {
        acRate: "AC pile delay rate",
        dcRate: "DC pile delay rate",
        acRateDetails: "AC pile delay fee details",
        dcRateDetails: "DC pile delay fee details",
        dcDelayFeeUpperLimit: "Max DC delay fee",
        acDelayFeeUpperLimit: "Max AC delay fee",
        delayFeeUpperLimit: "Max delay fee",
        freePeriod: "Free time slot",
    },
    // SIM卡管理
    simManage: {
        status: "SIM card status",
        successDev: "Successfully matched device",
        flow: "SIM card traffic package",
        globalSearch: "Iccid",
        matchingStatus: "Matching status",
        statusYes: "Matched",
        statusNo: "Unmatched",
        activeDate: "Activation date",
        endDate: "Closing date",
        simOperator: "Supplier",
        totalFlow: "Flow package",
        usedFlow: "Current month traffic",
        restFlow: "Remaining flow of the month",
        deviceModelName: "Equipment model",
        deviceType: "Equipment type",
        staName: "Charging station",
        dcDev: "DC equipment",
        acDev: "AC equipment",
        totalNum: "totalNumer",
        toBeActivatedNum: "toBeActivatedNumer",
        activatedNum: "activatedNumer",
        closedNum: "closedNumer",
        testableNum: "testableNumer",
        inventoryNum: "inventoryNumer",
        preCloseNum: "preCloseNumer",
    },
    // 新增SIM卡
    addSim: {
        fileText: "SIM card import template",
        downloadTemplate: "Download template",
        importTemplate: "Import template",
        selectFile: "Select file",
        timeError: "Date error prompt",
        No: "No",
        timeMax: "Line activation date cannot exceed deadline",
        close: "Close",
        please: "Please select",
        iccidPl: "Please enter iccid",
        iccidLen: "The length of iccid must be 20 bits",
        iccidError: "It can only consist of letters or numbers",
        iccid4Number: "The last four digits must be numbers",
        activeDatePl: "Please select activation date",
        endDatePl: "Please select the deadline",
        simOperatorPl: "Please select supplier",
        statusPl: "Please select card status",
        staPkIdPl: "Please select charging station",
        totalFlowPl: "Please choose a traffic package",
        exportSuccess: "Import succeeded",
        exportPl: "Please import the file",
        statusError: "The time when the card status is not a silent period cannot be empty",
        addSuccess: "Added successfully",
        timeNull: "Time cannot be empty",
        upSim: "Modify SIM card",
        detailsSim: "SIM card details",
    },
    // 头部
    header: {
        strip: "Strip",
        jump: "Click jump",
        accInfo: "Account information",
        upPas: "Change Password",
        out: "Log out",
        resetPas: "reset password",
        abnormalOrder: "Pending exception order",
        campaignAmount: "Promotional activities to be approved",
        couponTemplateAmount: "Template information of discount volume to be approved",
        feeAmount: "Rate template information to be approved",
        invoiceAmount: "Invoice records to be reviewed",
        mchDrawcashOrder: "Withdrawal form of merchant to be audited",
        mchSettlementOrder: "Merchant daily statement to be reviewed",
        memberMsgAmount: "Pending member message",
        rechargeApplyAmount: "Recharge application to be reviewed",
        refundOrder: "Refund order to be approved",
        staAmount: "Charging station to be audited",
        unusedEquipmentAmount: "Site equipment to be associated",
        outConfirm: "Are you sure you want to log out?",
        upSuccess: "Modification successful, please login again",
    },
    // 查看账号信息组件
    queryAccount: {
        loginUrl: "Login information",
        userName: "Login account",
        passwordShow: "Login password",
        infoPl: "Note: please save your login information. If you forget your password, please click Reset;",
        copy: "Copy",
        close: "Close",
    },
    // 操作密码
    safePassword: {
        title: "Please enter the operation password to confirm this operation",
        password: "Password",
        noPassword: "Forget the password?",
        passwordPl: "Please input a password",
    },
    // 验证
    regular: {
        name: "name",
        please: "Please input",
        pleaseSelect: "Please select",
        max: "No more than",
        maxText: "characters",
        min: "Not less than",
        numberABC: "It can only consist of numbers or letters",
        number_ABC: "It can only be composed of numbers, letters and underscores",
        tel: "Please enter the mobile number or the phone number, 7-15 digits",
        phone: "Please enter the phone number",
        phonePl: "Please input mobile phone number",
        phonePl11: "Please enter the 11 digit mobile phone number",
        phoneError: "Please input the correct mobile phone number",
        int: "It can only be an integer number",
        maxInput: "Maximum input",
        minInput: "Minimum input",
        unit: "",
        maxNum: "Cannot be greater than",
        minNum: "Cannot be less than",
        money: "amount of money",
        towDecimal: "Keep up to two decimal places",
        email: "Please input email",
        emailPl: "Mailbox cannot exceed",
        emailError: "Please fill in the correct email",
        passwordPl: "Please input a password",
        passwordError: "The password must contain letters and numbers and be between 8 and 16 in length. Please re-enter",
    },
    //===========================会员管理===========================
    //个人会员
    memberList: {
        cardStatus: "cardStatus",
        userNameAndPhone: "user name/phone",
        carNoAndvin: "carNo/vin(precise query)",
        userLevel: "User level",
        userName: "User name",
        account: "Account",
        phone: "Phone",
        carNo: "CarNo",
        vin: "Vin",
        accountBalance: "account balance",
        accountFrozen: "account frozen",
        residueIntegral: "residueIntegral",
        registrationDate: "registrationDate",
        userAmount: "total number of users",
        relevanceCard: "relevance card",
        relevance: "Associated",
        notRelevanceCard: "Not relevance card",
        memberExport: "User import",
        memberExportTpl: "User import template",
        startGet: "card reading",
        closeGet: "Cancel card reading",
        cardNumber: "Card number",
        serialNumber: "Serial number",
        relation: "relation",
        reset: "reset",
        getLoading: "Reading······",
        cardNumberPl: "Please enter the card number",
        getError: "Failed to read the card. Please check the connection of the card reader or replace the card to re associate",
        rechargeAmount: "Recharge amount (yuan)",
        rechargeSuccess: "recharge completed",
        rechargeSuccessTips: "Please wait for the review, the recharge amount will be credited to the account immediately after the review is approved",
        refundAmount: "refund amount",
        refund: "refund",
        maxMoney: "The refund amount cannot exceed the account balance",
        refundSuccess: "Refund successful",
        vipLevel: "Grade adjustment",
        vipDays: "Level duration",
        vipLevelPl: "Please select a level",
        vipDaysPl: "Please select a level duration",
        allOpen: "Turn on multiple charging",
        allClose: "Turn off multiple charging",
        multiCharge: "Multi-charge state",
        availableAmount: "Available Balance",
        isEnt: "Is it a corporate member",
        totalBalance: "User account balance (yuan)",
        totalFrozenAmount: "Account frozen amount (yuan)",
        vipEndTime: "Expiration time",
        add: "Grade adjustment",
        expired: "Expired",
        tab1: "Current level",
        tab2: "Invalid level",
        purchaseWay: "Acquisition method",
        effectStatus: "Current state",
        vipBeginTime: "entry-into-force time",
        remainDays: "Days Remaining",
        transactionTime: "Operation time",
        operatorName: "Operator",
        expCauseName: "Failure reason",
        expireTime: "Expiration time",
        auditMoney: "Recharge amount in review",
        refundableAmount: "Refundable amount",
        blacklistBtn: "Move blacklist",
        isBlackUser: "Blacklist state",
        moveBlackListTime: "Move in time",
        moveBlackListTimeEnd: "Move in expiration time",
        moveOut: "Remove",
        moveOutUser: "User name：",
        moveOutConfirm: "Are you sure you want to remove this user from the blacklist?",
        BlacklistedUsers: "Blacklisted users",
        blackListEndTime: "Expiration time",
        cycleBtn: "Membership cycle",
        reason: "Reason for joining the blacklist",
        enterReason: "Please enter the reason for joining the blacklist",
        isLoginAllowed: "Is login allowed",
        chooseNoTip: "If you choose no, users who have been moved to the blacklist will not be able to log in.",
        restrictSites: "Restrict sites",
        restrictSitesTip: "Users will not be able to charge at the selected site",
        enterUserName: "enter one user name",
        enterPhoneNo: "Please enter your phone number",
        confirmChangeCommonVip: "Confirm adjustment to regular member",
        confirmChangeCommonVipTip: "If the user has multiple pending members, they will become invalid after being adjusted to regular members",
        refundTip: "Note: The platform refund only clears the user's account balance and cannot be refunded through the original method. The actual amount should be refunded to the user offline (by transfer, cash, etc.).",
        freezeType: "Freeze type",
        importResult: "Import Results",
        importTotal: "Total imports:",
        successTotal: "Import successful:",
        failTotal: "Import failed:",
        wechatUnionID: "WeChat unionID",
        wechatAvatarUrl: "User avatar address",
        failReason: "Reason for failure",
        importTip: "Up to 500 pieces of data can be imported at once, and exceeding this limit will result in inability to import",
        success: "success",
        fail: "fail",
        importFailTip: "Importing more than 500 pieces of data at once, unable to import",
        importSuccessTip: "User import successful",
    },
    // 会员列表--详情
    memberDetails: {
        memberInfo: "User information",
        male: "male",
        female: "female",
        mergerName: "region",
        createTime: "Registration time",
        accInfo: "Account information",
        cardVin: "License plate number and Vin",
        cardStatus: "Card status",
        otherInfo: "Other information",
        vipEndTime: "User expiration time",
        points: "User's current points",
        memberCoupon: "User Coupon",
        cardPkId: "Card number",
        cardSerialNumber: "Serial number of electric card",
        cardPhysicalNumber: "Card physical number",
        silkScreenNumber: "Silk screen number",
        operationTime: "Operation time",
        createUserName: "Name of Creator",
        operateType: "Operation type description",
        releaseTime: "Collection date",
        endTime: "expiration date",
        hasUsed: "current state",
        entTitle: "User enterprise information",
        entName: "Enterprise",
        hasUseEntAccountDesc: "Payment method",
        hasAdminDesc: "Admin",
        elecFeeType: "Enterprise electricity bill",
        dcElecFee: "DC pile",
        acElecFee: "AC pile",
        serviceFeeType: "Enterprise service fee",
        dcServiceFee: "DC pile",
        acServiceFee: "AC pile",
        entBeginTime: "Starting time",
        entEndTime: "End Time",
    },
    // 会员列表--资金记录
    memberMoneyRecord: {
        tab1: "Charge",
        tab2: "Recharge",
        tab3: "Refund",
        tab4: "Fund Operation Log",
        rechargeAmount: "Total recharge amount",
        refundAmount: "Total refund amount",
        chargeAmount: "Total charge amount ",
        shoppingAmount: "Purchase member",
        balanceAmount: "Current total balance",
        transactionTime: "Operation time",
        flowType: "Operation Type",
        transactionChannel: "Operational channels",
        beforeBalance: "Balance before operation",
        transactionAmount: "Operating amount",
        afterBalance: "Balance after operation",
        orderNo: "Related order No",
    },
    // 会员列表 - 风险金列表
    memberListMoneyRiskFund: {
        flowType: "Flow type",
        transactionTime: "Transaction time",
        transactionAmount: "Transaction amount",
        beforeBalance: "Amount before transaction",
        afterBalance: "Amount after transaction",
        orderType: "order type",
        remark: "remark",
        riskAmount: "Current risk amount (yuan)",
    },
    // 会员列表 - 会员周期
    membershipCycle: {
        days: "Membership Days",
        effectiveStatus: "Membership Status",
        beginTime: "Start Time",
        endTime: "Failure time",
        expCause: "Reason for failure",
    },
    //企业会员
    corporateMemberList: {
        enterpriseName: "enterprise name",
        enterpriseAmount: "enterprise amount",
        enterpriseUserAmount: "enterprise user amount",
        enterprisePayUser: "enterprise pay user",
        rechargeTotalMoney: "recharge total money",
        chargeTotalMoney: "charge total money",
        station: "station",
        userUpperLimit: "user upper limit",
        account: "account",
        accountBalance: "account balance",
        accountFrozen: "account frozen",
        chargeTotalMoneyTips: "Total amount paid by business",
        unifiedDivision: "Unified payment group sharing status",
        unifiedOrder: "Unified payment order",
    },
    //非实名在线卡
    nonRealNameCardManagement: {
        cardPkId: "Card number",
        cardMember: "E-card member",
        cardStatus: "Card status",
        inUse: "in use",
        cancelled: "cancelled",
        operationStatistics: "operation statistics",
        selfSupport: "self support",
        generationCamp: "generation camp",
        fuzzySearch: "fuzzy search",
        cardAffiliation: "card affiliation",
        commercialTenant: "commercial tenant",
        cardNumber: "card number",
        cardPhysicalNumber: "card physical number",
        cardSerialNumber: "card serial number",
        contacts: "contacts",
        phone: "phone",
        cardBalance: "card balance",
        frozenAmount: "frozen amount",
        openTime: "open time",
        remark: "remark",
        money: "Card opening amount",
        openCardTips: "Please keep the card holder connected to the computer and place the card on the card holder",
        openCardError: "The charging card has been used! Please change the card",
        cardPhysicalNumberPl: "Please input the serial number of the card",
        cardSerialNumberPl: "Please enter the serial number",
        moneyPl: "Please enter the recharge amount",
        moneyMax: "One time recharge amount cannot be more than 5000",
        moneyMin: "One time recharge amount cannot be less than 0",
        moneyError: "The card opening amount must be in number and not more than two decimal places",
        openCardSuccess: "Card opened successfully",
        balance: "balance",
        amount: "amount of money",
        cancellation: "cancellation",
        cancellationTips: "After cancellation, the amount in the card will be automatically refunded in full, and the charging card will not be used",
        cancellationSuccess: "Logout succeeded",
        accountBalance: "Account balance (yuan)",
        createUserName: "Card opener",
        createTime: "Opening time",
        status: "Card status",
        operationInfo: "Operation information",
        cardInfo: "Card information",
        cardDetails: "Non real name card details",
        remarkPl: "Please enter your comments",
        createName: "Operator",
        operateTime: "Operation time",
        operateType: "Operation",
        rechargeAmount: "Recharge amount (yuan)",
        allMoneyMax: "The maximum amount of online card cannot exceed 9999 yuan",
        accountPkId: "Membership card number",
        refundAmount: "Refund amount (yuan)",
        refundBtn: "Refund",
        refundError: "The refund amount cannot exceed the account balance",
        refundSuccess: "Refund successful",
        silkScreenNumber: "Silk screen number",
        getCard: "card reading",
        input: "Direct entry",
        reset: "Reset",
        cardExist: "The card already exists. Please log off or change a card before opening it",
        openCard: "activate a bank card",
        silkScreenNumberPl: "Please enter the silk screen number",
        contactsPl: "Please enter contact",
        cardYes: "This card is operational",
        logout: "Logout",
        viewNo: "Your browser does not support card issuing system",
        connectError: "Issuer connection failed",
        logoutSuccess: "Card cancellation succeeded",
        cardChange: "The card has been replaced, please read the card again",
        cardWhite: "This card is blank. Please open it first",
        statusError1: "Please read the card before operation",
        statusError2: "No charging card detected, please operate again",
        statusError3: "Customer code cannot be empty",
        statusError4: "Card type cannot be empty",
        statusError5: "ID cannot be empty",
        statusError6: "Card ID can only be 16 digits",
        statusError7: "Not this system card, unable to operate!",
        logoutTitle: "This operation destroys all the information of this card. Please be careful",
        connectBtn: "Connect card issuer",
        connectBtnLoading: "Connecting card issuer……",
        cardBind: "This card has been used, please change to an unused card, serial number:",
        relation: "Relation",
        userName: "Member name",
        cardNumberPl: "Please enter the card number",
        relationSuccess: "Association succeeded",
        hasSms: "Send SMS",
        hasSmsPl: "Please select whether to send SMS",
        word: "Warm tips: operating instructions",
        wordDownload: "Click here to download",
        confirmStop: "Are you sure you want to deactivate?",
        confirmStart: "Are you sure you want to enable?",
        readCardTips: "Please read the available charging card first",
        connect: "Card issuer connected",
    },
    // 发卡下载提示
    cardTips: {
        t1: "1.Download and install the card issuer driver",
        download: "Click here to download",
        t1_1: "XP system, please",
        t2: "2.Connect the card reader to the computer through the USB cable. After normal power on, the card reader will 'beep' and keep the LED inside the card reader flashing.",
        t3: "3.Download and run the card issuer plug-in(",
        t3_1: "), after connecting the card reader, click 'open service'.",
        t4: "4.Open the card issuing management of the browser for relevant operations.",
        tips: "matters needing attention:",
        tips1: "1.At present, it supports windows operating system and windows 7 / 10 series versions.",
        tips1_1: "If you want to use it under Windows XP, you need to install the. NET3.5 framework",
        tips2: "2.During operation, ensure that the card issuer plug-in is in continuous service status.",
        tips3: '3.When the prompt "check whether to insert a card reader or install a serial port driver" is prompted, it is generally a problem that the card reader is not inserted or the serial port driver is not installed. Right click "my computer" and select "management", and then in the pop-up "computer management" window, click "device manager" in the left menu, Check whether "USB serial port" or "ft232rusr UART" exists under "other devices". If not, it means that the card reader is not plugged in. Try another USB oral test;',
    },
    //一号多充
    oneToMoreAudit: {
        phone: "phone",
        nickName: "nick name",
        applyTime: "apply time",
        applyCause: "apply cause",
        auditTime: "audit time",
        status: "status",
        auditUserName: "Reviewer",
        total: "Total applications",
        totalPending: "Waiting for approval",
        totalAudit: "Failed to pass the review",
        totalExamination: "Approved",
    },
    //站点监控
    siteMonitor: {
        province: "province",
        city: "city",
        type: "type",
        power: "power",
        equipmentAmount: "equipment amount",
        gun: "gun",
        number: "number",
        voltage: "voltage",
        current: "current",
        outPower: "power",
        chargeElect: "Charging capacity",
        totalPower: "Cumulative charge",
        thisPower: "Current output power",
        setPower: "Set output power",
        totalTimes: "Cumulative charging times (Times)",
        totalHours: "Accumulated charge time",
        accountPkId: "Charging account number",
        accountType: "Account type",
        carVin: "Vehicle VIN",
        chargedMinutes: "Charging time",
        chargingPower: "Charging capacity",
        predictAmount: "Charge amount",
        faultInfo: "Fault information",
        totalOprMch: "Operator/Site",
        totalMchSta: "Merchant/Site",
        totalMch: "Merchant",
        totalSite: "Site",
        totalGun: "Gun",
        totalGunStatus: "Charging pile status",
        queryAll: "View all",
        mchAmount: "Merchant",
        staAmount: "Site",
        devNum: "Equipment Quantity",
        dcPileAmount: "DC pile",
        acPileAmount: "AC pile",
        gunAmount: "Charging gun",
        devStatus: "Device status",
        onlinePileAmount: "Online pile",
        offlinePileAmount: "Offline piles",
        gunStatus: "Gun status",
        freeGunAmount: "idle",
        chargedGunAmount: "gun inserted",
        chargeGunAmount: "Charging",
        completedGunAmount: "Completed",
        offlineGunAmount: "Offline gun",
        faultGunAmount: "Fault gun",
        stopGunAmount: "Disable gun",
        reservedGunAmount: "Appointment gun",
        staName: "Site name",
        pileStatus: "Pile status",
        qrderlyCharging: "Orderly charging strategy",
        strategyName: "Charging strategy",
        strategyType: "Policy type",
        strategyStatus: "Policy Status",
        groupMaxOutputPower: "Maximum power",
        groupPileNum: "Group pile",
        open: "open",
        close: "close",
        pileType: "Pile type",
        orderDetails: "Order details",
        allStatus: "All status",
        gunChange: "Click to switch",
        totalElec: "Accumulated charging capacity(kWh)",
        electricity: "electric current(A)",
        thisChargingPower: "Current charging level(kWh)",
        online: "online",
        offline: "offline",
        gunTotal: "Total guns",
        soc: "Current SOC",
        thisVoltage: "Current Voltage",
        gunAllData: "Gun accumulation",
        gunThisData: "Gun current",
        parkNo: "Parking space",
        multipleDCPileAmount: "Split DC",
    },
    //告警通知
    alertNotification: {
        strategyName: "strategy name",
        sendWay: "send way",
        alarmCount: "alarm count",
        staCount: "sta count",
        modifyTime: "modify time",
        status: "status",
        faultCodes: "Event content",
        generalLevel: "General level",
        noSelect: "Not selected",
        emergencyLevel: "Emergency level",
        severityLevel: "Severity level",
        staPkId: "Designated site",
        checkSite: "Check site",
        wx: "WeChat official account",
        msg: "short message",
        wxPeople: "Official account notification",
        phonePl: "Enter the mobile phone number, and separate the numbers with",
        msgPeople: "SMS notification personnel",
        staPkIdsPl: "Please select the specified site",
        sendWaysPl: "Please select notification method",
        faultCodesPl: "Please enter at least one event content",
        msgPeoplePl: "Please enter the mobile phone number of the notifying person",
        phoneError: "Wrong number format, separated by ','",
        phoneMax: "The number cannot exceed 5 groups",
        strategyTotal: "Total number of strategies",
        faultTotal: "Total event content",
        normalTotal: "General level alarm",
        urgentTotal: "Emergency level alert",
        seriousTotal: "Severity level alarm",
        smsTotal: "SMS notification",
        weChatTotal: "Public account notice",
    },
    //事件告警
    alarmEvent: {
        alarmTime: "alarm time",
        eventAmount: "event amount",
        todayEvent: "today event",
        alarmRatio: "alarm ratio",
        alarmLevel: "alarm level",
        alarmType: "alarm type",
        equipmentAlarmAmountTop5: "equipment alarm amount top5",
        stationAlarmAmountTop5: "station alarm amount top5",
        equipmentSn: "equipment sn",
        stationName: "station name",
        quantity: "quantity",
        faultDesc: "fault desc",
        recoverTime: "recover time",
        duration: "duration",
        alarmStatus: "alarm status",
        equipmentType: "equipment type",
    },
    //站点报表
    siteReport: {
        stationName: "station name",
        dcPileNumber: "dc pile number",
        acPileNumber: "ac pile number",
        sharpPower: "sharp power",
        peakPower: "peak power",
        flatPower: "flat power",
        valleyPower: "valley power",
        totalAmount: "total amount",
        totalChargingMinutes: "total charging minutes",
        totalChargingTimes: "total charging times",
        totalElecAmount: "total elec amount",
        totalPower: "total power",
        totalSeviceAmount: "total sevice amount",
        billGenerationDate: "bill generation date",
        billCreateDate: "bill create date",
    },
    //电桩报表
    pileReport: {
        pilePkId: "pile pkid",
        pileName: "pile name",
        stationName: "station name",
        totalGunNumber: "total gun number",
        totalChargingTimes: "total charging times",
        totalAmount: "total amount",
        totalChargingMinutes: "total charging minutes",
        totalElecAmount: "total elec amount",
        totalPower: "total power",
        totalSeviceAmount: "total sevice amount",
        billGenerationDate: "bill generation date",
        billCreateDate: "bill create date",
        statisticalTime: "Statistical cycle",
        totalDelayAmount: "Accumulated delay fee",
        details: "details",
        tab1: "Station Stake Report",
        tab2: "Station Stake Report Details",
    },
    //企业报表
    kaReport: {
        enterpriseName: "Enterprise name",
        totalAmount: "Accumulated total amount (yuan)",
        totalChargingMinutes: "Cumulative charging time (minutes)",
        totalChargingTimes: "Cumulative charging times (Times)",
        totalElecAmount: "Accumulated charge (yuan)",
        totalPower: "Cumulative charge (KWH)",
        totalSeviceAmount: "Accumulated service charge (yuan)",
        billGenerationDate: "Bill generation date",
        billCreateDate: "Report creation date",
        timeError: "The end time cannot be more than yesterday",
    },
    //渠道报表
    channelReport: {
        stationName: "station name",
        orderQuantity: "order quantity",
        totalAmount: "total amount",
        totalChargingMinutes: "total charging minutes",
        totalChargingTimes: "total charging times",
        totalElecAmount: "total elec amount",
        totalPower: "total power",
        totalSeviceAmount: "total sevice amount",
        billGenerationDate: "bill generation date",
        billCreateDate: "bill create date",
    },
    //站点核算
    siteAccounting: {
        accountingTimeRange: "Accounting time range",
        qualifyingDays: "Qualified",
        failedDays: "Failed",
        accountingDate: "Accounting date",
        totalPowerConsumptionForTheCurrentPeriod: "Total power consumption for the current period(kWh)",
        totalPowerAtTheBeginningOfThePeriod: "Total power at the beginning of the period(OnLine + Offline)",
        totalElectricityConsumptionDuringSharpHours: "Total power consumption during sharp hours(kWh)",
        totalElectricityConsumptionDuringPeakHours: "Total power consumption during peak hours(kWh)",
        totalElectricityConsumptionDuringShoulderHours: "Total power consumption during flat hours(kWh)",
        totalElectricityConsumptionDuringOffPeakHours: "Total power consumption during valley hours(kWh)",
        accountingError: "Accounting error",
        formula: "Formula",
        absoluteError: "Accounting error",
        accountingResults: "Accounting results",
        pleaseSelectAChargingStationFirst: "Please select a charging station first",
        electricityAccounting: "Electricity accounting",
        amountAccounting: "Amount accounting",
        totalAmount: "The total charging amount in this period (yuan)",
        sharpAmount: "Total charging amount during sharp period (yuan)",
        peakAmount: "Total charging amount during peak hours (yuan)",
        flatAmount: "Total charging amount during flat period (yuan)",
        valleyAmount: "Total charging amount during valley period (yuan)",
        toleranceScope: "Tolerance scope",
        and: "and",
        electAmount: "charging fee",
        seviceAmount: "Service fee",
    },
    //运营核算
    operationalAccounting: {
        accountingTimeRange: "Accounting time range",
        totalAmountOfUserCharging: "Total Balance charging(RMB)",
        totalAmountOfUserRecharge: "Total recharge amount(RMB)",
        totalAmountOfUserRefunds: "Total refund amount(RMB)",
        totalUserBalanceOfThePreviousPeriod: "Total balance of last period(RMB)",
        totalUserBalanceForTheCurrentPeriod: "User's total balance(RMB)",
        totalShoppingAmount: "Current user consumption amount(RMB)",
        totalShoppingAmountTips: "Consumption includes purchase of members, goods and other consumption except charging",
        endAmount: "Current user amount(RMB)",
        accountingError: "Accounting error(RMB)",
        accountingResults: "Accounting results",
        qualified: "qualified",
        unqualified: "unqualified",
        formula: "Formula",
        toleranceScope: "Tolerance scope",
        rechargeAccounting: "Recharge accounting",
        refundAccounting: "Refund accounting",
        orderTracking: "Order Tracking",
        theEndTimeCannotBeLessThanTheStartTime: "The end time cannot be less than the start time",
        startAndEndTimesCannotBeEmpty: "Start time and end time cannot be empty",
        chargeAmount: "Charge amount",
        rechargeAmount: "Recharge amount",
        refundAmount: "Refund amount",
        consumptionAmount: "Consumption amount",
        currencyUnit: "yuan",
        amount: "amount",
        totalReservationAmount: "Appointment Charging(RMB)",
        totalPostPaidAmount: "Charge first, pay later(RMB)",
    },
    //用户核算
    userAccounting: {
        userType: "User type",
        selectUser: "Select user",
        accountingTimeRange: "Accounting time range",
        currentUserBalance: "Current user balance(RMB)",
        totalAmountOfUserRecharge: "Total recharge amount(RMB)",
        totalAmountOfUserRefunds: "Total refund amount(RMB)",
        totalAmountOfUserCharging: "Total Balance charging(RMB)",
        totalUserBalanceOfThePreviousPeriod: "Total balance of last period(RMB)",
        totalUserBalanceForTheCurrentPeriod: "User's total balance(RMB)",
        accountingError: "Accounting error(RMB)",
        accountingResults: "Accounting results",
        qualified: "qualified",
        unqualified: "unqualified",
        formula: "Formula",
        toleranceScope: "Tolerance scope",
        normal: "normal",
        abnormal: "abnormal",
        userName: "User name",
        accountID: "AccountID",
        rechargeThisPeriod: "Recharge this period（RMB）",
        refundForThisPeriod: "Refund for this period（RMB）",
        currentChargeAmount: "Current charge amount（RMB） ",
        theBalanceOfThePreviousPeriod: "The balance of the previous period（RMB）",
        balanceForThePeriod: "Balance for the period（RMB）",
        accountingErrorPercentage: "Accounting error percentage(%)",
        beginTime: "Accounting time",
        totalChargeAmount: "Total Balance charging(RMB)",
        totalReservationAmount: "Appointment Charging(RMB)",
        totalPostPaidAmount: "Charge first, pay later(RMB)",
        totalShoppingAmount: "Current user consumption amount(RMB)",
    },
    //充值核算
    rechargeAccounting: {
        rechargeChannels: "Recharge channels",
        accountingResults: "Accounting results",
        accountingTimeRange: "Accounting time range",
        fix: "Fix",
        accountID: "AccountID",
        numberOfRechargeOrders: "The total number of recharge orders",
        totalRecharge: "Total recharge amount",
        // numberOfAbnormalOrders: "Number of abnormal orders (pcs)",
        // abnormalTotalAmount: "Total abnormal amount (RMB)",
        accountingTime: "Accounting time",
        fullName: "Member name",
        phoneNo: "Phone number",
        createTime: "recharge time",
        orderNo: "Merchant order number",
        outOrderAmount: "WeChat recharge amount",
        OrderNo: "Platform order number",
        orderAmount: "Platform billing amount",
        differentAmount: "Difference amount",
        fixType: "Correction Type",
        recharge: "recharge",
        deduction: "deduction ",
        tel: "Administrator mobile phone",
        fixMoney: "Correction amount",
        fixOrder: "Correction order number",
    },
    //退款核算
    refundAccounting: {
        refundChannel: "Refund channel",
        accountingResults: "Accounting results",
        accountID: "AccountID",
        numberOfRefundOrders: "Number of refund orders (pcs)",
        totalAmountOfRefund: "Total amount of refund (RMB)",
        numberOfAbnormalOrders: "Number of abnormal orders (pcs)",
        totalAbnormalAmount: "Total abnormal amount (RMB)",
        accountingTime: "Accounting time",
        operation: "Operation",
        fix: "Fix",
    },
    //财务统计
    statistics: {
        financeStatistics: "Finance statistics",
        stationName: "Station name",
        selectionTime: "Select time",
        bind: "Bind",
        edit: "Edit",
        logout: "Logout",
        history: "History",
        chargingStation: "Charging station",
        chargingStationAddress: "Charging station address",
        chargingTime: "Charging time",
        chargeVolume: "Charging volume(degree)",
        basicElectricityBill: "Basic electricity charge(RMB)",
        serviceCharge: "Service Fee(RMB)",
        delayFee: "Delay fee(RMB)",
        discountAmount: "Discount amount (RMB)",
        actualAmount: "Actual amount received (RMB)",
        totalNumberOfOrders: "Total number of orders",
        numberOfGuns: "Number of guns (pcs)",
        usageRate: "Usage rate",
        pleaseChooseATime: "Please choose a time",
        pileNum: "Number of piles",
        usageRate2: "Utilization",
        proportion: "Proportion",
        transAmount: "Total amount",
        serviceAmount: "Total service charge",
        elecAmount: "Total electricity charge",
        delayAmount: "Total delay fee",
        totalDiscount: "Total discount",
        tab1: "Financial overview",
        tab2: "Electricity contribution",
        tab3: "Service fee contribution",
        tab4: "Delay fee contribution",
        incomeElecAmount: "Revenue electricity charge",
        incomeServiceAmount: "Revenue service fee",
        incomeDelayAmount: "Income delay fee",
    },
    //分成结算
    splitSettlement: {
        settlementType: "Classification Rule Type",
        settlementType1: "Offline",
        settlementType2: "on-line",
        shareSettlement: "Share settlement",
        orderBreakdown: "Order breakdown",
        merchantName: "merchantName",
        chargingOrderNumber: "Charging order number",
        selectionTime: "Select time",
        stationName: "Station name",
        chargeVolume: "Charging volume",
        electricityBill: "Electricity bill",
        serviceCharge: "Service Fee",
        chargeableAmount: "Chargeable amount",
        discountAmount: "Discount amount",
        totalAmountActuallyPaid: "Total amount actually paid",
        partitionMethod: "Partition method",
        merchantIncome: "Merchant income",
        operatorShare: "Operator share",
        orderDate: "Order accounting date",
        orderTimeError: "Order time cannot be empty, please select the correct time",
        errorStartTimeEndTime: "The start time cannot be greater than the end time",
        contentConfirm: "Are you sure you want to agree to the selected data? ?",
        successfulOperation: "Successful operation",
        daySettlementOrderNumber: "Day settlement order number",
        dailyStatementStatus: "Daily statement status",
        settlementDate: "Settlement date",
        numberOfOrders: "Number of orders",
        actualChargeAmount: "Actual charge amount",
        merchantIncomeAmount: "Merchant income amount",
        operatorShareAmount: "Operator share amount",
        createTime: "Create time",
        pleaseSelectTheGenerationDate: "Please select the create time",
        createTimeError: "The start time of the generation date cannot be greater than the end time",
        selectMonth: "Please select a monthly closing month",
        confirmDate: "Do you want to confirm the selected data?",
        confirmGeneration: "Confirm to re accounting?",
        confirmGenerationError: "The daily statement contains multiple merchants, and currently only the same merchant can batch regenerate the daily statement",
        withdrawnDate: "Are you sure you want to withdraw the selected data?",
        selectDate: "Do you want to operation the selected data?",
        selectDateToOperate: "Please select the data to be operated",
        deleteTitle: "Reasons for invalidation",
        remarkPl: "Please enter the reason",
        supplement: "Supplement",
        orderNo: "Select daily order number",
        orderNoPl: "Please select order",
        staName: "Charging station",
        settlementStatus: "Accounting status",
        regenerate: "regeneration",
        regenerateConfirm: "Are you sure to regenerate?",
        allSettlement: "Batch accounting",
        settlement: "accounting",
        settlementNew: "Re accounting",
        errorInfo: "Abnormal information",
        accountingRecords: "Accounting records",
        accountingRecordsStatus: "Accounting status",
        accountingRecordsRepairStatus: "Repair status",
        accountingRecordsTime: "Settlement date",
        initialAccounting: "Initial accounting",
        newAccounting: "Latest accounting",
        ComparisonResults: "Difference of comparison results",
        settlementNewConfirm: "Recalculate the selected data?",
        settlementConfirm: "Accounting for selected data?",
        settlementConfirmError: "The daily statement contains multiple merchants, and currently only the same merchant is supported for batch accounting of daily statements",
        exceptionDifference: "Abnormal difference",
        drawCashOrderStatus: "Withdrawal status",
        drawCashOrderStatus1: "Withdrawal",
        drawCashOrderStatus2: "Undrawn",
        exportMch: "Export (please select merchant)",
    },
    //商户提现
    withdrawal: {
        withdrawalOverview: "Withdrawal overview",
        withdrawOrder: "Withdraw details",
        addWithdrawal: "Add withdrawal form",
        totalNumberOfMerchants: "Total number of merchants(pcs)",
        totalChargeAmount: "Total amount charged(RMB)",
        amountOfCashWithdrawn: "Amount of cash withdrawn(RMB)",
        undrawnCash: "Amount of undrawn cash(RMB）",
        merchantName: "merchantName",
        chargeAmount: "totalChargeAmount",
        cashWithdrawal: "Amount of cash withdrawn",
        undrawn: "Amount of undrawn cash",
        pendingWithdrawalOrder: "Pending withdrawal order",
        beSettledOrderCount: "Settlement Doc to be settled",
        abnormalSettledOrderCount: "Settlement Exception Settlement Document",
        numberOfWithdrawals: "Number of withdrawals",
        dateOfTheMostRecentWithdrawal: "Date of the most recent withdrawal",
        pendingPaymentWithdrawalOrder: "Pending payment withdrawal order(one piece)",
        paidWithdrawalOrder: "Paid withdrawal order(one piece)",
        comprehensiveScreening: "Comprehensive screening",
        withdrawOrderStatus: "Withdraw order status",
        createTime: "Create time",
        reviewDate: "Review date",
        withdrawOrderTemplate: "Withdrawal order template",
        withdrawOrderNumber: "Withdraw order number",
        withdrawalAmount: "Withdrawal amount",
        transferFee: "Transfer fee",
        actualWithdrawalAmount: "Actual withdrawal amount",
        paymentDate: "Payment date",
        readyToPay: "Are you sure you are ready to pay?",
        successfulOperation: "Successful operation",
        noAttachments: "No attachments",
        reason: "Abort",
        reasonTitle: "Abort Reason",
        abortedReasonPl: "Please enter the reason",
        withdrawOrderBtn: "Withdrawal order",
        payVoucher: "annex",
        payVoucherPl: "Please upload the voucher",
    },
    //会员充值
    memberRecharge: {
        arrivalTime: "Amount arrival time",
        numberOfTopUpUsers: "Number of top-up users(a)",
        rechargeAmount: "Recharge amount(RMB)",
        rechargeTimes: "Number of recharges(times)",
        rechargeMethodAmountRatio: "Recharge method amount ratio",
        memberName: "Member name",
        cellphoneNumber: "Cellphone number",
        orderNumber: "Merchantor/ payment order number",
        rechargeMethod: "Recharge method",
        operatorCode: "Operator code",
        operatorName: "Operator name",
        memberNo: "Membership Number",
        memberPhoneNumber: "Member mobile number",
        merchantOrderNumber: "Merchant order number",
        paymentOrderNumber: "Payment order number",
        rechargeTime: "Recharge time",
        orderStatus: "Order Status",
        accountingCorrection: "Fix",
        wechatPay: "WeChat pay",
        cashRecharge: "Cash recharge",
        rechargeInformation: "Recharge information",
        typeOfMembership: "Type of membership",
        transferVoucher: "Transfer voucher",
        reviewInformation: "Process information",
        // reviewer: "Reviewer",
        // reviewTime: "Review time",
        // auditResults: "Audit results",
        remark: "Remark",
        reasonForRejection: "Reason for rejection",
        reasonForRejectionPl: "Please enter a reason",
        auditConfirm: "Are you sure you want to pass the review?",
        allAudit: "Batch audit",
        allAuditStatus: "Approval Status",
        allAuditStatusPl: "Please select a review status",
        processingTime: "Processing time",
        processingAction: "Processing action",
        auditUserName: "Handler",
        refundStatus: "Current state",
        auditPass: "Approved",
        auditReject: "Approval Denied",
        alipayRecharge: "Alipay",
        xlRecharge: "Xinlian",
        ccbRecharge: "CCB",
    },
    //退款记录
    refundRecords: {
        pageTitle: "refund records",
        refundApplicationTime: "Refund application time",
        refundOrderQuantity: "Refund order quantity (items)",
        refundAmount: "Refund amount(RMB)",
        orderStatus: "Order Status",
        globalSearch: "Order number/Account number/Phone number",
        accountType: "Account type",
        refundMethod: "Refund method",
        pendingReview: "Pending review",
        rejected: "Rejected",
        returned: "Returned",
        paymentFailed: "Payment failed",
        nonPaymentNumber: "Unpaid",
        passed: "Passed",
        orderNumber: "Order number",
        accountNumber: "Account number",
        accountName: "Account name",
        phoneNumber: "Phone number",
        amountOfRefundRequested: "Amount of refund requested(RMB)",
        successfulRefundAmount: "Successful refund amount(RMB)",
        uploadCertificate: "Upload certificate",
        transferVoucher: "Transfer voucher",
        pleaseUploadAPicture: "Please upload a picture",
        successfulOperation: "Successful operation",
        refundReview: "Refund review",
        refundReviewPl: "Please select the refund review method",
        refundNoteText: "Refund note text",
        refundNoteTextPl: "Please enter the text description of the refund",
        autoText: "Refund authority",
        autoTextPl: "Please select the refund permission method",
        refundRecordDetails: "Refund record details",
        applicationInformation: "Application Information",
        processingInformation: "Processing information",
        reviewInformation: "Review information",
        refundOrderStatus: "Refund order status",
        remark: "Remark",
        refundDetails: "Refund details",
        refundFailed: "Refund failed",
        refundSuccessfully: "Refund successfully",
        agreeToARefund: "Agree to a refund",
        refusalToRefund: "Refusal to refund",
        enterReason: "Please enter the reason for rejecting the refund",
        processingTime: "Processing time",
        processingAction: "Processing action",
        processResult: "Process result",
        detailedOrderNumber: "Detailed order number",
        amount: "Amounts",
        refundTime: "Refund time",
        result: "Result",
        refundToUser: "Refund to user",
        refundErrResult: "reason",
        allAudit: "Batch audit",
        allAuditType: "Audit type",
        rejectRemark: "Reasons for refusal",
        auditUserName: "Handler",
        refundStatus: "Current state",
        refundType: "Refund Type",
        refundStatusName: "Refund status",
        noHandleData: "No processing information",
    },
    //发票管理
    invoiceInfo: {
        applicationTime: "Application time",
        globalSearch: "Order number/Phone number",
        invoiceType: "Invoice type",
        invoicingStatus: "Invoicing status",
        auditSettings: "Audit settings",
        invoiceOrderNumber: "Invoice order number",
        invoiceHeaderType: "Invoice title type",
        invoiceTitle: "Invoice title",
        taxNumber: "Tax number",
        invoiceAmount: "Invoice amount(RMB)",
        phoneNumber: "Phone number",
        invoicing: "Invoicing",
        invoiceUserName: "Invoicing User",
        issuer: "Issuer",
        processingMethod: "Processing method",
        courierCompany: "Courier company",
        shipmentNumber: "Shipment number",
        remark: "Remark",
        haveBeenMailed: "mail",
        noNeedToMail: "No need to mail",
        enterIssuer: "Please enter the billing person",
        selectMethod: "Please select the billing method",
        validationError: "Form validation error",
        selectAddress: "Please enter the mailing address",
        enterNumber: "Please enter the mailing order number",
        orderNumberLength: "The length of the mailing order number must not be less than eight digits",
        invoiceSuccessful: "Invoice successful",
        numberOfInvoices: "Number of invoices",
        electronicInvoice: "Electronic invoice",
        paperInvoice: "Paper invoice",
        totalInvoicedAmount: "Total invoice amount",
        invoicedServiceFee: "Invoiced service fee",
        invoicedElectricityBill: "Electricity billed",
        invoiceReviewProcess: "Invoice review process",
        on: "Turn on",
        close: "Turn off",
        selectionProcess: "Please select the invoice review process",
        setSuccessfully: "Set successfully",
        invoiceInformation: "Invoice Information",
        serviceCharge: "Service fee(RMB)",
        electricityBill: "Electricity fee(RMB)",
        eMail: "EMail",
        receivingInformation: "Receiving information",
        invoicingInformation: "Invoicing information",
        processingTime: "Processing time",
        invoiceSerialNumber: "Invoice serial number",
        payee: "Payee",
        reviewer: "Reviewer",
        unit: "Unit",
        invoicePicture: "Invoice picture",
        shippingAddress: "Shipping Address",
        denialReason: "Please enter the reason for rejection",
        orderNumber: "Order number",
        delayFee: "Delay fee(RMB)",
        discountedPrice: "Discount amount(RMB)",
        amountActuallyPaid: "Actual payment amount(RMB)",
        reviewCompleted: "Review completed",
        invoiceOperator: "Invoice operator",
        invoiceOrder: "Invoice Order",
        invoiceAuditRecord: "Audit records",
        operationTime: "Operation time",
        operationStatus: "Operation action",
        operation: "Operator",
        applyStatuse: "current state",
        confirmAudit: "Are you sure to approve?",
        operationSys: "System automatic processing",
        registerAddress: "registered address",
        registerTelephone: "registered Phone",
        bankDeposit: "Bank of deposit",
        bankAccountNo: "bank account",
    },
    //===========================系统管理===========================
    //权限配置
    accessConfiguration: {
        roleName: "roleName",
        remark: "remark",
        createUserId: "createUserId",
        createTime: "createTime",
        updateTime: "updateTime",
        menuModule: "Menu Module",
        menuGlance: "Menu Glance",
        roleType: "Role Type",
        roleNameMsg: "Please enter the role Name",
        roleNameErrorMsg: "The role name cannot be more than 20 characters",
        roleTypeMsg: "Please select role type",
        operate: "Log",
        operationUserName: "Last operator",
        operationTime: "Last operation time",
        operationIp: "Last operation IP",
    },
    //用户管理
    userManage: {
        userName: "userName",
        role: "role",
        effectiveTime: "effectiveTime",
        status: "status",
        password: "password",
        confirmPassword: "Confirm Password",
        name: "name",
        addUser: "Add User",
        updateUser: "Update User",
        detailsUser: "Details User",
        userNameMsg: "Login account cannot be empty",
        roleMsg: "Role cannot be empty",
        passwordMsg: "Password cannot be empty",
        passwordLenMsg: "Length 6 ~ 18",
        passwordValMsg: "The password cannot contain spaces, tabs, and newlines",
        confirmPasswordMsg: "Confirm password cannot be empty",
        confirmPasswordOldMsg: "Confirm that the password is inconsistent with the password",
        effectiveTimeStartMsg: "The start time of the effective time must be filled in",
        effectiveTimeStartValMsg: "The start time cannot be greater than the end time",
        effectiveTimeEndMsg: "The end time of valid time must be filled in",
        effectiveTimeEndValMsg: "The end time cannot be less than the start time",
        assignedSite: "Assigned site",
        unassignedSite: "Unassigned site",
        moveLeft: "Move Left",
        moveRight: "Move Right",
        chargeStationName: "Charge Station Name",
        createUserName: "create User ",
        operationUserName: "operator",
        operationTime: "operation time",
        operationIp: "operation IP",
        operationTypeName: "Operation type",
        content: "Operation content",
    },
    //系统日志
    logManage: {
        operationLog: "user operationLog",
        logIn: "logIn",
        platformOperation: "Platform operation log",
        queryInfo: "queryInfo",
        userName: "userName",
        customerIp: "customerIp",
        moduleName: "moduleName",
        operationMethod: "operationMethod",
        operationTime: "operationTime",
        operationDetails: "operationDetails",
        logInTime: "logInTime",
        version: "version",
        operationModule: "operation module",
        platformUserName: "account",
        platformCustomerIp: "Customer IP",
        platformModuleName: "Module Name",
    },
    //更新日志
    renewLog: {},
    //在线用户usr
    onlineUser: {
        query: "username/login/IP address",
        roleName: "roleName",
        userName: "userName",
        IP: "IP",
        logInTime: "logInTime",
        token: "token",
    },
    //企业会员-- 资金记录
    memberListMoney: {
        transactionTime: "Recharge time",
        rechargeAmount: "Recharge amount",
        beforeBalance: "Balance before recharge",
        afterBalance: "Balance after recharge",
        rechargeMethod: "Recharge channel",
        orderStatus: "Order status",
        rechargeStatus: "Recharge status",
        transactionAmount: "Total recharge amount",
        wxTransAmount: "WeChat recharge amount",
        alipayTransAmount: "Alipay recharge amount",
        cashTransAmount: "Cash recharge amount",
        accountBalance: "Current total balance",
    },
    //企业会员-- 资金记录退款
    memberListRefundMoney: {
        transactionTime: "Time to apply for refund",
        refundAmount: "Refund amount",
        refundedAmount: "Successful refund balance",
        orderStatusDesc: "Order status",
        transactionAmount: "Total amount of refund",
        wxTransAmount: "WeChat refund amount",
        alipayTransAmount: "Alipay refund amount",
        cashTransAmount: "Cash refund amount",
        accountBalance: "Current total balance",
        refundMethod: "Refund channel",
        exportName: "Refund record",
    },
    // 企业会员-- 会员积分调整
    memberListIntegral: {
        tab1: "Integral adjustment",
        tab2: "Adjustment record",
        type: "Operation type",
        points: "Operation integral",
        typePl: "Please select the operation type",
        pointsPl: "Please enter points",
        pointsMin: "Operation integral must be greater than 0",
        pointsMax: "Deduction points are greater than current points, please re-enter",
        openId: "Wechat openid",
        unionId: "Wechat unionId",
        headImgUrl: "User profile",
        sex: "sex",
        balanceAmount: "Account balance (yuan)",
    },
    // 企业会员详情
    corporateMemberDetail: {
        info: "essential information",
        entName: "Company name",
        contactName: "contacts",
        phoneNo: "contact number",
        maxMemberNumber: "Max members",
        accountPkId: "Account number",
        minRechargeAmount: "Minimum recharge amount (yuan)",
        minRecharge: "Minimum recharge amount",
        accountBalance: "Account balance (yuan)",
        loginUrl: "Login address",
        accInfo: "account information",
        userName: "user name",
        detailsExpireTime: "Account validity",
        rolePkId: "Role",
        password: "password",
        password2: "Confirm password",
        reset: "Reset",
        effectiveTime: "Account validity",
        expireTime: "Account expiration time",
        add: "Add",
        updata: "Updata",
        effectiveTimePl: "Please select the effective date of account",
        expireTimePl: "Please select account expiration time",
        rolePkIdPl: "Please select a role",
        passwordPl: "Please input a password",
        passwordError: "Please enter a 6-10 character password",
        passwordTowError: "The two passwords are inconsistent, please re-enter",
        resetSuccess: "Reset successfully",
        loginTitle: "Key account login information",
        timeError: "The expiration time cannot be less than the effective time",
        unifiedDivisionDesc: "Unified payment group split status",
        feeInfo: "Rate information",
        elecBillType: "Electricity bill type",
        dcPileElecFee: "DC pile electricity fee",
        acPileElecFee: "Electricity cost for communication piles",
        openTime: "start time",
        serviceFeeType: "Service fee type",
        dcPileServiceFee: "DC pile service fee",
        acPileServiceFee: "AC pile service fee",
        endTime: "End time",
        occupationFeeType: "Types of station pile fees",
        dcOccupationFee: "DC pile occupation fee",
        acOccupationFee: "AC pile occupation fee",
        openStation: "Open site",
        stationList: "Site List",
        stationAddress: "Site address",
        feeType1: "Fee ratio%",
        feeType2: "Pricing (yuan)",
        feeType3: "Quota reduction (yuan)",
    },
    //  企业会员充值
    corporateMemberRecharge: {
        accountBalance: "Balance before transaction (yuan)",
        minRechargeAmount: "Minimum recharge (yuan)",
        rechargeAmount: "Recharge amount (yuan)",
        cardMaxMoney: "The maximum amount of online card cannot exceed 9999 yuan",
        cardMinMoney: "Recharge amount cannot be less than",
        rechargeSuccess: "Recharge success",
        balance: "Balance：",
    },
    //  企业会员退款
    corporateMemberRefund: {
        refundAmount: "Refund amount (yuan):",
        refundBtn: "Refund",
        maxAmount: "The refund amount cannot exceed the account balance",
        refundSuccess: "Refund successful",
        amountBalance: "Account balance",
    },
    //企业会员-- 绑定站点
    bindSites: {
        rateSet: "Electricity price modification",
        dcElecFee: "DC pile price",
        acElecFee: "AC pile price",
        dcServiceFee: "DC pile service fee",
        acServiceFee: "AC pile service fee",
        hasOriginalFee: "original price",
        yes: "Yes",
        beginTime: "Start time",
        endTime: "End time",
        bindSite: "Associated sites",
        self: "self-support",
        unself: "Non proprietary",
        amount: "amount of money",
        please: "Please input",
        pleaseCorrect: "Please enter the correct",
        towNumber: ", with a maximum of two decimal places",
        max: "Cannot be greater than",
        delayFeeTypePl: "Please choose the preferential way of delay fee",
        serviceFeeTypePl: "Please choose the service fee discount metho",
        elecFeeTypePl: "Please choose the preferential way of electricity charge",
        selectSta: "Select station",
        dealyADc: "AC/DC dealy",
    },
    // 企业成员
    corporateMembers: {
        hasUseEntAccount: "Payment method",
        entUserGroupPkId: "User group",
        hasAdmin: "Administrator",
        globalSearch: "Name / phone",
        historyRecords: "History",
        members: "Enterprise members",
        admin: "administrators",
        unallocated: "Unallocated",
        queryCarNo: "License plate",
        relevanceCard: "Associated card",
        queryBindCard: "Electric card information",
        setMain: "Set as Administrator",
        cancelMain: "Cancel administrator",
        handleDel: "remove",
        fullName: "Name",
        carList: "license plate number",
        vinList: "Vin code",
        quotaType: "Quota allocation (yuan)",
    },
    // 新增成员
    corporateMembersAdd: {
        add: "Can be added",
        templateDownload: "Template download",
        upCard: "Modify vehicle",
        addCard: "Add vehicle",
        addRow: "Add a column",
        addMember: "Add members",
        fullNamePl: "Please enter your name",
        phoneError: "The mobile number member already exists, please re-enter",
        phoneRepeat: "The mobile phone number has been repeated",
        cardMax: "The license plate number cannot be more than 10 characters",
        cardRepeat: "The license plate number has been repeated",
        exists: "Already exists",
        vinMax: "Vin code cannot be more than 17 characters",
        vinError: "Vin code can only be composed of numbers and letters",
        vinRepeat: "The code has been repeated",
        vinCardError: "Group license plate number and VIN code must be input at the same time or not",
        No: "No",
        addMemberTpl: "Add member template",
        updataMember: "Modify members",
        entUserGroupPkIdPl: "Please select User Group",
        updataTitle: "Modify employee information",
        entUserGroupPkIdTips: "Note: the revised quota allocation will take effect in the next cycle",
        adds: "Continue to add",
        carNoPl: "Please enter the license plate number",
        carNoMax: "The license plate number cannot be more than 10 characters",
        hasAdmin: "Yes (administrator)",
        del: "remove",
        confirmDel: "Are you sure you want to delete?",
    },
    // 成员绑卡
    corporateMembersBind: {
        cancelSuccess: "Cancel successfully",
        cancelRelation: "Cancel relation",
    },
    // 成员-历史记录
    membersHistory: {
        globalSearch: "Name / mobile phone number / license plate number",
        createTime: "Removal time",
        userName: "Operator",
        operateType: "Operation type",
    },
    // 企业会员--用户组
    membersUserGroup: {
        groupName: "User group name",
        entUserSum: "Number of members",
        staSum: "Available sites",
        quotaAmount: "Staff quota allocation",
        associateMembers: "Associate members",
        availableSites: "Available sites",
        hasUseEntAccountPl: "Please choose the payment method",
        moveLeft: "Move left",
        moveRight: "Move right",
        total: "total",
    },
    // 企业会员-- 资金记录
    corporateMemberRecord: {
        tab1: "Charge",
        tab2: "Recharge",
        tab3: "Refund",
        payStatus: "Payment status",
        chargeGlobalSearch: "full name",
        chargeRecord: "Charging record",
        rechargeType: "Recharge method",
        rechargeStatus: "Recharge status",
        rechargeRecord: "Recharge record",
        rechargeTime: "Recharge time",
        rechargeMoney: "Recharge amount (yuan)",
        beforeBalance: "Balance before recharge (yuan)",
        afterBalance: "Balance after recharge (yuan)",
        recordRecord: "Refund record",
        recordTime: "Time to apply for refund",
        refundAmount: "Refund amount (yuan)",
        refundedAmount: "Successful refund balance (yuan)",
        orderStatus: "Refund status",
    },
    // 非实名卡-- 资金记录
    nonFundHistory: {
        tab1: "Charge",
        tab2: "Recharge",
        tab3: "Refund",
        transactionTime: "Recharge time",
        rechargeAmount: "Recharge amount",
        createName: "Operator",
        refundTime: "Refund time",
        refundAmount: "Refund amount",
        amountBeforeRefund: "Amount before refund",
        amountAfterRefund: "Amount after refund",
        transactionAmount: "Total recharge amount",
        refundTransactionAmount: "Total refund amount",
        accountBalance: "Total card balance",
        beforeBalance: "Amount before recharge",
        afterBalance: "Amount after recharge",
    },
    // 运营商信息余额提醒
    upBalanceConfig: {
        tipsText: "Note: after opening this function, the member will notify the other party by sending SMS or official account when the balance is lower than the specified amount. In order to prevent frequent notification from affecting the user, it is recommended to remind the amount to be set carefully.",
        status: "Open function",
        open: "open",
        close: "close",
        triggerValue: "Balance reminder",
        triggerValueTips: "Users charge, the balance is less than",
        triggerValueTips2: "yuan, send a notice",
        sendWays: "Notification method",
        wx: "Official account notification",
        msg: "SMS notification",
        wxTpl: "Official account template detection",
        msgTpl: "SMS template detection",
        configured: "Configured",
        noConfigured: "not configured",
        noTmpTips: "No SMS template detected, please contact the platform service provider for configuration",
        balance: "balance",
        sendWaysPl: "Please select notification method",
        statusPl: "Please select whether the function is open or not",
        tab1: "individual member",
        tab2: "Non real name e-card members",
    },
    // 修改系统信息
    upSysInfo: {
        wxLogo: "WeChat official account logo",
        imgSize: "The recommended image size is:",
        wxMiniLogo: "Wechat applet logo",
        logo: "Platform logo",
        logoPl: "Please upload the platform logo",
        oprSystemName: "Platform name",
        loginPageSlogan: "Landing page message",
        websiteRecordInfo: "Web filing information",
        sysName: "System name",
        websiteRecordInfoPl: "Please enter the filing information of the website",
        wxLogoPl: "Please upload the official account number logo.",
        wxMiniLogoPl: "Please upload the logo of the app",
        upSuccess: "Modified successfully",
        description: "Operator description",
        descriptionPl: "Please enter operator description",
    },
    //  充电服务配置
    upChargeConfig: {
        tab1: "WeChat official account",
        tab2: "Wechat applet",
        tab3: "Alipay applet",
        infoConfig: "Basic configuration",
        hasWeChat: "Service enable",
        open: "open",
        close: "close",
        qrCodeFilePath: "QR code",
        upload: "upload",
        weChatName: "name",
        please: "Please input",
        primevalId: "Original ID",
        noticeTpl: "Notification template",
        wxPayInfo: "Wechat payment information",
        mchName: "Merchant name",
        mchId: "Merchant ID",
        mchKey: "Merchant key",
        mchCertFilePath: "Apply for refund certificate",
        download: "Download certificate",
        mchCertFilePathPl: "Please upload the refund certificate",
        qrCodeFilePathPl: "Please upload the QR code",
        weChatLogoPl: "Please upload logo",
        Applets: "Applets",
        wxNumber: "official account",
        "201": "Charging start notification",
        "203": "Charging settlement notice",
        "202": "End of charge notification",
        "301": "Fault notification",
        "204": "Reminder of insufficient balance",
        "205": "Send coupon template",
        "101": "Login SMS template",
        "104": "Authentication template",
        "102": "Modify password template",
        "103": "Information change template",
        zfbLogo: "Applet logo",
        qrCodePath: "Small program QR code",
        zfbName: "Alipay application name",
        zfbAppId: "Applet ID",
        zfbAppSecret: "Applet secret",
        privateKey: "Application private key",
        alipayPublicKey: "Alipay public key",
        zfbLogoPl: "Please upload logo",
        qrCodePathPl: "Please upload the QR code",
        mchCertName: "Payment certificate name",
        mchCert: "Payment certificate path",
        mchCertPwd: "Merchant certificate password",
        mchPosid: "Counter code",
        mchBranchid: "Branch code",
        mchTxCode: "Transaction code",
        mchUserId: "operator number",
        mchPassword: "operator password",
        ipAddr: "Outreach platform ip",
        port: "External port",
        wxPayPointsTitle: "WeChat Pay points",
        mchCertSerialNo: "Serial Number",
        mchCertPrivateKey: "Merchant Certificate Private Key",
        serviceIntroduction: "service information",
        mchV3Key: "Merchant V3 Key",
        serviceId: "WeChat Pay sub service id",
        required: "Required",
        sm2Pass: "sm2 Signature private key",
        merSm2KeyText: "Merchant Signature",
        merSm2PubKeyText: "Merchant Signature Public Key",
        merSm2DecKeyFile: "Merchant decrypts private key",
        merSm2DecPubKeyFile: "Merchant decryption public key",
        payCenterPublicKey: "Payment platform encryption public key",
        refundNotifyUrl: "Refund asynchronous notification interface",
        version: "version",
        xlType: "Payment version",
        mchType: "Merchant type",
        mchTypePl: "Please select merchant type",
        AppID: "App ID",
        mchPrivatePassword: "Merchant private key password",
        mchPrivateKey: "Merchant private key",
        mchPrivateKeyPl: "Please upload the account private key",
        entPublicKey: "Enterprise Gateway Public Key",
        entPublicKeyPl: "Please upload the enterprise gateway public key",
        isSupportLedgerSplit: "Does it support ledger splitting",
        isSupportLedgerSplitPl: "Please select whether to support split accounting",
        zfbInfo: "Alipay payment information",
        mchNo: "Merchant No",
    },
    // 修改操作密码
    upSafePassword: {
        userPwd: "New password",
        confirmPassword: "Repeat new password",
        verCode: "Mobile phone verification code",
        verCodePl: "Verification code cannot be empty",
        userPwdPl: "Password cannot be empty",
        userPwdLen: "Password length 6-18",
        userPwdError: "The password cannot contain spaces, tabs, and newlines",
        confirmPasswordPl: "Confirm password cannot be empty",
        confirmPasswordError: "Please confirm whether the new and old passwords are consistent",
        upError: "Modification failed",
    },
    // 结算配置
    upSettlementConfig: {
        info: "Billing information",
        invoiceOperator: "Invoice operator",
        invoiceOperatorPl: "Please select invoice operator",
        invoiceType: "Invoice type",
        companyName: "corporate name",
        taxId: "duty paragraph",
        chargeRate: "Tariff rate of electricity",
        serviceRate: "Tax rate of service charge",
        bankDeposit: "Bank of deposit",
        bankAccountNo: "bank account",
        unit: "Invoice unit",
        contacts: "contacts",
        telephone: "contact number",
        payee: "payee",
        drawer: "Drawer",
        reviewer: "Reviewer",
        registerAddress: "Receiving address",
        modifyTime: "Last update time",
        otherInfo: "Other information",
        drawRemark: "remarks",
        drawDesc: "Withdrawal instructions",
        tips: "matters needing attention",
        tips1: "1. Different invoice types will affect the tax rate of the other party's invoice, so the invoice type should be carefully selected.",
        tips2: "2. The company name will affect the payer of the withdrawal form and the company header of the invoice. Please modify it carefully.",
        tips3: "3. Other information such as tax number, deposit bank and account number is required for billing.",
        tips4: "4. The contact person, telephone number and receiving address are optional. The contact information of the operator is set by default",
        tips5: "5. You can fill in the notes and withdrawal instructions according to the actual payment request. After modification, the corresponding information in the withdrawal form will be updated",
        unitPl: "Please select invoice unit",
        isOpen: "Whether to open",
        isOpenPaper: "Whether to open paper invoice",
        openTipsTitle: "Open reminder",
        openTips: "The activation of this function requires connection with a third-party invoicing platform, and corresponding invoicing fees will be incurred, which must be borne by the operator. If necessary, please contact the platform administrator to activate.",
        companyCode: "Baiwang - Company Code",
        drawerCode: "Baiwang - Invoicer Code",
        terminalCode: "Baiwang - Invoicing Terminal Code",
        paperInvoiceType: "Invoicing type",
        paperInvoiceTypePl: "Please select the invoicing type",
    },
    // 新增商户
    addMerchant: {
        info: "essential information",
        fullName: "Merchant name",
        shortName: "Merchant abbreviation",
        contacts: "contacts",
        contactsMail: "Contact email",
        telephone: "contact number",
        address: "Contact address",
        operatorShare: "Operator share",
        shareType: "Classification",
        isMoneyRules: "Fixed amount",
        isMoneyRulesShareMaxError: "Fixed amount share cannot be greater than total amount, please check",
        orderTotalMoney: "Total amount of single order",
        orderTotalMoneyMax: "More than RMB",
        orderShare: "Share of each order",
        isMoneyRulesTips: "Display the corresponding allocation amount according to the classification type, multiple choices. Note: after the fixed amount is selected, the total amount cannot be selected again for each order of percentage type",
        isPercentageRules: "percentage",
        order: "Every order",
        cashConfig: "Withdrawal allocation",
        cashMin: "Minimum withdrawal amount",
        condition: "condition",
        fromValueTips: "Full settlement amount",
        feeTips: "Deduction of transfer charges",
        feeTipsPl: "Percentage of transfer fee deducted",
        loginUrl: "Login address",
        addTitle: "New account number",
        resetPassword: "reset password",
        mchCollectionInfo: "Merchant Collection Information",
        bankAccountName: "Bank account name",
        bankDeposit: "Opening bank of collection account",
        bankAccountNo: "Receiving bank account",
        addMch: "New merchant",
        loginTitle: "New login account",
        updataTitle: "Modify login account",
        required: "Required",
        textLenMax: "Length cannot exceed",
        divisionPercentPl: "Please choose the way of sharing",
        divisionPercentMax: "Value range: 0.00 ~ 100",
        divisionPercentError: "Please enter a valid number",
        base2: "percentage",
        minWithdrawAmount: "Minimum withdrawal amount",
        bankDepositPl: "Please enter the name of the collection account",
        bankAccountNamePl: "Please enter the name of the collection account",
        userName: "Login user name",
        effectiveTime: "entry-into-force time",
        expireTime: "Expiration time",
        accountName: "title of account",
        bankInstitutionDesc: "banking institution",
        remarks: "remarks",
        delConfig: "Are you sure you want to delete the current account",
        userParamsNull: "Login user account cannot be empty",
        isPercentageRulesPl: "Please select the type of percentage",
        isPercentageRulesError: "The type of percentage cannot be repeated",
        addSuccess: "Added successfully",
        mchLoginInfo: "Merchant login information",
        userParamsMax: "There can only be one login user, please delete the redundant one",
        mchDetails: "Merchant details",
        upDetails: "Modify merchant",
        add: "add",
        rolePkIdPl: "Please select a role",
        expireTimePl: "Please select the effective date first",
        expireTimeError: "Cannot be less than effective date",
        userNameError: "repeat of user name",
        issueCardCode: "Customer code",
        fixedShare: "Fixed share",
        fixedShareText: "Divided by kWh",
        accountPl: "Please fill in account information",
        invoiceType: "Invoice Type",
        hasOpenAudit: "Enable invoice review",
        open: "open",
        close: "close",
        invoiceSet: "Invoice Setting Information",
        invoiceTypePl: "Please select invoice type",
        hasOpenAuditPl: "Please choose whether to turn it on or not",
        settlementType: "Classification Rule Type",
        wxMerchantName: "WeChat Collection Merchant Name",
        wxMerchantAccount: "WeChat collection merchant account",
        wxMerchantNamePl: "Please enter",
        wxMerchantAccountPl: "Please enter",
        password: "password",
    },
    // 新增设备生产商信息
    addProducer: {
        busLicenseNumberPl: "Please enter the business license number",
        busLicenseNumberError: "The length of business license number is 18 digits",
        brandNamePl: "Please enter the brand name",
        manufacturerNamePl: "Please enter the equipment manufacturer",
        manufacturerIdPl: "Please enter the organization code of the equipment manufacturer",
        manufacturerIdError: "The length of business license number is nine digits",
        legalPersonPl: "Please enter company legal person",
        legalIdCardPl: "Please input ID card",
        legalIdCardError: "The length of corporate ID card is 18 digits",
        contactNamePl: "Please enter contact",
        contactName: "contacts",
    },
    // 新增设备型号
    addEquipmentModel: {
        typeInfo: "Model information",
        deviceType: "Equipment type",
        deviceModelName: "Equipment model",
        name1: "Standard configuration",
        name2: "Optional",
        manufacturerInfo: "Manufacturer information",
        optionalAdd: "Optional new items",
        manufacturerPkId: "Name of manufacturer",
        optionName: "Option name",
        remark: "Option description",
        addDevType: "Add device model",
        deviceModelNamePl: "Please enter the device model",
        manufacturerPkIdPl: "Please select manufacturer name",
        optionNamePl: "Please enter an option name",
        isChecked: "Is it standard",
        optionValue: "Fixed value",
        valueNull: "Value cannot be empty",
        valueError: "The value can only be positive",
        detailsTitle: "Equipment model details",
        upTitle: "Modify equipment model",
        addTitle: "New equipment model",
        addSplitPile: "Add split device model",
        delDevType: "Delete device model",
        outPutRange: "Output range",
    },
    // 短信购买
    msgBuy: {
        step: "Step analysis",
        step1: "The first step",
        step1Text: "Number of items to be purchased",
        step2: "Step two",
        step2Text: "Add recharge contact wechat and note information",
        step3: "The third step",
        step3Text: "Submit purchase",
        step4: "Step four",
        step4Text: "Payment, completion of purchase",
        note: "Note:",
        note1: "Return is not supported after SMS purchase;",
        note2: "There is no expiration limit for SMS;",
        note3: "Currently, docking with other SMS providers is not supported;",
        note4: "If the number of text messages is within 70 words, it shall be charged according to one SMS;",
        note5: "If the billing item is sent successfully, the failure of sending is not included.",
        remainder: "Current number",
        comboPkId: "Number of items purchased",
        paymentAmount: "Payment amount (yuan)",
        purchasedWay: "Payment method",
        remark: "remarks",
        tips: "After filling in the information, dial the mobile phone number of the recharge contact below or add wechat to contact the background to recharge. Online purchase is not supported for the time being.",
        rechargeContact: "Recharge contact",
        contactPhone: "Contact mobile number",
        qrCodeFileUrl: "Contact wechat",
        contactTips: "Add wechat, please note the name of the operator, so that the back office staff can quickly find the recharge order. Support online purchase.",
        purchasedWayPl: "Please choose the payment method",
        purchasedCountPl: "Please select the number of items to purchase",
    },
    // 余额提醒
    balanceReminderPage: {
        triggerValue: "Balance reminder",
        triggerValueTips: "Account balance below",
        triggerValueTips2: "Yuan, send the notification.",
        sendWays: "Notification method",
        sendWaysTips: "Official account notification",
        triggerVTips2: "SMS notification",
        wxTpl: "Official account template detection",
        msgTpl: "SMS template detection",
        configured: "Configured",
        noConfigured: "not configured",
        noTips: "No SMS template detected, please contact the platform service provider for configuration",
        wxMessage: "Official account notification",
        msgMessage: "SMS notification personnel",
        phoneTips: "Enter the mobile phone number, and separate the numbers with",
        sendWaysPl: "Please select notification method",
        phonePl: "Please enter the number",
        phoneError: "Wrong number format, separated by ','",
        phoneMax: "The number cannot exceed 5 groups",
        openFunctionality: "Open functionality",
        open: "open",
        close: "close",
        time: "Reminder Time",
        timePl: "Please select a time",
        timeError: "Time repetition, please reselect",
    },
    // 互联互通
    interflowListSend: {
        operatorId: "Organization structure code",
        projectName: "entry name",
        systemName: "System name",
        protocolPkId: "Protocol primary key",
        phoneNo: "contact information",
        contactName: "contacts",
        netDriection: "Interworking direction",
        netType: "Interworking type",
        beginTime: "Internet start date",
        endTime: "Interconnection end date",
        netFileUrl: "enclosure",
        upload: "Upload file",
        reason: "Reasons for application",
        tab1: "essential information",
        tab2: "Platform key",
        tab3: "Carrier key",
        addInterflow: "New interconnection",
        reasonPl: "Please input the reason for application",
        netDriectionPl: "Please choose the direction of interchange",
        netTypePl: "Please select interworking type",
        beginTimePl: "Please select start time",
        endTimePl: "Please select the end time",
        netFileUrlPl: "Please upload the attachment",
        protocolPkIdPl: "Please enter agreement primary key",
        upInterflow: "Modification of interconnection",
        detailsInterflow: "Interconnection details",
        aesDataSecret: "Data encryption key",
        aesDataSecretIV: "Initialization vector",
        operatorSecret: "Carrier key",
        sigSecret: "Signature key",
        requestUrl: "Request platform address",
        rechargeAmount: "Recharge amount (yuan)",
        rechargeSuccess: "Recharge success",
        refundAmount: "Refund amount (yuan)",
        refundBtn: "refund",
        refundError: "The refund amount cannot exceed the account balance",
        refundSuccess: "Refund successful",
        refundOrderNo: "order number",
        balance: "Account balance",
        governmentPush: "Push charging data",
        governmentPushPl: "Please select push charging data",
    },
    // 互联互通-- 资金记录
    interflowRecord: {
        tab1: "Charge",
        tab2: "Recharge",
        tab3: "Refund",
        accountPkId: "Account number",
    },
    // 互联互通-- 对账单
    interflowBill: {
        abnormal: "Push results",
        queryDetails: "detailed",
        errorOrder: "Abnormal order",
        normal: "normal",
        error: "abnormal",
        beginTime: "Billing start time",
        endTime: "Billing end time",
        orderNumber: "Number of orders",
        totalChargeElect: "Total electricity (KWH)",
        totalAmount: "Total amount (yuan)",
        abnormalNumber: "Number of abnormal orders",
        abnormalAmount: "Abnormal order amount (yuan)",
        checkingResult: "Check the results",
        reset: "reset",
        diffContent: "Reasons for dispute",
        tab1: "Account Statement",
        tab2: "Statement details",
    },
    // 修改接口会员
    interfaceMemberUp: {
        operatorSecret: "Platform key",
        systemName: "Interface user name",
        protocolPkId: "Protocol primary key",
        phoneNo: "contact information",
        contactName: "contacts",
        netFileUrl: "enclosure",
        upload: "Upload file",
        reason: "Reasons for application",
        reasonPl: "Please input the reason for application",
        netFileUrlPl: "Please select attachment",
        protocolPkIdPl: "Please enter agreement primary key",
        operatorIdPl: "Please enter the organization code",
        operatorIdError: "Please enter 9-digit organization code",
        detailsTitle: "Interface member details",
        updataTitle: "Modify interface member",
        addTitle: "Add interface members",
        rechargeAmount: "Recharge amount (yuan)",
        rechargeSuccess: "Recharge success",
    },
    // 修改接口会员
    interfaceMemberRecord: {
        tab1: "Charge",
        tab2: "Recharge",
        accountPkId: "Account number",
    },
    // 第三方服务申请开通
    addThirdPartyServices: {
        tab1: "essential information",
        tab2: "Third party platform secret key",
        platformType: "Platform type",
        protocolPkId: "agreement",
        contactName: "contacts",
        phoneNo: "contact information",
        attachmentPkId: "enclosure",
        uploadBtn: "Upload attachment",
        remarks: "remarks",
        attachmentPkIdPl: "Please upload the attachment",
        platformTypePl: "Please select platform type",
        protocolPkIdPl: "Please select agreement",
        remarksPl: "Please enter your comments",
        platformId: "Third party platform ID",
        aesDataSecret: "Encryption key",
        aesDataSecretIV: "Encryption initialization vector",
        appSecret: "Platform voucher",
        sigSecret: "Signature key",
        requestUrl: "Request platform address",
        requestUrlPl: "Please enter the platform address",
        protocolType: "agreement type",
        protocolTypePl: "Please enter the protocol type: https://, http:// or other",
        platformNamePl: "Please enter the name of the third party service provider",
        couponType: "Coupon type",
        couponTypeNo: "nothing",
        couponValueUnit: "minute",
        couponValueUnit2: "yuan",
        couponValueNull: "Please enter a value",
        couponValueError: "Please enter a number greater than or equal to 0",
        couponValueTimeMax: "Time cannot be greater than 5000",
        couponValueNumber: "Please enter the correct number without decimal",
        couponValueMomeyMax: "Amount cannot be greater than 5000",
        couponValueMoneyTow: "The amount can be kept to two decimal places at most",
        couponValueDisMax: "The discount cannot be greater than 100. 0 means free",
        couponValueDisOne: "The discount can be kept to one decimal place at most",
        invoiceOpenType: "Invoice invoicing type",
        invoiceOpenTypePl: "Please select an invoice invoicing type",
        hasOpenFreeHours: "Open free time slot",
        freeBeginHours: "Free start time",
        freeEndHours: "Free End Time",
        policyConfig: "Policy Configuration",
        parkingReductionRule: "Parking barrier reduction and exemption rules",
        dcPileChargingReduction: "DC pile charging amount push reduction",
        acPileChargingReduction: "Communication pile charging volume push reduction",
        dcPileChargingTimeReduction: "DC pile charging duration reduction push",
        acPileChargingTimeReduction: "Communication pile charging time reduction push",
        chargeUnit: "kW·h",
        inputEnterTip: "Please enter a positive integer.",
        minDcCharge: "DC pile charging capacity ≥",
        minDcChargeMinutes: "Charging duration of DC pile ≥",
        minAcCharge: "Charging capacity of communication piles ≥",
        minAcChargeMinutes: "Charging duration of communication piles ≥",
        pushReduction: "Push exemption",
    },
    // 新增提现单
    addwithdrawal: {
        cashInfo: "Withdrawal information",
        cashTime: "Withdrawal period",
        settlementBtn: "settlement",
        cashTimeBtn: "Withdrawal date",
        currentChargeAmount: "Current charge amount",
        transactionServiceAmount: "Current service charge",
        transactionDelayAmount: "Current delay fee",
        oprShare: "Operator share",
        serviceCharges: "Service Charge",
        transferAmount: "Actual withdrawal amount",
        account: "Collection account",
        contacts: "contacts",
        telephone: "contact number",
        bankAccountName: "title of account",
        bankDeposit: "Bank of deposit",
        bankAccountNo: "bank account",
        recordStatus: "Add withdrawal",
        recordStatus1: "Prepare payment",
        recordStatus2: "Complete payment",
        recordStatus3: "Aborted",
        timePl: "Please select a time",
        merchantPkIdPl: "Please select a merchant",
        settlementError: "Abnormal settlement",
        settlementNo: "Unsettled",
        settlementYes: "Withdrawal",
        settlement: "Withdrawable",
        paying: "In payment",
        handleTitle: "Processing progress",
        moneyTips: "Maximum amount to two decimal places",
    },
    // 提现单模板
    withdrawalTemplate: {
        title: "Cost Settlement Sheet of Cooperative Operation Charging Station",
        settlementTime: "Settlement cycle",
        settlementTips: "Note: According to the cooperation agreement between both parties, the operator's share ratio is as follows:",
        settlementTips1: "The withdrawal fee is {serviceChargeFee} of the final withdrawal amount (final withdrawal amount=total revenue amount - operator share)",
        // settlementTips1:
        //   " yuan,According to the cooperation agreement, Party A shall pay Party B a share fee of",
        // settlementTips2: ",Total to be settled",
        number: "Serial No",
        tableProject: "project",
        tableMoney: "amount of money",
        transactionChargeAmount: "Electric charge amount",
        transactionDelayAmount: "Amount of pile cost",
        transactionServiceAmount: "Service charge amount",
        oprShare: "Operator share",
        serviceCharges: "Service Charge",
        transferAmount: "Total settlement",
        collectionInfo: "Collection information",
        MchSeal: "Merchant/individual name (seal)",
        oprSeal: "Operator name (seal)",
        download: "Download certificate",
        templateTime: "Preparation date",
        totalIncome: "Total income",
        remarks: "In summary, the total amount of charging income for this period is {currentChargeAmount} yuan, and {transferAmount} yuan should be paid to your company for the settlement of this period's income",
        delegate: "delegate",
        date: "date",
        company: "name",
        bank: "bank",
    },
    // 刷卡数据报表
    cardDataReport: {
        cardPkId: "Card membership number",
        totalGunNumber: "Gun count",
        totalAmount: "Cumulative total amount",
        totalChargingMinutes: "Cumulative charging time (minutes)",
        totalChargingTimes: "Cumulative charging times",
        totalElecAmount: "Cumulative charge",
        totalPower: "Cumulative charge",
        totalSeviceAmount: "Accumulated service charge",
        billGenerationDate: "Bill generation date",
        billCreateDate: "Report creation date",
    },
    // 短信条数充值
    msgRecharge: {
        notes: "notes:",
        notes1: "After recharging, the remaining number of SMS will be updated",
        notes2: "In order to ensure the normal sending and accurate counting of SMS, please make sure that Alibaba cloud has completed the SMS purchase while recharging the number here",
        remainder: "Current number",
        purchasedCount: "Number of recharge items",
        remark: "Remark",
        recharge: "Recharge",
        rechargeUnit: "strip",
        rechargeSuccess: "Recharge success",
    },
    //子菜单标题
    childMenuTitle: {
        // 短信服务
        msgBuy: "SMS purchase",
        msgRecharge: "Recharge the number of SMS",
        msgBuyRecordDetails: "SMS purchase detais",
        msgApplyInvoice: "Apply for invoice",
        msgPurchase: "SMS purchase",
        //接口会员
        interfaceRecharge: "Interface member recharge",
        interfaceAdd: "New interface members",
        interfaceUp: "Modify interface member",
        interfaceDetails: "Interface member details",
        interfaceRecord: "Interface member capital records",
        interfaceSite: "Interface member site",
        interfaceBalance: "Interface member balance reminder",
        // 结算订单补推订单
        supplementOrder: "Incremental order",
        // 第三方服务
        thirdPartyServicesAdd: "Third party service application",
        thirdPartyServicesUp: "Third party service editor",
        thirdPartyServicesDetails: "Third party service details",
        // 会员充值记录
        memberRechargeDetails: "Recharge record details",
        //退款记录
        refundRecordsDetails: "Refund record details",
        refundRecordsAudit: "Refund audit",
        refundRecordsManage: "Refund management",
        // 商户提现
        withdrawalTpl: "Withdrawal form template",
        addWithdrawal: "Add withdrawal",
        detailsWithdrawal: "Withdrawal details",
        // 导入信息存在错误
        importError: "Error importing information",
        accInfo: "account information",
        login: "login",
        // 互联互通
        interflowStaOpen: "Site opening management",
        interflowStaOpenDetail: "View details",
        interflowSend: "Initiate application",
        interflowUp: "Modification of interconnection",
        interflowDetails: "Interconnection view details",
        interflowBill: "Account Statement",
        interflowBalance: "Intercommunication balance reminder",
        interflowRecharge: "Interconnection recharge",
        interflowRecord: "Interconnection fund record",
        interflowRefund: "Refund for interconnection",
        // 会员列表
        memberDetails: "User details",
        memberRecharge: "Member recharge",
        memberRefund: "Member refund",
        memberImport: "Member import",
        memberBindCard: "Associated card",
        memberRecord: "member capital records",
        memberIntegral: "Adjustment of membership points",
        memberGrade: "Membership level adjustment",
        membershipCycle: "Membership cycle",
        // 企业会员
        corporateMemberRecharge: "Enterprise member recharge",
        corporateMemberDetails: "Details of corporate members",
        corporateMemberRecord: "Enterprise member fund record",
        corporateMemberEdit: "Edit corporate members",
        corporateMemberAdd: "Add corporate members",
        corporateMemberBind: "Binding site",
        corporateMemberMembers: "Enterprise members",
        corporateMemberHistory: "Enterprise members - History",
        membersBindCard: "Enterprise members-Binding card",
        membersAdd: "Add members",
        membersUp: "Modify members",
        membersCard: "Member license plate",
        corporateUserGroup: "Enterprise member user group",
        corporateUserGroupAdd: "Enterprise member user group - Add",
        corporateUserGroupUp: "Enterprise member user group - Modify",
        corporateUserGroupDetails: "Enterprise member user group - Details",
        corporateRefund: "Corporate member refund",
        corporateBalance: "Enterprise member balance reminder",
        enterpriseApplicationAudit: "Corporate membership audit",
        corporateMemberBindList: "Binding site",
        corporateMemberEntPayOrder: "Enterprise Payment Order",
        //注销会员
        cancellationMemberRecord: "Cancellation of membership/funding records",
        // 站点监控
        siteMonitorDetails: "Site Monitoring Details",
        siteMonitorGunDetails: "Site Monitoring/Pile Details",
        siteMonitorOper: "Site monitoring/operator",
        siteMonitorPileDetails: "Site Monitoring/Device Details",
        // 发票管理
        invoiceDetails: "Invoice details",
        invoiceAudit: "Invoice review",
        // 优惠券
        couponAdd: "Add coupons",
        couponDetails: "Coupon details",
        couponAddUp: "Modify coupons",
        couponAudit: "Check coupons",
        couponGrant: "Issue coupons",
        // 营销活动
        memberCouponAdd: "Add promotions",
        memberCouponUp: "Modify promotions",
        memberCouponAudit: "Audit promotions",
        memberCouponDetails: "Promotions details",
        memberCouponGrant: "Issue coupons for activities",
        // 系统公告
        noticeAdd: "Add system announcement",
        noticeDetails: "System announcement details",
        // 客户消息
        customerServiceReply: "Customer message reply",
        // 用户指南
        userGuideCatalog: "Directory management",
        userGuideCatalogAdd: "Add directory",
        userGuideCatalogUp: "Modify directory",
        userGuideArticleAdd: "Add article",
        userGuideArticleUp: "Modify article",
        // 非实名卡管理
        cardDetails: "Non real name card details",
        cardAdd: "Non real name card activate a bank card",
        cardRecharge: "Non real name card recharge",
        cardUp: "Non real name card editor",
        cardDel: "Cancellation of non real name card",
        cardHistory: "Non real name card-Operation record",
        cardFundHistory: "Non real name card-Capital records",
        cardRefund: "Non real name card refund",
        // 会员等级管理
        memberGradeAdd: "Add member level",
        memberGradeUp: "Modify membership level",
        memberGradeDetails: "Membership level details",
        memberGradeRecordDetails: "Level purchase record details",
        // 积分活动管理
        integralActivityAdd: "Add points activity",
        integralActivityUp: "Modify points activity",
        integralActivityDetails: "Details of the integral activity",
        integralRecordDetails: "Points exchange record details",
        integralAddRecordDetails: "Points growth record details",
        // 告警通知
        addAlert: "Add strategy",
        upAlert: "Modify strategy",
        detailsAlert: "Strategy details",
        // 设备生产商
        producerAdd: "Add equipment manufacturer information",
        producerUp: "Edit equipment manufacturer information",
        // 商户管理
        merchantUp: "Edit merchant",
        merchantAdd: "Add merchant",
        merchantDetails: "Merchant details",
        mchOperationLog: "Merchant Operation Log",
        // 运营商信息
        operInfoUpSys: "Modify system information",
        operInfoUp: "Basic information of operators",
        operInfoChargeConfig: "Charging service configuration",
        operInfoSoc: "Mobile customization",
        operInfoUpSafePassword: "Change operation password",
        operInfoUpSettlement: "Electronic invoice",
        operInfoUpBalance: "Balance reminder",
        invoiceSettings: "Invoice settings",
        invoiceSettingsPaper: "Paper Invoice Settings",
        // 设备型号
        equipmentModelAdd: "Add equipment model",
        equipmentModelUpdate: "Modify equipment model",
        equipmentModelDetail: "Equipment model details",
        //档案报告详情
        reportFileDetail: "report file details",
        // 订单列表
        chargeOrderDetail: "Order details",
        errorOrderDetail: "Exception details",
        abnormalOrder: "Abnormal processing",
        abnormalErrorOrder: "Abnormal processing ",
        offCardOrderDetails: "Offline card order details",
        reserveChargingOrderDetails: "Appointment Order Details",
        // 系统管理
        addRoleInfo: "Add role",
        permissionMune: "Permission configuration",
        updataRoleInfo: "Modify roles",
        detailsRoleInfo: "Role details",
        detailsEdit: "User details",
        permissionLog: "Operation Log",
        userEdit: "User editing",
        userAdd: "Add users",
        renewLogAdd: "Add update log",
        assignSta: "Assign site",
        // 首页桩
        homePileSta: "List of standing piles",
        homePileStaPile: "Details of station piling",
        // 站点列表
        siteDetails: "Site details",
        siteImportTable: "Site import",
        chargeStrategy: "Charging strategy",
        operSet: "Operation settings",
        phoneShow: "Value added services",
        allUpdatarate: "Batch replacement",
        addRateTemplate: "Bulk replacement charging rates",
        allUpdataRateChange: "Batch replacement delay rate",
        allUpdataReservation: "Reservation rate for batch replacement",
        eleListDetails: "Site electricity price details",
        updataRateTemplate: "Modify replacement strategy",
        detailsRateTemplate: "Replacement strategy details",
        pileChargingStrategy: "Orderly charging strategy",
        pileChargingStrategyGroups: "Ordered charging strategy grouping",
        // 站点列表
        editPiles: "Edit site",
        addPiles: "Add sites",
        allLineOffPile: "Batch go online / go offline",
        allBindPile: "Batch Association / unbinding",
        elePiles: "Tariff list",
        discountTerm: "Preferential scheme",
        pileAudit: "Site audit",
        editGun: "Editing gun",
        elePilesChargeRecord: "Rate Replacement Details",
        // // 桩列表
        detailsPile: "Pile details",
        editPile: "Edit pile",
        addPile: "Add pile",
        editElePile: "Edit tariff",
        siteDebug: "On site commissioning",
        pileAllUpdata: "Bulk editing",
        // 费率管理
        feePileDetail: "AC/DC charging rate",
        feeUsePileDetail: "Charge Point Rate",
        addFee: "Add rate",
        editFee: "Edit rate",
        delayFeeDetail: "Delay rate",
        countDetail: "Rate quantity used",
        feePageRecord: "Rate - Record",
        feeStationBatchChange: "Batch replacement rate",
        entFeeUpdata: "Rate modify",
        feeBindStation: "Bind Site",
        feeBindStationList: "Bind Site List",
        delayCountDetail: "Delay rate quantity used",
        delayFeeAdd: "Add delay fee",
        delayFeeUpdata: "Modify Delay Fee",
        feeDetails: "Rate Application Details",
        delayFeeDetails: "Delay rate Application Details",
        //预约费率
        addReservationRate: "Add reservation charging rate",
        updataReservationRate: "Modify reservation charging rate",
        detailsReservationRate: "Reservation charging Rate Details",
        reservationRateCount: "Reservation charging Rate Usage Site",
        // 电池管理
        batteryTestDetails: "Report Details",
        // 有序充电
        qrderlyChargingCount: "Number of power sharing strategy applications",
        qrderlyChargingAdd: "Add power sharing strategy",
        qrderlyChargingUpdata: "Updata power sharing strategy",
        qrderlyChargingFirstComeCount: "Number of first come, first charge policy applications",
        qrderlyChargingFirstComeAdd: "Add a first come, first charge strategy",
        qrderlyChargingFirstComeUpdata: "Updata a first come, first charge strategy",
        qrderlyChargingFirstComeDetails: "Strategy Details",
        qrderlyChargingFirstComeDetails2: "Strategy Details ",
        qrderlyChargingFirstComeBindSta: "Associated Sites",
        qrderlyChargingFirstComeBindSta2: "Associated Sites ",
        //余额提醒
        balanceReminderEntBindCount: "Enterprise User Association",
        balanceReminderThirdPartyCount: "Third party user association",
        addBalanceReminder: "Add Balance Reminder",
        balanceReminderUpdataRecord: "Modify Record",
        updataBalanceReminder: "Modify Balance Reminder",
        detailsBalanceReminder: "Balance reminder details",
        // SIM卡管理
        editSim: "Edit SIM card",
        detailsSim: "SIM card details",
        addSim: "Add SIM card",
        //平台通知
        platformNotice: "Platform Notification",
        platformNoticeDetails: "Platform Notification Details",
        pilePower: "Station pile group",
        // 结算概览
        settlementOverviewDetails: "Merchant Settlement Overview",
        //积分商城
        addCommodity: "add goods",
        updataCommodity: "updata goods",
        detailsCommodity: "goods details",
        commodityOrderDetails: "Product order details",
        mallConfigAdd: "add address",
        mallConfigUpdata: "updata address",
        businessConsulting: "Business consulting",
        // 经营分析-站点排行
        siteRankingTotalRevenue: "Revenue ranking",
        siteRankingDfRevenue: "Ranking of electricity revenue",
        siteRankingServerRevenue: "Ranking of service fee revenue",
        siteRankingDelayRevenue: "Revenue ranking of delay fee",
        siteRankingChargeOrder: "Ranking of charging order quantity",
        siteRankingChargeTime: "Ranking of charging duration",
        siteRankingChargeUtilizationRate: "Ranking of charging utilization rate",
        siteRankingChargeUtilization: "Ranking of charging utilization",
        siteRankingChargeDlTable: "Charging capacity ranking details",
        siteRankingChargeDlTableSharp: "Ranking of sharp charging amount",
        siteRankingChargeDlTablePeak: "Ranking of peak charging amount",
        siteRankingChargeDlTableFlat: "Ranking of flat charging amount",
        siteRankingChargeDlTableValley: "Ranking of valley charging amount",
        siteRankingRevenue: "Revenue ranking",
        siteRankingCharging: "Charging capacity ranking",
        siteAnalysisDetails: "Single site analysis details",
        userRankingMore: "Ranking of total revenue of individual users",
        singleUserDetails: "Details of single user analysis",
        //站点建设排名
        siteRankingPile: "Ranking of charging pile construction",
        siteRankingGun: "Ranking of charging gun construction",
        siteRankingPower: "Rated power construction ranking",
        // 充值及账户配置
        rechargeConfig: "Recharge amount limit configuration",
        rechargeConfigDetails: "Recharge amount limit details",
        accountConfig: "Account limit configuration",
        accountConfigDetails: "Account limit details",
        cashRechargeConfig: "Cash Recharge Audit Configuration",
        cashRechargeConfigDetails: "Details of cash recharge audit configuration",
        //地锁
        addFloorLock: "Add ground lock",
        editFloorLock: "Modify floor lock",
        configFloorLock: "Config ground lock",
        // 核算
        rechargeCheckingCorrect: "Recharge correction",
        refundCheckingCorrect: "Refund correction",
        merchantSharingErrorInfo: "Settlement anomaly",
        //费率策略
        feePageUseNum: "Rate usage quantity",
        feePagePendingNum: "Quantity to be issued",
        feePagePendingFee: "Pending effective rate",
        //预约占桩费率
        reservationRateDistribution: "Distribute reservation rates",
        reservationRateRecord: "Reservation rate modification record",
        //占桩费率
        delayRateDistribution: "Issue pile occupancy rate",
        delayRateRecord: "Modification record of pile cost",
        qrderlyChargingOperationRecord: "Power sharing strategy operation record",
    },
    //  全局纵览
    overview: {
        timeMonth: "Start month",
        allClose: "Fold all",
        allOpen: "expand all",
        time: "current date",
        scaleDay: "Scale (day)",
        orderMoney: "Order amount",
        totalOrder: "Total orders",
        orderUnit: "order",
        normalOrder: "Normal order quantity",
        abnormalOrder: "Abnormal order quantity",
        chargingDegree: "Charging degree",
        supplyDay: "Supply (day)",
        onlineSta: "Number of online charging stations",
        onlineGun: "Number of online charging guns",
        userDay: "User (day)",
        userNum: "Number of daily active users",
        efficiencyDay: "Efficiency (day)",
        gunEle: "Single shot single quantity",
        gunServer: "Single gun service fee",
        utilization: "Utilization rate",
        maintenanceDay: "Operation and maintenance (day)",
        abnormalRate: "Abnormal rate",
        experienceDay: "Experience (day)",
        utilizationRate: "Utilization rate",
        gunUnit: "",
        formTimeType1: "By day",
        formTimeType2: "Total by week",
        formTimeType3: "Monthly total",
        timeError: "Time error",
        day: "day-to-day",
        week: "week-to-week",
        month: "month-on-month",
        orderMoneyValue: "Order amount paid",
        eleFeeValue: "Electricity bills paid",
        serverFeeValue: "Service fee paid",
        delayFeeValue: "Delay Fee Paid",
        totalOrderValue: "Paid + number of abnormal orders",
        normalOrderValue: "Quantity of paid orders",
        abnormalOrderValue: "The number of abnormal orders",
        chargingDegreeValue: "The degree of charge for a normal order",
        onlineStaValue: "Number of charging stations online",
        onlineGunValue: "Number of charging guns online",
        userNumValue: "Users who have successfully charged",
        gunEleValue: "Normal order quantity of charging guns/Number of charging guns online",
        gunServerValue: "Online charging gun service fee daily turnover/number of online charging guns",
        utilizationValue: "The sum of the power of the charging pile/(the sum of the power of the charging pile*24h)",
        abnormalRateValue: "Abnormal orders/total orders",
        utilizationRateValue: "The total charging time of the online charging gun/the total charging time of the online charging gun",
    },
    // 站点列表 -- 运营设置
    operSet: {
        tabCard: "Designated card member number",
        inputCard: "(Please enter a non real name online card number)",
        inputPhone: "(Please enter the user's mobile phone number)",
        tabUser: "Designated user",
        tab1: "Card swiping charging strategy",
        tab2: "Code scanning charging strategy",
        tab3: "Enterprise member charging strategy",
        tab4: "Interconnection charging strategy",
        tab5: "Interface member charging strategy",
        tab6: "SOC charging strategy",
        tab7: "Vehicle Information Strategy",
        closedSoc: "SOC constant stop charging",
        closedSocTips: "SOC constant stop function switch. If the setting is closed, the SOC setting function is hidden at the mobile end, and the SOC function is restored after it is turned on.",
        defaultSoc: "SOC default (%)",
        socSetTitle: "SOC Overall Strategy Configuration",
        defaultSocTips: "Configure the default setting value of the SOC of the mobile terminal. If the user does not set the SOC value, use this setting value to charge. The default setting value is 98%. To prevent accidental overcharge, set the default value carefully",
        defaultSocTips2: "The default value has reached 100%. After the actual charging exceeds 98%, charging is only allowed for 5 minutes. Please set it carefully",
        floorSoc: "SOC lower limit (%)",
        floorSocTips: "The lower limit value set by SOC at mobile terminal is between 10% and 80% by default",
        defaultSocPl: "Please enter a default value",
        defaultSocMax: "The default value cannot be more than 100",
        defaultSocMin: "The default value must be an integer greater than 0",
        floorSocPl: "Please enter the lower limit value",
        floorSocMax: "The lower limit value cannot be more than 100",
        floorSocMin: "The lower limit value must be an integer greater than 0",
        pileList: "Pile list",
        status: "Strategy switch",
        statusTips: "Note: the card swiping strategy is only effective for non real name online cards. The charging cards associated with code scanning members belong to real name online cards and do not belong to the scope of this strategy",
        time: "time interval",
        name: "name",
        namePl: "Please enter a name",
        remark: "remarks",
        remarkPl: "Please enter comments",
        openTime: "Opening Hours",
        accountPl: "Please enter the user's registered mobile phone number. Multiple mobile phone numbers are separated by commas. If no member is specified, all members will take effect",
        accountCardPl: "Please enter the electric card member number. Multiple electric card member numbers are separated by commas. If no member is specified, all members will take effect",
        account: "Designated account",
        sys: "Designated system",
        pile: "Specify the pile",
        select: "select",
        pilePl: "Please enter the pile number. Multiple pile numbers are separated by commas. If no equipment is specified, all equipment will take effect",
        addTime: "Add time",
        statusPl: "Please select enable policy",
        entName: "Enterprise name",
        accountPkId: "Account number",
        sysName: "System name",
        sysId: "System ID",
        interfaceName: "Interface user name",
        import: "Import",
        importTmp: "Specify user import template",
        explain: "explain",
        explain1: "1. The policy enables the mode of open time, that is, after the time is set, only the specified users or all users are allowed to charge in this time period and under this pile",
        explain2: "2. If you want all users to take effect in this period, all members will take effect without adding designated members",
        example: "Strategy example",
        exampleText: "example",
        requireLicPlateNo: "Charging requires license plate",
    },
    // 登录
    login: {
        contentTitle: "Charging for a better life",
        contentTitleSmall: "Access to the open platform, and the interconnection ecology is clear at a glance",
        account: "Account login",
        userNamePl: "enter one user name",
        passwordPl: "Please input a password",
        passwordMax: "Please enter a password with more than 6 digits",
        userName: "user name",
        password: "password",
        login: "login",
    },
    //验证码
    inputCode: {
        getCode: "Get verification code",
        phonePl: "Please enter the phone number in the correct format",
        sendSuccess: "Sent successfully",
        send: "Send again",
    },
    // 车牌库
    licensePlateLibrary: {
        pageTitle: "license plate library",
        userType: "user type",
        entName: "Company Name",
        userName: "Member name",
        phone: "Member cell phone",
        carNo: "number plate",
        vin: "VIN code",
        createTime: "create time",
    },
    // 平台通知
    platformNotice: {
        title: "title",
        publishTime: "publish time",
        read: "read",
    },
    // 站点功率统计
    pilePower: {
        staName: "Pile group name",
        operationTypeName: "Business type",
        totalPileQuantity: "total",
        totalPower: "Total power",
        totalGunQuantity: "Number of guns",
        staPilePower: "Pile pile power",
    },
    // 结算概览
    settlementOverview: {
        dlTotal: "Electricity summary (KWH)",
        amount: "Amount to be settled",
        settledAmount: "Settled amount ",
        operDivide: "Operator share",
        withdrawnAmount: "Withdrawn amount",
        undrawnamount: "Undrawn amount",
        mchPl: "Merchant name / abbreviation",
        mchName: "Merchant name",
        orderNumber: "Number of settlement orders",
        orderDl: "Settlement order quantity (KWH)",
        settlementTime: "Settlement time",
        exportName: "Billing overview",
        merchantTotal: "Total merchants",
        numOfPercentMerchant: "Percentage sharing merchant",
        fixedShare: "Fixed share merchant",
        oprTotal: "Operator's share (yuan)",
        settlementYear: "Settlement year",
        shareType: "Classification type",
        actionQuery: "details",
        percentage: "percentage",
        mchIfo: "Merchant information",
        ruleDetails: "Split Details",
        detailsTitle: "Settlement overview",
        unsettled: "unsettled",
        settled: "settled",
        reportDate: "Settlement month",
        settleTotalOrder: "Settlement order",
        settleTotalElectricity: "Power(kWh)",
        chargePayableAmount: "Charging amount payable(yuan)",
        discountAmount: "Discount amount(yuan)",
        paidChargeAmount: "Paid charging amount(yuan)",
        merchantIncomeAmount: "Merchant income amount(yuan)",
        status: "Settlement status",
    },
    // 商户报表
    merchantReport: {
        yearReport: "annual report",
        monthReport: "monthly report",
        mchName: "Merchant name",
        devNum: "Number of equipment",
        reportYear: "report year",
        totalDl: "Total power (KWH)",
        totalAmount: "Income amount",
        electricFee: "electricity fees",
        serviceFee: "Service charge (yuan)",
        delayFee: "Delay fee (yuan)",
        operDivide: "Operator share",
        reportMonth: "Report month",
        monthDetails: "details",
    },
    // 账号信息
    accountInfo: {
        userName: "Login account",
        roleName: "Role",
        fullName: "Name",
        effectiveTime: "Effective time",
        loginRecord: "Log in for the last seven days",
        logintime: "Log in time",
        resultDesc: "Operation details",
        loginIp: "Login IP",
    },
    // 时间
    timeObj: {
        "0": "Sunday",
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday",
        earlyMorning: "early morning",
        morning: "morning",
        noon: "noon",
        afternoon: "afternoon",
        night: "night",
    },
    // 商城商品
    commodity: {
        superior: "put on sale",
        down: "pull off shelves",
        addNum: "add",
        reduceNum: "reduce",
        changeDetails: "Exchange details",
        superiorConfirm: "Are you sure you want to list the item??",
        downConfirm: "Are you sure you want to remove the item??",
        numPl: "Please enter quantity",
        num: "quantity",
        allAddNum: "Bulk replenishment",
        allReduceNum: "Bulk reduction",
        globalSearch: "product name",
        productType: "Product Types",
        stockStatus: "stock status",
        productStatus: "product status",
        productName: "product name",
        pictureUrl: "Thumbnail",
        price: "Point price",
        discountRatio: "Discount ratio",
        stock: "Inventory (pieces)",
        purchaseLimit: "Purchase limit",
        effectiveStartTime: "valid time range",
        redeemed: "Amount redeemed",
        // 添加
        productNamePl: "Please enter product name",
        productTypePl: "Please select a product attribute",
        pricePl: "Please enter the unit price",
        discountRatioPl: "Please enter a discount",
        discountRatioYes: "with discount",
        discountRatioNo: "no discount",
        stockPl: "Please enter stock",
        listed: "Is it on the shelf",
        desc: "product description",
        picturePl: "Please upload a thumbnail",
        descPl: "Please enter product description",
        exCompany: "courier company",
        exCompanyPl: "Please select a courier company",
        exOrderNo: "tracking number",
        exOrderNoPl: "Please enter the courier number",
        shipBtn: "Confirm delivery",
        shipTitle: "Express delivery",
        shipConfirm: "Are you sure you want to ship?",
        precise0: "fuzzy query",
        precise1: "Exact query",
        imgTips: "Note: The image size is less than 5M, the recommended size is: 680 * 600",
        adjustTitle: "adjusting inventory",
        adjustType: "Adjustment Type",
        adjustNum: "Adjust quantity",
    },
    //商城订单
    mallOrder: {
        globalSearch: "order number",
        telephone: "phone number",
        deliveryMethod: "Exchange method",
        orderStatus: "Order Status",
        exchangeTime: "Exchange time",
        deliveryTime: "delivery time",
        completeTime: "Complete time",
        delivery: "delivery",
        orderNo: "order number",
        createUserName: "Nickname",
        paymentMethod: "payment method",
        discountPoints: "activity unit price",
        quantity: "Exchange quantity",
        paymentPoints: "Pay points",
        totalOrder: "Total number of orders (pen)",
        discount: "with or without discount",
        address: "Shipping address",
        contacts: "Receiver",
        contactsPhone: "contact number",
        expressOrderNo: "tracking number",
        exportName: "Mall order",
        receipt: "Receipt",
        receiptConfirm: "Are you sure the user has received the item?",
        pickUpCode: "Pickup code",
        pickUpCodePl: "Please enter the pickup code",
        orderInfo: "order information",
        deliveryInfo: "delivery information",
        pickUpInfo: "Self-provided information",
        statisticsTime: "Time",
    },
    // 商城配置
    mallConfig: {
        tab1: "Delivery Address",
        tab2: "stock status",
        tab3: "mall switch",
        disable: "disable",
        enable: "enable",
        regionName: "Province, city/county",
        address: "Pick up address",
        contacts: "contact",
        contactsPhone: "contact number",
        status: "address status",
        disableConfirm: "Are you sure you want to deactivate this address?",
        enableConfirm: "Are you sure you want to enable this address?",
        addressDetails: "Address",
        regionId: "district belong to",
        regionIdPl: "please select the region",
        addressPl: "Please enter address",
        mallStatus: "Mall status",
        mallSwitch: "Points mall switch",
        open: "open",
        close: "close",
        mallStatusPl: "Please select a status",
        limitStatus: "Current inventory display status",
        limit: "in stock",
        limitPl: "Please enter stock",
        limitStatus1: "Inventory",
        limitStatusValue1: "Inventory > 50",
        limitStatus2: "Low Inventory",
        limitStatusValue2: "0 < Inventory ≤ 50",
        limitStatus3: "Low Inventory",
        limitStatusValue3: "Inventory = 0",
        openDeliveryAddress: "Shopping Mall Shipping Address",
        openMallOrder: "Mall orders",
        openDeliveryAddressPl: "Please select whether to open the shipping address of the mall",
        openMallOrderPl: "Please choose whether to open a mall order",
    },
    businessConsulting: {
        search: "Phone/nickname",
        consultStatus: "Status",
        consultType: "Business type",
        updata: "Mark read",
        fullName: "User's Nickname",
        contactPhone: "Contact number",
        content: "Content",
        createTime: "Create time",
        modifyUserName: "Operator",
        upConfirm: "Are you sure you want to mark as read?",
        exportName: "Business Consulting",
    },
    //会员注销
    memberCancellation: {
        globalSearch: "Member name/mobile phone number",
        logoutTime: "logout time",
    },
    // 费率明细
    releaseDetailsRate: {
        syncMode: "Delivery type",
        syncStatus: "Deliver results",
        userName: "Operator",
        syncTime: "Delivery time",
    },
    releaseDetailsQrCode: {
        syncStatus: "deliver results",
        checkStatus: "Check result",
        allCheck: "Batch check",
        check: "Check",
        userPkId: "Operator",
        syncTime: "Delivery time",
        checkSuccess: "The verification has been issued, and the verification can be successful after waiting for the reply of the pile",
    },
    // 营收分析
    analysisIncome: {
        totalIncome: "Total revenue analysis",
        serviceIncome: "Service fee revenue analysis",
        elecIncome: "Analysis of electricity revenue",
        delayIncome: "Revenue analysis of delay fee",
        totalAmount: "Total amount receivable",
        totalAmount2: "Total amount receivable",
        totalSeviceAmount: "Service fee receivable",
        totalElecAmount: "Electricity receivable",
        totalDelayAmount: "Receivable delay fee",
        totalSumDiscount: "Total discount",
        totalSumDiscount2: "Total discount",
        totalServiceDiscount: "Service fee discount",
        totalChargeDiscount: "Electricity discount",
        totalDiscount: "Total discount",
        totalTransAmount: "Total amount received",
        totalTransAmount2: "Total amount received",
        totalTransSeviceAmount: "Service charge received",
        totalTransElecAmount: "Received electricity charge",
        totalTransDelayAmount: "Delay fee received",
        delayDiscount: "Discount for delay fee",
        receivableRatio: "Ringgit receivable(%)",
        incomeRatio: "Received ringgit(%)",
        discountRatio: "Offers ringgit(%)",
        receivableBasis: "Receivables year-on-year(%)",
        incomeBasis: "Actual receipts year-on-year(%)",
        discountBasis: "Year-on-year offers(%)",
        totalIncomeTitle: "Total revenue",
        serviceIncomeTitle: "Service fee revenue",
        elecIncomeTitle: "Electricity revenue",
        delayIncomeTitle: "Delay fee revenue",
        incomeRatioTitle: "Received ringgit",
        incomeBasisTitle: "Actual receipts year-on-year",
        receivableProportionTitle: "Proportion of receivables",
        incomeProportionTitle: "Proportion of paid in",
        discountProportionTitle: "Preferential ratio",
        seviceTimeTitle: "Service fee revenue of each period",
        seviceReceivableProportionTitle: "Proportion of service fee receivable",
        seviceIncomeProportionTitle: "Percentage of service fee paid in",
        seviceDiscountProportionTitle: "Percentage of service fee concessions",
        elecTimeTitle: "Electricity revenue of each period",
        elecReceivableProportionTitle: "Proportion of electricity charges receivable",
        elecDiscountProportionTitle: "Proportion of preferential tariff",
        elecIncomeProportionTitle: "Percentage of electricity charge actually received",
        jian: "sharp period",
        feng: "peak period",
        ping: "flat period",
        gu: "valley period",
        incomeTitle: "net receipts",
        discountTitle: "discount",
        receivableTitle: "receivable",
        incomeMoeny: "net receipts(RMB)",
        discountMoney: "discount(RMB)",
        receivableMoney: "receivable(RMB)",
        money: "RMB",
    },
    // 账户配置
    accountConfig: {
        titleRecharge: "Recharge amount limit configuration",
        titleAccount: "Account limit configuration",
        titleCashRecharge: "Cash Recharge Audit Configuration",
        hasOpenCashAuditName: "Cash Recharge Audit Configuration",
        configName: "Config name",
        config: "set up",
        hasOpenCashAudit: "Cash recharge audit switch",
        hasOpenCashAuditAll: "Whether all recharge amounts need to be approved",
        hasOpenCashAuditAllPl: "Please select",
        cashAuditLeast: "Minimum Recharge Audit Amount",
        accountMaxTips: "The maximum account balance is ",
        rechargeMaxTips: "The maximum amount of a single recharge cannot exceed",
        rechargeMax: "Maximum recharge",
        hasOpenRechargeAmountLimit: "Recharge amount limit",
        singleRechargeAmount: "The maximum amount of a single recharge is",
        singleRechargeAmountName: "Set Amount",
        applicationChannel: "Application channel",
        applicationChannelPl: "Please select an application channel",
        applicationChannelName0: "Cash recharge",
        applicationChannelName1: "Online recharge",
        hasOpenAccountLimit: "Account limit",
        personalAccountLimit: "Maximum limit of individual account",
        entUserAccountLimit: "Enterprise account ceiling",
        accountMaxError: "The sum of the current account balance and the amount to be reviewed has exceeded the maximum limit and cannot be recharged temporarily",
        chargeAmountConfig: "Allocation of recharge amount limit",
        accountMaxConfig: "Account limit configuration",
        cashAuditConfig: "Cash Recharge Audit Configuration",
    },
    // 站点排名
    siteRankingPage: {
        tabIndex: "ranking",
        titleRevenue: "Revenue ranking",
        titleCharge: "Charging capacity ranking",
        titleOrder: "Ranking of charging order quantity",
        titleDuration: "Ranking of charging duration",
        titleRatio: "Ranking of charging utilization rate/ utilization",
        titleUtil: "Ranking of charging utilization",
        titleService: "Ranking of service fee revenue",
        titleElec: "Analysis of electricity revenue",
        titleDelay: "Revenue analysis of delay fee",
        titleChargeSharp: "Ranking of sharp charging amount",
        titleChargePeak: "Ranking of peak charging amount",
        titleChargeFlat: "Ranking of flat charging amount",
        titleChargeValley: "Ranking of valley charging amount",
        totalRevenue: "Total amount received(yuan)",
        totalCharge: "Total charge(kWh)",
        totalOrder: "Total order quantity",
        totalDuration: "Charging duration",
        totalRatio: "Total utilization rate",
        totalUtil: "Total Utilization",
        totalService: "Paid in service fee(yuan)",
        totalElec: "Paid in electricity charge(yuan)",
        totalDelay: "Paid in delay fee(yuan)",
        totalChargeSharp: "Total charge during sharp period(kWh)",
        totalChargePeak: "Total charge during peak period(kWh)",
        totalChargeFlat: "Total charge during flat period(kWh)",
        totalChargeValley: "Total charge during valley period(kWh)",
        moreBtn: "See more rankings",
        staName: "Site Name",
        oprName: "Operator",
        mchName: "Merchant",
        percentage: "Proportion",
        staNum: "Total number of charging stations",
    },
    //单站点分析
    siteAnalysis: {
        siteInfo: "Site basic information",
        siteAnalysis: "Site analysis",
        pileNum: "Number of Charge Points",
        gunCount: "Number of charging guns",
        totalTransAmount: "Total amount received",
        totalPower: "Total charge(kWh)",
        avgCharging: "Average charge duration(minute)",
        avgGunChargeMinutes: "Average charging time of single gun (min)",
        totalChargingTimes: "Charging order quantity",
        usageRate: "Usage rate",
        utilRate: "Util rate",
        staName: "Site Name",
        totalAmount: "Total amount receivable",
        totalDiscount: "Total discount",
        totalChargingHours: "Total charging time",
        // totalChargingMinutes: "Total charging time",
        totalServiceAmount: "Service fee receivable",
        totalAmountDiscount: "Total discount",
        totalTransServiceAmount: "Paid in service fee",
        totalSharpPower: "Sharp period charge(kWh)",
        oprName: "Operator",
        merchantName: "Merchant",
        totalElecAmount: "Electricity charges receivable",
        totalServiceDiscount: "Service fee discount",
        totalTransElecAmount: "Paid in electricity charge",
        totalPeakPower: "Peak period charge(kWh)",
        totalDelayAmount: "Delay fee receivable",
        totalChargeDiscount: "Electricity discount",
        totalTransDelayAmount: "Paid in delay fee",
        totalFlatPower: "Flat period charge(kWh)",
        totalValleyPower: "Valley period charge(kWh)",
        time: "Statistical time",
        userName: "User name",
        accountPkId: "Account No",
        phoneNo: "phone",
        totalDelayDiscount: "Discount of delay fee (yuan)",
        totalChargingMinutes: "Charging duration (min)",
        totalOrderTimes: "Charging order quantity (pcs.)",
        totalOrderSecond: "Charging times",
        entName: "Enterprise name",
        merchantTypeDesc: "Card ownership",
        accountPkIdCard: "Card user number",
        cardPhysicalNumber: "Card No",
        contactName: "contacts",
        contactPhoneNo: "contact number",
        ranking: "ranking",
        userInfo: "Basic user information",
        userUseAnalysis: "User usage analysis",
        siteInfoData: "Site info",
        siteOprData: "Site operation",
        staPower: "total power",
    },
    // 使用分析
    useAnalysis: {
        totalPower: "Total charge",
        totalPower2: "Total charge(kWh)",
        sharpPower: "Sharp period charge(kWh)",
        peakPower: "Peak period charge(kWh)",
        flatPower: "Flat period charge(kWh)",
        valleyPower: "Valley period charge(kWh)",
        totalChargingTimes: "Charging order quantity",
        totalChargingSeconds: "Total charging time (hours)",
        avgChargingSeconds: "Average charging time",
        totalUserNum: "Number of users(person)",
        chargingUseRatio: "Use ratio(%)",
        chargingUsageRate: "Usage rate(%)",
        eleAnalysis: "Charging capacity analysis",
        orderAnalysis: "Charging order quantity analysis",
        timeAnalysis: "Average charging time",
        activeUserAnalysis: "Active user analysis",
        userAnalysis: "User growth analysis",
        useRatioAnalysis: "Charging usage/utilization analysis",
        usageRateAnalysis: "Charging utilization analysis",
        avgChargingRadio: "Average charging time loop ratio",
        avgChargingBasis: "Year on year average charging duration",
        totalChargingTimesRadio: "Charge order volume month on month",
        totalChargingTimesBasis: "Year on year charging orders",
        orderTypes: "Order quantity of each type of charging",
        orderTypesProportion: "Proportion of charging orders of various types(%)",
        personnelOrderVolume: "Individual order quantity",
        enterpriseOrderVolume: "Enterprise order quantity",
        noRealNameCardVolume: "Order quantity of non real name card",
        personnelOrderVolumeRadio: "Individual order volume month on month",
        enterpriseOrderVolumeRadio: "Chain comparison of enterprise order volume",
        noRealNameCardVolumeRadio: "Non real name card order volume month on month",
        personnelOrderVolumeBasis: "Year on year individual order volume",
        enterpriseOrderVolumeBasis: "Year on year order volume of enterprises",
        noRealNameCardVolumeBasis: "Year on year order volume of non real name card",
        totalOrder: "Total order quantity",
        personnel: "Individual users",
        enterprise: "Enterprise users",
        noRealNameCard: "Non real name card user",
        totalPowerRadio: "Total charge Ring ratio",
        totalPowerBasis: "Year on year total charging",
        sharpPowerName: "Sharp period",
        peakPowerName: "Peak period",
        flatPowerName: "Flat period",
        valleyPowerName: "Valley period",
        sharpPowerRadio: "Sharp period Ring ratio",
        peakPowerRadio: "Peak period Ring ratio",
        flatPowerRadio: "Flat period Ring ratio",
        valleyPowerRadio: "Valley period Ring ratio",
        sharpPowerBasis: "Year on year sharp period",
        peakPowerBasis: "Year on year peak period",
        flatPowerBasis: "Year on year flat period",
        valleyPowerBasis: "Year on year valley period",
        timeCharging: "Charging amount in each period",
        timeChargingProportion: "Percentage of charging capacity in each period",
        userNum: "Number of users",
        userNumRadio: "Number of users Ring ratio",
        userNumBasis: "Year on year number of users",
        activeUserNume: "Number of active people",
        activeUserNumRadio: "Number of active people Ring ratio",
        activeUserNumBasis: "Year on year active population",
        activeUserRadio: "Number of people",
        activeUserBasis: "Number of people year-on-year",
        activeUserReqNum: "User growth",
        activeUserReqNumRadio: "User growth Ring ratio",
        activeUserReqNumBasis: "User growth year-on-year",
        money: "RMB",
        chargeCapacity: "charge capacity(kWh)",
        number: "number",
        userNumber: "numbers",
    },
    // 设备档案
    reportFile: {
        deviceArchivePkId: "File ID",
        deviceTypeName: "Equipment type",
        manufacturerName: "Manufacturer",
        deviceModelName: "Equipment model",
        deviceModelRatedPower: "Rated power",
        deviceModelChargeStandardName: "Equipment standards",
        archiveCode: "Report No",
        feelerMechanismName: "Testing agency",
        archiveCreateDate: "Report generation date",
        attachmentRecordPkId: "Type test report",
        entryDate: "Entry date",
        deviceRatedPower: "Power range(kW)",
        query: "Click to view",
    },
    // 建设分析
    constructionAnalysis: {
        totalMchNum: "Merchant",
        totalStaNum: "Charging station",
        totalPileNum: "Charging pile",
        totalGunNum: "Charging gun",
        totalPower: "Total power(kW)",
        totalDcPileNum: "DC pile",
        totalDcGunNum: "DC gun",
        totalDcPower: "DC pile power(kW)",
        totalAcPileNum: "AC pile",
        totalAcGunNum: "AC gun",
        totalAcPower: "AC pile power(kW)",
        stationAnalysis: "Analysis of charging station construction",
        pileAnalysis: "Analysis of charging pile construction",
        gunAnalysis: "Analysis of charging gun construction",
        powerAnalysis: "Power construction analysis",
        station: "Original charging station",
        addStation: "New charging station",
        staMomRatio: "New link ratio of charging station",
        staYoyRatio: "Year on year increase of charging stations",
        addMomRatio: "Newly-added month-on-month",
        addYoyRatio: "Year-on-year increase",
        totalMultipleDCPileNum: "Split DC pile",
        totalMultipleDCGunNum: "Split DC Gun",
        totalMultipleDCPower: "Split DC Pile Power",
        pile: {
            dcTitle: "Analysis of DC pile construction",
            dcMomRatio: "New ring ratio of DC pile",
            dcYoyRatio: "Year on year increase of DC pile",
            dcLineAddName: "New DC pile",
            dcLineName: "Original DC pile",
            acTitle: "Analysis of AC pile construction",
            acMomRatio: "New link ratio of AC pile",
            acYoyRatio: "Year on year increase of AC pile",
            acLineAddName: "New AC pile",
            acLineName: "Original AC pile",
        },
        gun: {
            dcTitle: "Analysis of DC gun construction",
            dcMomRatio: "New loop ratio of DC gun",
            dcYoyRatio: "Year on year increase of DC gun",
            dcLineAddName: "New DC gun",
            dcLineName: "Original DC gun",
            acTitle: "Analysis of AC gun construction",
            acMomRatio: "New link ratio of AC gun",
            acYoyRatio: "Year on year increase of AC gun",
            acLineAddName: "New AC gun",
            acLineName: "Original AC gun",
        },
        power: {
            dcTitle: "DC power construction analysis",
            dcMomRatio: "New loop ratio of DC power",
            dcYoyRatio: "Year on year increase of DC power",
            dcLineAddName: "New DC power",
            dcLineName: "Original DC power",
            acTitle: "Analysis of AC power construction",
            acMomRatio: "Increased link ratio of AC power",
            acYoyRatio: "Year on year increase of AC power",
            acLineAddName: "New AC power",
            acLineName: "Original AC power",
        },
    },
    //建设排名
    constructionRanking: {
        tabIndex: "ranking",
        pileTab: "Ranking of charging pile construction",
        gunTab: "Ranking of charging gun construction",
        powerTab: "Rated power ranking",
        pileNum: "Charge pile",
        gunNum: "Charge gun",
        powerNum: "Rated power (kW)",
        totalStaNum: "Charging station",
        totalPileNum: "Charging pile",
        totalAcPileNum: "AC pile",
        totalDcPileNum: "DC pile",
        totalGunNum: "Charging gun",
        totalAcGunNum: "AC gun",
        totalDcGunNum: "DC gun",
        totalPower: "Total rated power (kW)",
    },
    // 非实名卡分析
    offcardAnalysis: {
        tab0: "Total revenue",
        tab1: "Charge by swiping card",
        tab2: "Plug and charge",
        tab3: "Password charging",
        chargeNum: "Charging times",
        totalCardNum: "Offline card",
        totalChargeElect: "Total charge(kWh)",
        totalChargeTime: "Total charge duration",
        totalChargeNum: "Total number of charges",
        avgChargeElect: "Average charge(kWh)",
        avgChargeTime: "Average charge duration",
        avgChargeNum: "Average charging times",
        offlineCharging: "Offline charging capacity(kWh)",
        userTypeDl: "Percentage of charging capacity of each user type(%)",
        timeType: "Charging amount in each period(kWh)",
        cardCharge: "Charge by swiping card",
        plugCharge: "Plug and charge",
        passwordCharge: "Password charging",
        cardChargeRation: "Ring ratio of card charging",
        plugChargeRation: "Plug and Charge Ring Ratio",
        passwordChargeRation: "Ring ratio of password charging",
        cardChargeBasis: "Year on year charge by swiping card",
        plugChargeBasis: "Plug and play year-on-year",
        passwordChargeBasis: "Year on year password charging",
        userTypeTime: "Percentage of charging duration by user type(%)",
        chargeNumRation: "Cycle ratio of charging times",
        chargeNumBasis: "Year on year charging times",
        userTypeChargeNum: "Percentage of charging times by user type(%)",
        totalTransAmount: "Total amount",
        totalTransSeviceAmount: "service charge",
        totalTransElecAmount: "electricity fees",
        timeUserChargeProportion: "Percentage of charging capacity in each period",
    },
    // 用户分析
    userUseAnalysis: {
        totalPower: "Total charge(kWh)",
        totalOrderNum: "Total charging order quantity",
        totalChargingSeconds: "Total charge duration",
        totalChargingNum: "Total number of charges",
        activeNum: "Number of active people",
        avgPower: "Average charge(kWh)",
        avgOrderNum: "Average charging order",
        avgChargingSeconds: "Average charge duration",
        avgChargingNum: "Average charging times",
        useNum: "Number of users",
        userNum: "Total users",
        personnel: "Individual users",
        enterprise: "Enterprise users",
        noRealNameCard: "Non real name card user",
        personnelRadio: "Link ratio of individual users",
        enterpriseRadio: "Link ratio of enterprise users",
        noRealNameCardRadio: "Link ratio of non real name card users",
        personnelBasis: "Year on year individual users",
        enterpriseBasis: "Year on year enterprise users",
        noRealNameCardBasis: "Year on year comparison of non real name card users",
        totalUserCharge: "Total user charge(kWh)",
        totalTypeUserCharge: "Percentage of charging capacity of each user type(%)",
        timeUserCharge: "Charging amount in each period(kWh)",
        timeUserChargeProportion: "Percentage of charging capacity in each period",
        totalAverageTime: "Total average charging time",
        typeChargeDuration: "Percentage of charging duration by user type(%)",
        chargeNumber: "Charging times",
        chargeNumberRadio: "Cycle ratio of charging times",
        chargeNumberBasis: "Year on year charging times",
        typeChargeDurationNumber: "Percentage of charging times by user type(%)",
        activeUsers: "Active Users",
        activeUsersRadio: "Link ratio of active users",
        activeUsersBasis: "Year on year active users",
        typeChargeactiveUsers: "Proportion of active users(%)",
        useNumber: "Number of users",
        useNumberRadio: "Link ratio of number of users",
        useNumberBasis: "Year on year number of users",
        typeChargeUseNumber: "Proportion of users by type(%)",
        avgChargingRadio: "Cycle ratio of average charging time",
        avgChargingBasis: "Year-on-year average charging time",
    },
    // 用户分析 - 用户排名
    userAnalysisRanking: {
        userType: "customer type",
        incomeType: "Ranking Type",
        more: "See more rankings",
        userAccount: "individual account",
        entAccount: "Corporate accounts",
        cardAccount: "Non real name card user account",
        totalAmount: "Total revenue",
        serverAmount: "Service fee revenue",
        eleAmount: "Electricity revenue",
        delayAmount: "Revenue from pile cost",
        chargeQuantity: "Charging capacity",
        chargeTimes: "Charging times",
        chargeDuration: "Charging duration",
        userNum: "Total users",
        typeUserNum1: "Individual users",
        typeUserNum2: "Enterprise users",
        typeUserNum3: "Number of non real name card users",
        pageTitleUserType1: "Personal user ranking",
        pageTitleUserType2: "Enterprise user ranking",
        pageTitleUserType3: "Ranking of non real name card users",
        index: "ranking",
        userName: "User Name",
        phoneNo: "phone",
        enterpriseName: "Enterprise name",
        cardPhysicalNumber: "Electric card membership number",
        cardSerialNumber: "Serial number of electric card",
        merchantType: "Card ownership",
        contactName: "contacts",
        contactPhoneNo: "contact number",
        amount1: {
            totalAmount: "Total amount receivable",
            discountAmount: "Total discount",
            actualAmount: "Total amount received",
        },
        amount2: {
            totalAmount: "Service fee receivable",
            discountAmount: "Service fee discount",
            actualAmount: "Paid in service fee",
        },
        amount3: {
            totalAmount: "Electric charge receivable",
            discountAmount: "Preferential tariff ",
            actualAmount: "Paid in electricity charge",
        },
        amount4: {
            totalAmount: "Delay fee receivable",
            discountAmount: "Discount for delay fee",
            actualAmount: "Paid in delay fee",
        },
        dataValue5: "Charging capacity (kWh)",
        dataValue6: "Charging times",
        dataValue7: "Charging duration(hours)",
    },
    qrderlyCharging: {
        powerStrategy: "Power sharing strategy",
        firstServedStrategy: "First come, first served strategy",
        bindSta: "Associated Sites",
        qrderlyInfo: "policy information",
        tipsTitle: "Strategy Description:",
        tipsList: [
            "1. The power sharing strategy will only be triggered when the total output power of the charging station is greater than the configured power",
            "2. If the current output power of the site is higher than the set maximum output power, the system will automatically calculate the percentage of the excess. Each charging gun that is being started will be reduced by the current percentage of excess power",
            "3. After triggering the power sharing strategy, when encountering charging completion, new start charging, and 5-minute timed tasks, the output power is detected to be higher or lower than the configured value",
            "4. After the policy is activated, it is determined whether the output power is lower than the configured value. If the current output power of the site is lower than the set maximum output power, the system will automatically calculate the percentage of the lower part, and each charging gun that is being started will be adjusted up by the percentage of the current power below",
            "5. If the current power plus the increased power is greater than the rated power of the pile, the pile will not participate in this power increase",
            "6. Exceeding percentage=Exceeding power/configured maximum rated power. For example, if the rated power of a site is 100Kw and the configured percentage is 90%, the configured maximum output power of the site is 100 * 90%=90Kw. If the current site power is 120Kw, the exceeding percentage=(120 90)/90=33.34%, rounded to two decimal places",
            "7. Below percentage=below power/configured maximum rated power. For example, if the rated power of a site is 100Kw and the configured percentage is 90%, then the configured maximum output power of the site is 100 * 90%=90Kw. If the current site power is 80Kw, then below percentage=(90-80)/90=1.12%, rounded to two decimal places,",
        ],
        accurateTipsList: [
            "1. The power sharing strategy will only be triggered when the total output power of the charging station is greater than the configured power",
            "2. If the current output power of the site exceeds the set maximum output power, the system will automatically calculate the percentage of the excess and first reduce the output power of all charging AC guns by the percentage of the excess current power",
            "3. Further reduce the output power of DC piles with SOC ≥ 80% and SOC<80%",
            "4. If (SOC ≥ 80%) ＞ (SOC ＜ 80%), DC piles with SOC ≥ 80% reduce the remaining power reduction by 2/3, and DC piles with SOC ＜ 80% reduce the remaining power reduction by 1/3",
            "5. If (SOC ≥ 80%)=(SOC<80%), DC piles with SOC ≥ 80% reduce the remaining power reduction by 1/2, and DC piles with SOC<80% reduce the remaining power reduction by 1/2",
            "6. If (SOC ≥ 80%)<(SOC<80%), DC piles with SOC ≥ 80% reduce the remaining power reduction by 1/3, and DC piles with SOC<80% reduce the remaining power reduction by 2/3",
            "7. After triggering the power sharing strategy, when encountering charging completion, new start charging, and 5-minute timed tasks, the output power is detected to be higher or lower than the configured value",
            "8. After the policy is activated, it is determined whether the output power is lower than the configured value. If the current output power of the site is lower than the set maximum output power, the system will automatically calculate the percentage of the lower part, and each charging gun that is being started will be adjusted up by the percentage of the current power below",
            "9. If the current power plus the increased power is greater than the rated power of the pile, the pile will not participate in this power increase",
            "10. Exceeding percentage=Exceeding power/configured maximum rated power. For example, if the rated power of a site is 100Kw and the configured percentage is 90%, the configured maximum output power of the site is 100 * 90%=90Kw. If the current site power is 120Kw, the exceeding percentage=(120 90)/90=33.34%, rounded to two decimal places",
            "11. Below percentage=below power/configured maximum rated power. For example, if the rated power of a site is 100Kw and the configured percentage is 90%, then the configured maximum output power of the site is 100 * 90%=90Kw. If the current site power is 80Kw, then below percentage=(90-80)/90=1.12%, rounded to two decimal places,",
        ],
        firstComeTipsList: [
            "1. The first come, first charge strategy will only be triggered when the total output power of the charging station is greater than the configured power",
            "2. When implementing the first come, first charge strategy, divide the DC piles and AC piles in the station, and sort them by device type and charging start time",
            "3. By default, the number of charging piles (≥ 3) will be sorted by three equal parts in time. If three equal parts are not possible, 1 will be added from the back to the front based on the remaining piles",
            "4. After the system calculates the number of charging stations to be allocated for each time sequence, they are sorted in positive order according to the charging start time and included in each time sequence. The first time sequence is the station with the earliest start and longest charging time. The second time sequence takes second place, and the third time sequence is the station with the latest start and shortest charging time",
            "5. If there are piles with the same charging start time (in seconds as the minimum timing unit) that cannot be assigned to the same time sequence, they will be postponed in the positive order of the station numbers",
            "6. After the time sorting is completed, the stakes in the first sequence are reduced to 75% of the current output power, the stakes in the second sequence are reduced to 50% of the current output power, and the stakes in the third sequence are reduced to 25% of the current output power. The first come, first charge strategy is executed separately",
            "7. After triggering the first come, first charge strategy, when encountering charging completion, new start charging, and 5-minute timed tasks, the output power is detected to be higher or lower than the configured value",
            "8. After the strategy is activated, it is determined whether the output power is lower than the configured value. If it is lower than the configured value, the percentage of the current power lower than the configured maximum output power needs to be calculated, and all charging stations that are charging need to increase their output power according to this proportion. If there are stations with increased power exceeding the rated power of the station itself, the power increase strategy will not be executed",
            "9. For example, if the rated power of the site is 100Kw and the configuration percentage is 90%, the maximum output power configured for the site is 100 * 90%=90Kw. If the current site power is 80Kw, then it is lower than the percentage=(90-80)/90=1.12%, rounded to two decimal places",
            "10. Increase the current output power of all charging piles below the percentage (calculated as 11.12% in the example). If there are piles with increased power exceeding the rated power of the pile itself, the power increase strategy will not be executed,",
        ],
        strategyName: "Policy Name",
        strategyType: "Policy Type",
        strategyValue: "Maximum output power",
        modifyTime: "Operation time",
        modifyUserName: "Operator",
        countUse: "Number of sites used",
        delConfirm: "Are you sure you want to delete this charging policy?",
        strategyNamePl: "Please enter a policy name",
        strategyTypePl: "Please select a policy",
        strategyValuePl: "Please enter a percentage",
        strategyValuePl2: "percentage",
        strategyValueTips: "Note: The set percentage is the percentage of the rated power of the station.",
        useSta: "Scope of use",
        staAddStrategy: "Add/replace the orderly charging strategy",
        staUnbindStrategy: "Unbinding",
        staUnbindStrategyConfirm: "Are you sure to unbind this policy?",
        strategyTypeChangeTips: "Reminder: it will take effect immediately after submission, and the site will follow the new orderly charging strategy.",
        strategyTypeChangeTitle: "Replacement strategy",
        staMaxOutputPower: "Maximum output power",
        staGroupStatus: "packet states",
        configBtn: "Configure grouping",
        open: "open",
        close: "close",
    },
    // 有序充电策略分组
    chargingStrategyGroups: {
        add: "Add Group",
        sitePower: "Station rated power",
        maxPower: "The limit for sequential charging is",
        siteMaxPowerd: "The maximum allowable output power of the site is",
        totalPower: "The total rated power of the group is",
        configPower: "The remaining configurable power is",
        configPile: "The remaining number of configurable piles is",
        groupName: "Group Name",
        groupTotalPower: "Group rated power (KW)",
        limitRatioTable: "The maximum output power within the group shall not exceed the percentage of rated power within the group (%)",
        limitRatio: "Limit ratio",
        groupMaxOutputPower: "Group maximum output power (KW)",
        groupPileNum: "Associated pile",
        groupStatus: "packet states",
        modifyTime: "TIME",
        modifyUserName: "operator",
        pilePkIdList: "Associated pile",
        pilePkIdListTips: "Configured power",
        pilePkIdListError: "The configurable power has been exceeded, please check",
        pilePkIdListPl: "Please select a pile",
        addTitle: "Add grouping strategy",
        updataTitle: "Modify Group Policy",
        detailsTitle: "Group Policy Details",
        selectPilePl: "Please enter the pile name/number/type (AC/DC)",
        selectNo: "Unselected piles",
        selectYes: "Selected piles",
    },
    reservationRate: {
        freeMinutes: "Free duration",
        minute: "minute",
        minuteUnit: "Rate (per minute/yuan)",
        semih: "Semih",
        semihUnit: "Rate (half an hour/yuan)",
        slotFlag: "bucket type",
        timingType: "Charge Type",
        acRate: "Reservation rate of AC pile",
        dcRate: "Reservation rate of DC pile",
        replaceTime: "Association time",
        operatorName: "Operator",
        allCancle: "Batch disassociation",
        cancleTip: "Are you sure to cancel the association?",
        cancleAllTip: "Are you sure to batch unassociate the selected sites?",
    },
    // 预约充电配置
    appointmentChargeConfig: {
        tabReservation: "Appointment Charging",
        tabOrderly: "Orderly charging",
        enable: "Appointment charging",
        maxDuration: "Appointment Maximum time",
        minDuration: "Appointment Minimum duration",
        maxDurationPl: "Please select",
        minDurationPl: "Please select",
        timeoutDuration: "Maximum timeout duration",
        enableTips1: "After shutdown, all sites do not support scheduled charging",
        enableTips2: "When enabled, only sites configured with a reserved charging rate support reserved charging",
        maxDurationTips: "The maximum time a user can reserve for a single charge",
        minDurationTips: "The shortest time that a user can reserve a single charge",
        timeoutDurationTips1: "The timeout period between the end time of the user's appointment and the start time of charging is long, which can be tolerated by the operator,",
        timeoutDurationTips2: "After setting, only subsequent orders will become effective, and generated orders will not become effective; The default is 0,",
        timeoutDurationTips3: "That is, when the current time is the end time of the user's appointment, it is immediately processed as an appointment timeout;",
        openSta: "Site opened",
        reservationName: "Appointment occupancy rate name",
    },
    // 预约订单
    reserveChargingOrder: {
        durationRange: "Appointment duration",
        stopReason: "End Reason",
        startTime: "Appointment start time",
        handle: "handling",
        reservationOrderNo: "Reservation No",
        chargingTime: "Appointment of charging time",
        frozenAmount: "Frozen amount (yuan)",
        stopTime: "Appointment end time",
        actualDuration: "Actual appointment duration",
        transactionAmount: "Paid-in amount (yuan)",
        reasonType: "Reason for appeal",
        picture: "Site photos",
        auditResult: "Processing results",
        auditMind: "Handling opinions",
        reasonTitle: "Appointment Form Grievance Handling",
        auditMindPl: "Please input processing comments",
        auditResultPl: "Please select a processing result",
        totalOrder: "Total reservation",
        confirm: "After agreeing to the user's complaint, the frozen amount or paid amount of the charging reservation will be fully returned to the user's account. Do you want to continue?",
        reserveOrderStatus: "order status",
        reserveOrderTimeType: "Duration appointment form",
    },
    // 预约订单详情
    reserveChargingOrderOrder: {
        info: "Appointment Order Information",
        timingType1: "minute",
        timingType2: "Semih.",
        timingType: "Charge Type",
        freeMinutes: "Free duration (minutes)",
        timeoutDuration: "Operators can tolerate timeout duration(minutes)",
        total: "Total price (yuan)：",
        rate: "rate",
        slotFlag: "bucket type",
        time: "time slot",
        duration: "Duration (minutes)",
        feeInfo: "Billing information",
        orderInfo: "Order Information",
        orderStatus: "Order Status",
        chargingOrderNo: "Charging order number",
        life: "life cycle",
        operatingUserName: "Operator",
        occurTime: "Operation time",
        stopReason: "cause",
        imgList: "Auxiliary materials",
        refOrderNo: "Refund Order Number",
    },
    // 运营商日结单
    operatorDailyStatement: {
        tab1: "Daily statement",
        tab2: "Daily statement details",
        tab3: "Daily statement sharing details",
        settleOrderNo: "Order No",
        settlementOrderStatus: "Daily statement status",
        shareOrderStatus: "Ledger status",
        settlementDate: "Settlement date",
        createTime: "creation date",
        totalOrderCount: "Order Quantity",
        totalChargeElect: "Charging capacity",
        totalTransactionAmount: "Total paid amount",
        totalTransactionServiceAmount: "Paid service fee",
        totalTransactionChargeAmount: "Paid electricity bill",
        totalServiceProviderIncome: "Total share amount",
        totalOprIncome: "Operator revenue",
        merchantPkId: "Name of dividing party",
        settlementRule: "Sharing method",
        totalMerchantIncome: "Merchant Revenue Amount",
    },
    // 运营商分成单
    operatorSplitOrder: {
        tab1: "Split order",
        tab2: "Split Order Details",
        tab3: "Split Order Details",
        currentServiceProviderIncome: "Actual sharing amount in this period",
        currentRecordedAmount: "Current accounting amount",
        accumulatedRecordedAmount: "Accumulated bookkeeping amount",
        shareOrderStatus: "Sharing states",
        serviceProviderIncome: "Divider's total share",
        chargeOrderNo: "Charging order number",
        outOrderNo: "Sharing Order Number",
        outOrderNoDetailId: "Sharing Details Order Number",
        rechargeOrderNo: "Recharge order number",
        transactionId: "WeChat Pay order number",
        failReason: "Reason for failure in sharing",
        finishTime: "Split completion time",
        detailServiceProviderIncome: "Divider's share amount",
    },
    // 记帐金额管理
    bookkeepingAmount: {
        tab1: "accounting management",
        tab2: "Accounting details",
        btnName: "Positive",
        positiveStatus: "Positive state",
        selectPositivePl: "Please select the data to be reversed",
        selectPositiveConfirm: "Confirm positive",
        clearPositive: "Cancel positive",
        positiveYes: "Yes",
        positiveNo: "No",
        settlementDate: "Posting Date",
        positiveTime: "Positive date",
        recordedAmount: "Bookkeeping amount",
        operator: "operator",
        attachmentPkId: "annex",
        positiveMoney: "Posting amount",
        paymentNetFileUrl: "Upload attachments",
        paymentNetFileUrlPl: "Please upload the attachment",
        operatorPl: "Please enter the operator",
    },
    // 运营商注册
    oprRegister: {
        oprRegisterTitle: "Operator Registration",
        clearGoBack: "Cancel and return",
        roleName: "Senior operator",
    },
    // 忘记密码
    forgetPassword: {
        title: "forgot password",
        tips: "Only the main account can retrieve the password, please use the main account user management function to reset the password for sub accounts to retrieve the password",
        step1: "validate",
        step2: "Reset successful",
        resetBtn: "Reset",
        goLogin: "Go log in",
    },
    // 到期提醒配置
    expirationReminder: {
        enable: "Expiration reminder",
        days: "Reminder Time",
        daysPrepend: "Reminder",
        daysAppend: "day",
        addRow: "Add Reminder",
        customerType1: "Enterprise users",
        customerType2: "Authorized merchants",
        customerType3: "Interconnection customers",
        customerType4: "Third party customers",
        customerType5: "Interface Customers",
        errorTips: "There are duplicate reminders, please check!",
        enablePl: "Please select the configuration you want to enable",
    },
    //  余额提醒
    balanceReminderConfig: {
        tabEnt: "Enterprise and third-party users",
        tabUser: "Individual users",
        tabCarUser: "Non real name card users",
        entName: "Enterprise users",
        thirdPartyName: "Third party users",
        templateName: "Policy name",
        triggerValue: "Reminder amount",
        alarmTimes1: "Reminder time one",
        alarmTimes2: "Reminder time two",
        alarmTimes3: "Reminder time three",
        notice: "Notification method",
        entUserSum: "Enterprise User Association",
        thirdUserSum: "Third party user association",
        weChat: "official account",
        message: "text message",
        modifyRecord: "Modify Record",
        configInfo: "configuration information",
        amountMin: "Charging, balance below",
        amountInfo: "Send notifications",
        notificationMethod: "Notification method",
        weChatNotification: "Official account notification",
        smsNotification: "SMS notification",
        alarmTimesTips: "Select at least one reminder time",
        allSelect: "Batch select",
        allCancel: "Batch cancel",
        cancel: "disassociation",
        phoneTips: "Please enter your phone number, separated by ','",
        messageUser: "SMS notification personnel",
        weChatUser: "Notify personnel on WeChat official account",
        cancelConfirm: "Are you sure to cancel the association in bulk?",
        noDataTips: "Please select data",
        weChatTips: "Please enter the mobile phone number of the person notified by the official account",
        phoneError: "Mobile number error, please check",
        messageTips: "Please enter the phone number of the SMS notification personnel",
        updataTime: "Modification time",
        updataUser: "Modified By",
        deleteTip: "The current policy has associated users and cannot be deleted at the moment",
        canDeleteTip: "Are you sure to delete the balance reminder policy?",
    },
    // 电池检测
    batteryTest: {
        orderNo: "Charging order number",
        acquired: "User Status",
        userName: "User Name",
        userPhone: "User phone",
        detailsBtn: "Report Details",
        acquiredStatus: "User Status",
        carBatteryInfo: "Vehicle and charging information",
        carInfo: "Vehicle information",
        chargeInfo: "Charging information",
        carNo: "License plate number",
        libMaf: "Battery manufacturer",
        brand: "Vehicle brand",
        libType: "Type",
        model: "Model",
        libBday: "Battery production date",
        stdQ: "Rated capacity of the vehicle",
        stdV: "Rated total voltage of the vehicle",
        chaE: "Current charging amount",
        startTime: "Charging start time",
        chaTime: "Duration of this charging",
        endTime: "Charging end time",
        dsoc: "SOC growth",
        carbon: "Saving carbon emissions this time",
        batteryAnalysis: "Battery Health Analysis",
        socSta: "SOC status",
        trateMax: "Maximum temperature rise rate",
        cellVSta: "Individual voltage status",
        tempAve: "Average charging temperature",
        tsta: "Temperature state",
        socStart: "Starting SOC this time",
        rsta: "Insulation state",
        socEnd: "End of this SOC",
        conSta: "Power link status",
        powerAve: "Average power",
        healthScore: "Health score",
        score: "",
    },
    //运营概览
    operationalOverview: {
        incomeTotal: "Total income",
        incomeTotalTips: "Statistical payment time",
        totalChargeTransAmount: "Charging income",
        totalReserveAmount: "Appointment income",
        totalMemberAmount: "Member purchase income",
        orderTotal: "Charging order statistics",
        orderTotalTips: "Calculate the start charging time",
        totalOrder: "Total order",
        totalChargingOrder: "Charging orders",
        totalFinishedChargingOrder: "Completion order",
        totalAbnormalOrder: "Abnormal orders",
        totalPaidOrder: "Paid orders",
        totalUnPaidOrder: "Unpaid orders",
        totalReadyOrder: "Prepare charging order",
        rateTotal: "Rate statistics",
        totalFee: "Total rate",
        totalNormalFee: "Site Rate",
        totalEntFee: "Enterprise rate",
        totalInterFlowFee: "Interconnection rate",
        activityTitle: "Marketing activities",
        totalActive: "Activation",
        totalNoActive: "Activity not started",
        totalClosed: "Activity ended",
        totalDisAble: "Deactivate Activity",
        totalRechargeGift: "Recharge gift",
        totalRegisterGift: "Registration Gifts",
        totalChargeGift: "Charging gift",
        totalPriceDiscount: "Event discounts",
        totalInvitationGift: "Inviting gifts",
        mallTitle: "Mall Management",
        mallCommodity: "Product statistics",
        mallOrder: "Shopping Mall Order Statistics",
        mallCommodityTotal: "Total product",
        mallOrderTotal: "Total order",
        totalFullStockCommodity: "Goods with sufficient inventory",
        totalLowStockCommodity: "Low inventory items",
        totalOutOfStockCommodity: "Out of stock items",
        totalConsignmentOrder: "back-order",
        totalToBeReceivedOrder: "Orders to be received",
        totalCompletedOrder: "Completed order",
        integralTitle: "Points Activity",
        totalAll: "Charging activities",
        integralTotalActive: "Active",
        integralTotalNoActive: "Not started",
        integralTotalClosed: "Ended",
        msgTitle: "message center",
        totalMessage: "Total member information",
        totalNoReplyMessage: "No reply message",
        totalReplyMessage: "Reply message",
    },
    // 地锁
    floorLock: {
        floorLockNumber: "Floor lock number",
        lockStatus: "jacking condition",
        floorLockOnLine: "Online status",
        serialNumber: "Affiliated pile number",
        carDetected: "Pull into",
        parkNo: "Parking space",
        deviceType: "Floor lock type",
        floorLockProtocol: "agreement",
        remark: "remark",
    },
    // 商户概览
    mchOverview: {
        revenueTitle: "Use data",
        settlementInfo: "Settlement information",
        unsettledOrderNum: "Unsettled daily statement",
        notPaidDrawCashOrderNum: "Unpaid withdrawal note",
        undrawAmount: "Undrawn amount",
        inPayAmount: "Withdrawing amount",
        drawedAmount: "Withdrawn amount",
        serviceCharges: "Accumulated withdrawal fee",
        tosettledOrderNum: "Unsettled daily statement",
        totalChargingCapacity: "Total charging capacity (kWh)",
        onlineChargingCapacity: "Online charging capacity (kWh)",
        offlineChargingCapacity: "Offline charging capacity (kWh)",
        dividedInformation: "Divided information",
        mchActualIncome: "Merchant's actual income amount",
        operatorActualIncome: "Actual revenue amount of the operator",
        handingFeeAmount: "Handling fee amount",
        amountChangeData: "Non real name card amount change data",
        refundOrderNumber: "Number of refund orders to be reviewed",
        rechargeAmount: "Recharge amount (yuan)",
        refundAmount: "Refund amount (yuan)",
        invoiceInformation: "Invoice information",
        operatorNotInvoiced: "Number of operators not invoiced",
        operatorInvoiced: "Number of invoices issued by the operator",
        pendingReview: "Pending review",
        aggreed: "Agreed",
        rejected: "Rejected",
        invoiceFailed: "Invoice failed",
        invoicing: "In invoicing",
        shareOfTotalCharging: "Share of total charging capacity",
        notInvoicing: "Not invoiced",
        mchNotInvoiced: "Number of merchants not invoiced",
        mchInvoiced: "Number of invoices issued by merchants",
    },
    //站点管理-资产概览
    staAssetOverview: {
        staTitle: "Total number of charging stations",
        pileProportion: "Total proportion",
        gunProportion: "Total proportion",
        staProportion: "Total proportion",
        usingNum: "In use",
        repairNum: "under repair",
        constructionNum: "Construction",
        closeNum: "Close offline",
        msgTitle: "SMS statistics",
        residualNum: "SMS remaining",
        useNum: "Accumulated SMS usage",
        pileTitle: "Construction of charging stations",
        acNum: "AC pile",
        dcNum: "DC pile",
        onlineNum: "Go live",
        pileCloseNum: "Offline",
        powerTitle: "Total construction power",
        powerProportion: "Share of total power",
        powerDc: "DC power",
        powerAc: "AC power",
        simStatistics: "SIM statistics",
        totalSim: "Total number of SIM cards",
        simType1: "To be activated",
        simType2: "Activated",
        simType3: "Shutdown",
        simType4: "Testable",
        simType5: "inventory",
        simType6: "Pre closing account",
        simType7: "unknown",
        gunTitle: "Total charging gun",
        pileOnlineTitle: "Charging Station Online Status",
        dcGun: "DC Gun",
        acGun: "AC Gun",
        splitDcPile: "Split type DC pile",
        splitDcGun: "Split type DC gun",
        splitDcPower: "Split type DC pile power",
        goLiveNum: "Online Electric Pile",
        downLiveNum: "Offline Electric Pile",
    },
    startupFailOrder: {
        staOperationTypeDesc: "Operation type",
        staOperationMethodDesc: "Business mode",
        startModeDesc: "Start mode",
        username: "User nickname",
        phoneNo: "Phone number",
        chargeBeginTime: "Start charging time",
        stopReasonDesc: "Stop reason",
        queryStr: "order number/phone number",
        selectTime: "select start time",
        startupFailOrder: "start fail order",
    },
    msgManage: {
        msgSendRecord: "messgSendRecord",
        msgBuyRecord: "messgBuyRecord",
    },
    operationOverview: {
        equipmentStatistics: "Equipment statistics",
        totalStation: "Total charging stations(units)",
        totalGunNum: "Total number of charging guns",
        totalGun: "Total number of guns (pieces)",
        eventStatistics: "Event Statistics",
        alarmStatistics: "Alarm Statistics",
        todayEventNum: "Number of events today",
        recoveryStatus: "Recovery status",
        emergent: "emergent",
        important: "important",
        secondary: "secondary",
        commonAlarm: "General alarm",
        emergentAlarm: "Emergency alarm",
        seriousAlarm: "Serious alarm",
        todayAlarmNum: "Today's alarm count",
        allAlarmNum: "Total number of alarms",
        alarmStrategy: "Alarm strategy",
        strategyNum: "Total number of strategies",
        staAlarmRank: "Top 10 Site Alarm Times",
        unRecovered: "Not recovered",
        recovered: "Recovered",
        eventAmount: "event amount",
        alarmLevel: "alarm level",
    },
};
